export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
};

/** Activity tracking entity for canonical, deduped interactions */
export type Activity = BaseEntity & {
  __typename?: 'Activity';
  actorPersonId?: Maybe<Person>;
  canonicalActivityName?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dedupKey?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  participantsContactIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  participantsPersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  signalType?: Maybe<Scalars['String']['output']>;
  sourceEventType?: Maybe<Scalars['String']['output']>;
  sourceTool?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Long']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ActivityInput = {
  actorPersonId?: InputMaybe<Scalars['ID']['input']>;
  canonicalActivityName?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dedupKey?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  externalRefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  participantsContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  participantsPersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signalType?: InputMaybe<Scalars['String']['input']>;
  sourceEventType?: InputMaybe<Scalars['String']['input']>;
  sourceTool?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Long']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ActivityList query */
export type ActivityListResult = {
  __typename?: 'ActivityListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Activity>>>;
  /** Total number of Activity records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Outcome of addOrgChangeItems: the saved draft plus what happened to each submitted item, so merges and no-op drops are visible instead of silent. */
export type AddOrgChangeItemsResult = {
  __typename?: 'AddOrgChangeItemsResult';
  /** Items appended as new entries */
  added: Scalars['Int']['output'];
  /** The draft after the add */
  changeSet: OrgChangeSet;
  /** Items dropped because the requested value is already live */
  dropped: Scalars['Int']['output'];
  /** Items reconciled into an existing item on the same entity+field */
  merged: Scalars['Int']['output'];
  /** Items skipped because an admin dismissed the identical change within the suppression window (AGENT lane only; always 0 elsewhere) */
  suppressed: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** One row of the Actions queue — shared chrome plus the artifact it stands for */
export type AgentActionCard = {
  __typename?: 'AgentActionCard';
  /** The agent that produced this (a workflow's code for a headless run), or null when a person drafted it */
  agentCode?: Maybe<Scalars['String']['output']>;
  /** That agent's or workflow's display name as it was when it ran */
  agentName?: Maybe<Scalars['String']['output']>;
  /** The career path an agent drafted, when kind is CAREER_PATH — reviewed, edited and published (or discarded) on its own screen at reviewUrl */
  careerPath?: Maybe<AgentActionCareerPath>;
  /** The org change set, when kind is CHANGE_SET */
  changeSet?: Maybe<OrgChangeSet>;
  /** The session this came out of — a conversation to open with agentChat, or a workflow run's record. Null for a hand-drafted change set or a session that was somebody else's. */
  chatId?: Maybe<Scalars['ID']['output']>;
  /** The agent draft, for every other kind */
  draft?: Maybe<Agent_Draft>;
  /** Document id of the artifact — also this row's identity */
  id: Scalars['ID']['output'];
  /** CHANGE_SET, CAREER_PATH, or the kind of draft (BRIEFING) — decides which body is populated */
  kind: Scalars['String']['output'];
  /** How this came to exist: CHAT (a person talked an agent into it), WORKFLOW (a person ran a workflow now — see workflowCode), ROUTINE (a routine fired — see routineId; it ran as its owner), SYNC (the HRIS feed), or MANUAL (an admin drafted it by hand). In every case but SYNC, createdBy on the artifact is the person. Badge from this instead of re-deriving it from other fields. */
  origin: Scalars['String']['output'];
  /** Where the review button goes, when the artifact has its own screen; null for a draft that is read in the card itself */
  reviewUrl?: Maybe<Scalars['String']['output']>;
  /** The routine whose firing produced this — matches routineId in the routines list. Null for a conversation or a Run-now. */
  routineId?: Maybe<Scalars['ID']['output']>;
  /** The artifact's own status — DRAFT for a change set, OPEN for a draft */
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Last touched, epoch millis — what the queue is ordered by */
  updatedAt?: Maybe<Scalars['Long']['output']>;
  /** The workflow a headless run executed — matches a code in workflowLibrary. Null for a conversation. */
  workflowCode?: Maybe<Scalars['String']['output']>;
};

/** A draft career path on an Actions card */
export type AgentActionCareerPath = {
  __typename?: 'AgentActionCareerPath';
  /** Ids of the job family groups the career path is for */
  appliesTo?: Maybe<Array<Scalars['ID']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Its bare entity id, as the career path screens are keyed */
  entityId: Scalars['ID']['output'];
  /** Document id of the career framework */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** DRAFT while it is on the queue */
  status?: Maybe<Scalars['String']['output']>;
};

/** Which halves of the Actions queue to page. Origin is a different axis (how an artifact came to exist). */
export enum AgentActionCategory {
  /** Open org change sets, agent-drafted career paths and open briefings, merged newest first */
  All = 'ALL',
  /** Career paths an agent drafted that are still drafts — needs MANAGE_CAREER_FRAMEWORK */
  CareerPaths = 'CAREER_PATHS',
  /** Open org change sets only — every origin */
  ChangeSets = 'CHANGE_SETS'
}

/** Paginated result of an agentActions query */
export type AgentActionListResult = {
  __typename?: 'AgentActionListResult';
  /** Whether more actions exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<AgentActionCard>>;
  /** Total number of open actions visible to this caller */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One conversational agent as shown in the picker */
export type AgentChatAgent = {
  __typename?: 'AgentChatAgent';
  /** Avatar settings, stored and served verbatim — the FE generates the face from them. Null means seed it from code. */
  avatar?: Maybe<Scalars['JSON']['output']>;
  /** Stable code; pass to startAgentChat */
  code: Scalars['String']['output'];
  /** Set when the agent is listed but not usable yet — the user-facing reason ("Waits on a payroll integration"). Tag the card 'Coming soon' and disable starting a chat; startAgentChat refuses it with the same text. Null when the agent works today */
  comingSoon?: Maybe<Scalars['String']['output']>;
  /** The person who built a TENANT agent — its owner; null for PLATFORM */
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Text of the execute button for this agent; null for a chat-only agent (resultKind NONE), which has no button — its conversation is the product */
  executeLabel?: Maybe<Scalars['String']['output']>;
  /** Kind of artifact this agent produces (e.g. CHANGE_SET) */
  resultKind?: Maybe<Scalars['String']['output']>;
  /** PLATFORM for an out-of-the-box agent (read-only in the UI: no edit, no delete); TENANT for one authored in this workspace, whose document is in tenantAgents and whose author may edit it there */
  source: Scalars['String']['output'];
  /** The agent's own prompt chips: shown on the picker, and under any reply whose turn wrote no follow-ups of its own */
  suggestedPrompts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Codes of the workflows attached to this agent — the job the execute button runs. Empty for agents that only converse. */
  workflows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** One model a chat can be run on — an entry in the composer's picker */
export type AgentChatModel = {
  __typename?: 'AgentChatModel';
  /** The id to send back as sendAgentChatMessage's model argument */
  code: Scalars['String']['output'];
  /** True for the model a chat runs on when the user has not picked one. Preselect it; do not send it as an explicit choice */
  current: Scalars['Boolean']['output'];
  /** What to show in the picker, e.g. "GPT-4o" */
  label: Scalars['String']['output'];
  /** One line on what picking this trades — speed against depth. Written for the person choosing, so show it as-is */
  note?: Maybe<Scalars['String']['output']>;
};

/** One workflow as shown in the Workflows tab — a unit of work that can be run on its own (runWorkflow) or by the agent that attaches it */
export type AgentWorkflow = {
  __typename?: 'AgentWorkflow';
  /** Library group (ORG, HR, …) — contributed by the owning module */
  category: Scalars['String']['output'];
  /** Stable code; pass to runWorkflow */
  code: Scalars['String']['output'];
  /** Set when the workflow is listed but cannot run yet — the user-facing reason. Tag the card 'Coming soon' and disable Run now, routines and attaching it to an agent; runWorkflow and saveRoutine refuse it with the same text. Null when it runs today */
  comingSoon?: Maybe<Scalars['String']['output']>;
  /** Author's Person ref for a TENANT card; null for PLATFORM */
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Typed inputs, in declaration order: [{name, type, required, default, description}] — the Run-now form */
  inputs?: Maybe<Scalars['JSON']['output']>;
  /** True when a run's result is information kept as an Agent_Draft in Actions; false when it is a reviewable change in its own flow */
  producesBriefing: Scalars['Boolean']['output'];
  /** Permission a run needs; the library is already filtered by it */
  requiredPermission?: Maybe<Scalars['String']['output']>;
  /** Kind of artifact one run produces (CHANGE_SET, BRIEFING, …) */
  resultKind: Scalars['String']['output'];
  /** PLATFORM (shipped in a module) or TENANT (authored by the caller). Only TENANT cards can be edited — by their author */
  source: Scalars['String']['output'];
  /** Cron hint pre-filled when the caller saves a routine of this workflow; not a routine itself */
  suggestedCron?: Maybe<Scalars['String']['output']>;
  /** The file's own number from its frontmatter, default 1 */
  version?: Maybe<Scalars['Int']['output']>;
  /** The situation this workflow answers, in the user's words — what an agent matches a request against, and what a card can show as "Use it when …". Null when the file states only what it does */
  whenToUse?: Maybe<Scalars['String']['output']>;
};

/** One agent action intent with the governance verdict; the agent action ledger */
export type Agent_Action = BaseEntity & {
  __typename?: 'Agent_Action';
  actionType?: Maybe<Scalars['String']['output']>;
  agentCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  dispatchMode?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['Long']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Long']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  resultRef?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
  verdictReason?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Agent_ActionInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  agentCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchMode?: InputMaybe<Scalars['String']['input']>;
  dispatchedAt?: InputMaybe<Scalars['Long']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Long']['input']>;
  executionError?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
  verdictReason?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a Agent_ActionList query */
export type Agent_ActionListResult = {
  __typename?: 'Agent_ActionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Agent_Action>>>;
  /** Total number of Agent_Action records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One turn of an agent chat transcript — a child document of its Agent_Chat_Session */
export type Agent_Chat_Message = BaseEntity & {
  __typename?: 'Agent_Chat_Message';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  blocks?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  role?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** One conversational agent session — transcript, execution state, and the produced result */
export type Agent_Chat_Session = BaseEntity & {
  __typename?: 'Agent_Chat_Session';
  agentCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  loadedTools?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  memoryCompactedThroughSeq?: Maybe<Scalars['Int']['output']>;
  memorySummary?: Maybe<Scalars['String']['output']>;
  /** The transcript, oldest first — the session's Agent_Chat_Message child documents, fetched only when this field is selected */
  messages?: Maybe<Array<Maybe<Agent_Chat_Message>>>;
  model?: Maybe<Scalars['String']['output']>;
  openedWith?: Maybe<Scalars['String']['output']>;
  parentChatId?: Maybe<Scalars['String']['output']>;
  proposal?: Maybe<Scalars['JSON']['output']>;
  reads?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  readyToExecute?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectRef?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  titledByUser?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  webSearch?: Maybe<Scalars['Boolean']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowInputs?: Maybe<Scalars['JSON']['output']>;
  workflowVersion?: Maybe<Scalars['Int']['output']>;
};

/** An agent's reviewable work product that changes nothing — a briefing, an outline — listed in Actions alongside org change sets */
export type Agent_Draft = BaseEntity & {
  __typename?: 'Agent_Draft';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  counts?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reviewComment?: Maybe<Scalars['String']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  subjectRef?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowVersion?: Maybe<Scalars['Int']['output']>;
};

/** Defines a single aggregate expression (e.g. COUNT(*) AS total) */
export type AggregationInput = {
  /** Output alias for this aggregate column */
  alias: Scalars['String']['input'];
  /** Aggregate expression, e.g. "COUNT(*)", "SUM(c.amount)", "MAX(c.amount)" */
  expr: Scalars['String']['input'];
};

export type AnalyticsDashboard = BaseEntity & {
  __typename?: 'AnalyticsDashboard';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dashboardType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  globalFilters?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tiles?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDashboardInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dashboardType?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  globalFilters?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tiles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a AnalyticsDashboardList query */
export type AnalyticsDashboardListResult = {
  __typename?: 'AnalyticsDashboardListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<AnalyticsDashboard>>>;
  /** Total number of AnalyticsDashboard records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsView = BaseEntity & {
  __typename?: 'AnalyticsView';
  chart?: Maybe<Scalars['JSON']['output']>;
  columns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  /** Number of dashboards referencing this view */
  dashboardCount?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reportDefinitionId?: Maybe<ReportDefinition>;
  sort?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type App_Role = BaseEntity & {
  __typename?: 'App_Role';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentRoleId?: Maybe<App_Role>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type App_RoleInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  parentRoleId?: InputMaybe<Scalars['ID']['input']>;
  systemDefined?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a App_RoleList query */
export type App_RoleListResult = {
  __typename?: 'App_RoleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<App_Role>>>;
  /** Total number of App_Role records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Artifact entity for tracking documents and files */
export type Artifact = BaseEntity & {
  __typename?: 'Artifact';
  activityId?: Maybe<Activity>;
  artifactRef?: Maybe<Scalars['String']['output']>;
  artifactType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  ownerPersonId?: Maybe<Person>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ArtifactInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  artifactRef?: InputMaybe<Scalars['String']['input']>;
  artifactType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  ownerPersonId?: InputMaybe<Scalars['ID']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ArtifactList query */
export type ArtifactListResult = {
  __typename?: 'ArtifactListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Artifact>>>;
  /** Total number of Artifact records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A next move suggested to a person by someone above them, for the person to accept or decline */
export type AspirationProposal = BaseEntity & {
  __typename?: 'AspirationProposal';
  aspirationId?: Maybe<CareerAspiration>;
  contextRef?: Maybe<BaseEntity>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  decidedAt?: Maybe<Scalars['Long']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  note?: Maybe<Scalars['String']['output']>;
  proposedByPersonId?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  subjectPersonId?: Maybe<Person>;
  targetLevelId?: Maybe<CareerLevel>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AspirationProposalInput = {
  aspirationId?: InputMaybe<Scalars['ID']['input']>;
  contextRef?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  decidedAt?: InputMaybe<Scalars['Long']['input']>;
  declineReason?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  proposedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectPersonId?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a AspirationProposalList query */
export type AspirationProposalListResult = {
  __typename?: 'AspirationProposalListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<AspirationProposal>>>;
  /** Total number of AspirationProposal records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Audit_Log = {
  __typename?: 'Audit_Log';
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<User>;
  actorUserId?: Maybe<Scalars['String']['output']>;
  app?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Array<Maybe<FieldChange>>>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['Long']['output']>;
  targetEntityType?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<Scalars['String']['output']>;
};

/** Common fields shared by all entity types. Use inline fragments (e.g. '... on Account { name }') to access type-specific fields. */
export type BaseEntity = {
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BrowserUploadSession = {
  __typename?: 'BrowserUploadSession';
  expiresAt?: Maybe<Scalars['Long']['output']>;
  requiredHeaders?: Maybe<Scalars['JSON']['output']>;
  sessionId: Scalars['ID']['output'];
  uploadMode: Scalars['String']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** A calibration session over part of a review cycle: its scope, facilitator and participants */
export type CalibrationSession = BaseEntity & {
  __typename?: 'CalibrationSession';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<ReviewCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  facilitatorPersonId?: Maybe<Person>;
  finalisedAt?: Maybe<Scalars['Long']['output']>;
  finalisedByPersonId?: Maybe<Person>;
  id: Scalars['ID']['output'];
  jobProfileIds?: Maybe<Array<Maybe<JobProfile>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  levelIds?: Maybe<Array<Maybe<CareerLevel>>>;
  locationIds?: Maybe<Array<Maybe<Location>>>;
  notes?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['Long']['output']>;
  orgIds?: Maybe<Array<Maybe<Org>>>;
  participantPersonIds?: Maybe<Array<Maybe<Person>>>;
  personTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CalibrationSessionInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employmentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  facilitatorPersonId?: InputMaybe<Scalars['ID']['input']>;
  finalisedAt?: InputMaybe<Scalars['Long']['input']>;
  finalisedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  levelIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openedAt?: InputMaybe<Scalars['Long']['input']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  participantPersonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a CalibrationSessionList query */
export type CalibrationSessionListResult = {
  __typename?: 'CalibrationSessionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CalibrationSession>>>;
  /** Total number of CalibrationSession records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Someone being hired who is not a Person yet; documents about them move to the Person at hire */
export type Candidate = BaseEntity & {
  __typename?: 'Candidate';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  expectedJoiningDate?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a CandidateList query */
export type CandidateListResult = {
  __typename?: 'CandidateListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Candidate>>>;
  /** Total number of Candidate records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An uploaded document to draft from, and what to take from it */
export type CareerAiFileInput = {
  /** The StoredFile entityId, or its full id */
  fileId: Scalars['ID']['input'];
  /** What to look for in it; up to 1000 characters */
  instruction?: InputMaybe<Scalars['String']['input']>;
};

/** A document an AI-drafted framework is drafted from */
export type CareerAiSource = {
  __typename?: 'CareerAISource';
  fileId: Scalars['ID']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  /** What the author asked to take from it */
  instruction?: Maybe<Scalars['String']['output']>;
  /** Whether the knowledge base has read it; unread files are read by the next step */
  read: Scalars['Boolean']['output'];
};

/** Where an AI-drafted framework's current step stands, and what it is drafted from */
export type CareerAiState = {
  __typename?: 'CareerAIState';
  completedSteps?: Maybe<Array<Scalars['String']['output']>>;
  /** Why the step failed, when FAILED */
  error?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  /** The job profiles the author chose; the AI places these and no other */
  jobProfileIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** What the step is doing now */
  message?: Maybe<Scalars['String']['output']>;
  /** 0 to 100 */
  progress?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Array<CareerAiSource>>;
  /** QUEUED, RUNNING, SUCCEEDED or FAILED */
  status?: Maybe<Scalars['String']['output']>;
  /** PROPOSE, LEVELS, DEFINITIONS or MOVES — the step last asked for */
  step?: Maybe<Scalars['String']['output']>;
  /** LIGHT, STANDARD or STRICT */
  strictness?: Maybe<Scalars['String']['output']>;
  /** LET_AI_DECIDE, IC_AND_MANAGEMENT or IC, from the CareerAITrack picklist */
  track?: Maybe<Scalars['String']['output']>;
  /** Levels whose AI-drafted requirements are not reviewed yet */
  unreviewedLevelIds?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['Long']['output']>;
};

/** The career level a person aspires to for one interval; at most one is open per person */
export type CareerAspiration = BaseEntity & {
  __typename?: 'CareerAspiration';
  SEP?: Maybe<Scalars['String']['output']>;
  closeReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['Long']['output']>;
  effectiveTo?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  latestReadinessId?: Maybe<CareerReadiness>;
  personId?: Maybe<Person>;
  sourceRef?: Maybe<BaseEntity>;
  targetLevelId?: Maybe<CareerLevel>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CareerAspirationInput = {
  SEP?: InputMaybe<Scalars['String']['input']>;
  closeReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Long']['input']>;
  effectiveTo?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  latestReadinessId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  sourceRef?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** How much of a ladder this organisation can evaluate */
export type CareerCoverage = {
  __typename?: 'CareerCoverage';
  criteria?: Maybe<Scalars['Int']['output']>;
  evaluable?: Maybe<Scalars['Int']['output']>;
  frameworkId?: Maybe<Scalars['ID']['output']>;
  levels?: Maybe<Array<Maybe<CareerLevelCoverage>>>;
};

/** A career ladder system, optionally naming the job family groups its profiles come from */
export type CareerFramework = BaseEntity & {
  __typename?: 'CareerFramework';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  ai?: Maybe<Scalars['JSON']['output']>;
  appliesTo?: Maybe<Array<Maybe<JobFamilyGroup>>>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  routineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
};

/** Track, level and unique job-profile counts for one framework */
export type CareerFrameworkCounts = {
  __typename?: 'CareerFrameworkCounts';
  frameworkId: Scalars['ID']['output'];
  jobProfileCount: Scalars['Int']['output'];
  levelCount: Scalars['Int']['output'];
  trackCount: Scalars['Int']['output'];
};

export type CareerFrameworkInput = {
  agentCode?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  ai?: InputMaybe<Scalars['JSON']['input']>;
  appliesTo?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  routineId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  workflowCode?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a CareerFrameworkList query */
export type CareerFrameworkListResult = {
  __typename?: 'CareerFrameworkListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CareerFramework>>>;
  /** Total number of CareerFramework records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A level's entry criteria judged against the person now; computed, never stored */
export type CareerGap = {
  __typename?: 'CareerGap';
  fromLevelId?: Maybe<Scalars['ID']['output']>;
  /** Levels between, ending at the target */
  path?: Maybe<Array<Scalars['ID']['output']>>;
  personId?: Maybe<Scalars['ID']['output']>;
  /** One CriterionResult per entry criterion */
  results?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  targetLevelId?: Maybe<Scalars['ID']['output']>;
};

/** A career framework with its tracks and levels */
export type CareerLadder = {
  __typename?: 'CareerLadder';
  framework: CareerFramework;
  levels?: Maybe<Array<Maybe<CareerLevel>>>;
  tracks?: Maybe<Array<Maybe<CareerTrack>>>;
};

/** What validating or publishing a ladder found. Errors refuse a publish; warnings do not */
export type CareerLadderReport = {
  __typename?: 'CareerLadderReport';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Set when the ladder was published or saved as a draft */
  frameworkId?: Maybe<Scalars['ID']['output']>;
  ok: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** One rung on a career track: its grade, its expectations, its entry bar, and its outbound moves */
export type CareerLevel = BaseEntity & {
  __typename?: 'CareerLevel';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  entryCriteria?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  expectations?: Maybe<Scalars['String']['output']>;
  expectedQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  expectedSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  isTop?: Maybe<Scalars['Boolean']['output']>;
  jobGrade?: Maybe<Scalars['String']['output']>;
  jobProfileIds?: Maybe<Array<Maybe<JobProfile>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  rank?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trackId?: Maybe<CareerTrack>;
  transitions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CareerLevelCoverage = {
  __typename?: 'CareerLevelCoverage';
  criteria?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  evaluable?: Maybe<Scalars['Int']['output']>;
  levelId?: Maybe<Scalars['ID']['output']>;
  notEvaluable?: Maybe<Array<Scalars['String']['output']>>;
  /** Job profiles on the level no enabled productivity model scores, when its bar has score requirements: those are unknown for their holders */
  unscored?: Maybe<Array<Scalars['ID']['output']>>;
};

export type CareerLevelInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  entryCriteria?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  expectations?: InputMaybe<Scalars['String']['input']>;
  expectedQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  expectedSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTop?: InputMaybe<Scalars['Boolean']['input']>;
  jobGrade?: InputMaybe<Scalars['String']['input']>;
  jobProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  trackId?: InputMaybe<Scalars['ID']['input']>;
  transitions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Whether a person met the bar for a target career level, with the criteria and values it was judged on */
export type CareerReadiness = BaseEntity & {
  __typename?: 'CareerReadiness';
  assessedAt?: Maybe<Scalars['Long']['output']>;
  blockedBy?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  criteriaSnapshot?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  criterionResults?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evaluableRatio?: Maybe<Scalars['Float']['output']>;
  fromLevelId?: Maybe<CareerLevel>;
  gatesMet?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  narrative?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  targetLevelId?: Maybe<CareerLevel>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
};

export type CareerReadinessInput = {
  assessedAt?: InputMaybe<Scalars['Long']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  criteriaSnapshot?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  criterionResults?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  evaluableRatio?: InputMaybe<Scalars['Float']['input']>;
  fromLevelId?: InputMaybe<Scalars['ID']['input']>;
  gatesMet?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  windowEnd?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a CareerReadinessList query */
export type CareerReadinessListResult = {
  __typename?: 'CareerReadinessListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CareerReadiness>>>;
  /** Total number of CareerReadiness records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One named ladder within a career framework */
export type CareerTrack = BaseEntity & {
  __typename?: 'CareerTrack';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  frameworkId?: Maybe<CareerFramework>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CareerTrackInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  frameworkId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CellError = {
  __typename?: 'CellError';
  column?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowIndex?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
};

/** Accumulator for incomplete chat channel batches */
export type ChatBucket = BaseEntity & {
  __typename?: 'ChatBucket';
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channelId?: Maybe<Scalars['String']['output']>;
  combinedMessageText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  rawChatIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ChatBucketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  combinedMessageText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  rawChatIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ChatBucketList query */
export type ChatBucketListResult = {
  __typename?: 'ChatBucketListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ChatBucket>>>;
  /** Total number of ChatBucket records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Tenant root — carries AI calibration context and OKR cycle configuration */
export type Company = BaseEntity & {
  __typename?: 'Company';
  businessModel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultAmbitionLevel?: Maybe<Scalars['String']['output']>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  emailDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  fiscalYearStartMonth?: Maybe<Scalars['Int']['output']>;
  foundedYear?: Maybe<Scalars['Int']['output']>;
  geographiesServed?: Maybe<Array<Maybe<Location>>>;
  growthStage?: Maybe<Scalars['String']['output']>;
  headcountRange?: Maybe<Scalars['String']['output']>;
  headquartersLocation?: Maybe<Location>;
  headquartersTimezone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  keyProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  locationIds?: Maybe<Array<Maybe<Location>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  notableClients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  okrCadence?: Maybe<Scalars['String']['output']>;
  registeredAddress?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  workLocations?: Maybe<Array<Maybe<Location>>>;
  workMode?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  businessModel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  defaultAmbitionLevel?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  geographiesServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  growthStage?: InputMaybe<Scalars['String']['input']>;
  headcountRange?: InputMaybe<Scalars['String']['input']>;
  headquartersLocation?: InputMaybe<Scalars['ID']['input']>;
  headquartersTimezone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  keyProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  notableClients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  okrCadence?: InputMaybe<Scalars['String']['input']>;
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  workMode?: InputMaybe<Scalars['String']['input']>;
};

/** A knowledge entry in the company knowledge graph — feeds the OKR generation LLM pipeline */
export type CompanyKnowledge = BaseEntity & {
  __typename?: 'CompanyKnowledge';
  FIELD_KG_EXTRACTED_AT?: Maybe<Scalars['String']['output']>;
  FIELD_KG_EXTRACTION_STATUS?: Maybe<Scalars['String']['output']>;
  KG_STATUS_DONE?: Maybe<Scalars['String']['output']>;
  KG_STATUS_FAILED?: Maybe<Scalars['String']['output']>;
  KG_STATUS_PENDING?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kgExtractedAt?: Maybe<Scalars['Long']['output']>;
  kgExtractionStatus?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CompanyKnowledgeInput = {
  FIELD_KG_EXTRACTED_AT?: InputMaybe<Scalars['String']['input']>;
  FIELD_KG_EXTRACTION_STATUS?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_DONE?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_FAILED?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_PENDING?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kgExtractedAt?: InputMaybe<Scalars['Long']['input']>;
  kgExtractionStatus?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceDate?: InputMaybe<Scalars['Long']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a CompanyKnowledgeList query */
export type CompanyKnowledgeListResult = {
  __typename?: 'CompanyKnowledgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CompanyKnowledge>>>;
  /** Total number of CompanyKnowledge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a CompanyList query */
export type CompanyListResult = {
  __typename?: 'CompanyListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Company>>>;
  /** Total number of Company records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ConnectionAuthStart = {
  __typename?: 'ConnectionAuthStart';
  authorizationUrl: Scalars['String']['output'];
  connectionId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
};

export type Connector = {
  __typename?: 'Connector';
  feeds?: Maybe<Array<ConnectorFeed>>;
  sourceType: Scalars['String']['output'];
};

export type ConnectorFeed = {
  __typename?: 'ConnectorFeed';
  name: Scalars['String']['output'];
  schema?: Maybe<Array<ConnectorField>>;
};

export type ConnectorField = {
  __typename?: 'ConnectorField';
  field: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateIntegrationInput = {
  connection: Scalars['ID']['input'];
  connector: Scalars['String']['input'];
  feed: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  mapping?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  target: Scalars['String']['input'];
};

/** Paginated result of a dashboards query */
export type DashboardListResult = {
  __typename?: 'DashboardListResult';
  /** Whether more dashboards exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Dashboards on this page */
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Total dashboards matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DashboardType {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

/** Department entity representing an organizational unit */
export type Department = BaseEntity & {
  __typename?: 'Department';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMGSAEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DepartmentInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMGSAEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A document's stable identity across its versions */
export type Document = BaseEntity & {
  __typename?: 'Document';
  acknowledgementRoundVersionId?: Maybe<DocumentVersion>;
  appliesToEmploymentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  appliesToJobProfileIds?: Maybe<Array<Maybe<JobProfile>>>;
  appliesToLocationIds?: Maybe<Array<Maybe<Location>>>;
  appliesToOrgIds?: Maybe<Array<Maybe<Org>>>;
  appliesToPersonTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  archiveReason?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['Long']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currentVersionId?: Maybe<DocumentVersion>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  disposalReason?: Maybe<Scalars['String']['output']>;
  disposedAt?: Maybe<Scalars['Long']['output']>;
  documentTypeId?: Maybe<DocumentType>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Long']['output']>;
  folderId?: Maybe<DocumentFolder>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastReviewedAt?: Maybe<Scalars['Long']['output']>;
  lastReviewedByPersonId?: Maybe<Person>;
  libraryId?: Maybe<DocumentLibrary>;
  nextReviewAt?: Maybe<Scalars['Long']['output']>;
  retainUntil?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** One person's acknowledgement of a published document, or the one they still owe */
export type DocumentAcknowledgement = BaseEntity & {
  __typename?: 'DocumentAcknowledgement';
  acknowledgedAt?: Maybe<Scalars['Long']['output']>;
  closedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Document>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastRemindedAt?: Maybe<Scalars['Long']['output']>;
  personId?: Maybe<Person>;
  roundVersionId?: Maybe<DocumentVersion>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<DocumentVersion>;
  waivedByPersonId?: Maybe<Person>;
  waiverReason?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentAcknowledgementList query */
export type DocumentAcknowledgementListResult = {
  __typename?: 'DocumentAcknowledgementListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentAcknowledgement>>>;
  /** Total number of DocumentAcknowledgement records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** How the current round of acknowledgement of a document stands */
export type DocumentAcknowledgementSummary = {
  __typename?: 'DocumentAcknowledgementSummary';
  acknowledged: Scalars['Int']['output'];
  documentId: Scalars['ID']['output'];
  overdue: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  pendingPersonIds: Array<Scalars['ID']['output']>;
  roundVersionId?: Maybe<Scalars['ID']['output']>;
  waived: Scalars['Int']['output'];
};

/** A folder arranging documents inside a library; may narrow the library's access */
export type DocumentFolder = BaseEntity & {
  __typename?: 'DocumentFolder';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inheritAccess?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  libraryId?: Maybe<DocumentLibrary>;
  parentFolderId?: Maybe<DocumentFolder>;
  subjectId?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentFolderList query */
export type DocumentFolderListResult = {
  __typename?: 'DocumentFolderListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentFolder>>>;
  /** Total number of DocumentFolder records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A document library: the access boundary documents are filed in */
export type DocumentLibrary = BaseEntity & {
  __typename?: 'DocumentLibrary';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  libraryKind?: Maybe<Scalars['String']['output']>;
  maxClassification?: Maybe<Scalars['String']['output']>;
  subjectTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentLibraryList query */
export type DocumentLibraryListResult = {
  __typename?: 'DocumentLibraryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentLibrary>>>;
  /** Total number of DocumentLibrary records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Relates a document to an entity it governs, describes or evidences; grants no access */
export type DocumentLink = BaseEntity & {
  __typename?: 'DocumentLink';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Document>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  role?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentLinkList query */
export type DocumentLinkListResult = {
  __typename?: 'DocumentLinkListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentLink>>>;
  /** Total number of DocumentLink records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a DocumentList query */
export type DocumentListResult = {
  __typename?: 'DocumentListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Document>>>;
  /** Total number of Document records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Who a document move gives read access to, and who it takes it from, as actors (u/…, ug/…, o/…) */
export type DocumentMoveAccessDiff = {
  __typename?: 'DocumentMoveAccessDiff';
  changesAccess: Scalars['Boolean']['output'];
  gains: Array<Scalars['String']['output']>;
  loses: Array<Scalars['String']['output']>;
};

/** A document a person must provide under a requirement, and where it stands */
export type DocumentObligation = BaseEntity & {
  __typename?: 'DocumentObligation';
  closedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Document>;
  documentTypeIds?: Maybe<Array<Maybe<DocumentType>>>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastRemindedAt?: Maybe<Scalars['Long']['output']>;
  openedAt?: Maybe<Scalars['Long']['output']>;
  personId?: Maybe<Person>;
  requirementId?: Maybe<DocumentRequirement>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  waivedByPersonId?: Maybe<Person>;
  waiverReason?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentObligationList query */
export type DocumentObligationListResult = {
  __typename?: 'DocumentObligationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentObligation>>>;
  /** Total number of DocumentObligation records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A document type the people it matches must have */
export type DocumentRequirement = BaseEntity & {
  __typename?: 'DocumentRequirement';
  active?: Maybe<Scalars['Boolean']['output']>;
  alternativeDocumentTypeIds?: Maybe<Array<Maybe<DocumentType>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentTypeId?: Maybe<DocumentType>;
  dueWithinDays?: Maybe<Scalars['Int']['output']>;
  employmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobProfileIds?: Maybe<Array<Maybe<JobProfile>>>;
  joinedOnOrAfter?: Maybe<Scalars['Long']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationIds?: Maybe<Array<Maybe<Location>>>;
  orgIds?: Maybe<Array<Maybe<Org>>>;
  personTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** How the people a requirement applies to stand on it */
export type DocumentRequirementCompliance = {
  __typename?: 'DocumentRequirementCompliance';
  expired: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  pendingVerification: Scalars['Int']['output'];
  requirementId: Scalars['ID']['output'];
  satisfied: Scalars['Int']['output'];
  waived: Scalars['Int']['output'];
};

/** Paginated result of a DocumentRequirementList query */
export type DocumentRequirementListResult = {
  __typename?: 'DocumentRequirementListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentRequirement>>>;
  /** Total number of DocumentRequirement records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A kind of document, the defaults its documents start from, and where they are filed */
export type DocumentType = BaseEntity & {
  __typename?: 'DocumentType';
  acknowledgementDueDays?: Maybe<Scalars['Int']['output']>;
  approvalDueDays?: Maybe<Scalars['Int']['output']>;
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultClassification?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  expiryReminderDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  expiryRequired?: Maybe<Scalars['Boolean']['output']>;
  folderId?: Maybe<DocumentFolder>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  libraryId?: Maybe<DocumentLibrary>;
  requiresAcknowledgement?: Maybe<Scalars['Boolean']['output']>;
  retentionAnchor?: Maybe<Scalars['String']['output']>;
  retentionDays?: Maybe<Scalars['Int']['output']>;
  reviewCadenceDays?: Maybe<Scalars['Int']['output']>;
  selfUploadAllowed?: Maybe<Scalars['Boolean']['output']>;
  singleCurrent?: Maybe<Scalars['Boolean']['output']>;
  subjectTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templateFileId?: Maybe<StoredFile>;
  templateInputs?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  templateSourceVersionId?: Maybe<DocumentVersion>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a DocumentTypeList query */
export type DocumentTypeListResult = {
  __typename?: 'DocumentTypeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentType>>>;
  /** Total number of DocumentType records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One immutable version of a document's content */
export type DocumentVersion = BaseEntity & {
  __typename?: 'DocumentVersion';
  approvedAt?: Maybe<Scalars['Long']['output']>;
  approvedByPersonId?: Maybe<Person>;
  changeNote?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  disposedAt?: Maybe<Scalars['Long']['output']>;
  documentId?: Maybe<Document>;
  effectiveFrom?: Maybe<Scalars['Long']['output']>;
  effectiveTo?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  generatedFromTemplateFileId?: Maybe<StoredFile>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  minorChange?: Maybe<Scalars['Boolean']['output']>;
  retainUntil?: Maybe<Scalars['Long']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  sha256?: Maybe<Scalars['String']['output']>;
  signatureRequestId?: Maybe<SignatureRequest>;
  state?: Maybe<Scalars['String']['output']>;
  storedFileId?: Maybe<StoredFile>;
  submittedAt?: Maybe<Scalars['Long']['output']>;
  submittedByPersonId?: Maybe<Person>;
  supersededAt?: Maybe<Scalars['Long']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionNo?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a DocumentVersionList query */
export type DocumentVersionListResult = {
  __typename?: 'DocumentVersionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<DocumentVersion>>>;
  /** Total number of DocumentVersion records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Reified, provenance-bearing relationship between two Org Knowledge Graph nodes */
export type Edge = BaseEntity & {
  __typename?: 'Edge';
  MILLIS_PER_DAY?: Maybe<Scalars['Long']['output']>;
  OBSERVED_DAYS_RETENTION?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidenceRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectId?: Maybe<BaseEntity>;
  objectType?: Maybe<Scalars['String']['output']>;
  observedAt?: Maybe<Scalars['Long']['output']>;
  observedDays?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  predicate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Long']['output']>;
  validTo?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type EdgeInput = {
  MILLIS_PER_DAY?: InputMaybe<Scalars['Long']['input']>;
  OBSERVED_DAYS_RETENTION?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  evidenceRefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['Long']['input']>;
  observedDays?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  predicate?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Long']['input']>;
  validTo?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Paginated result of a EdgeList query */
export type EdgeListResult = {
  __typename?: 'EdgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Edge>>>;
  /** Total number of Edge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Lookup sequence for auto-generated entity codes (prefix + nextCode + padding) */
export type EntityCodeLookup = BaseEntity & {
  __typename?: 'EntityCodeLookup';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nextCode?: Maybe<Scalars['Int']['output']>;
  padding?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Peeked entity-code sequence for one sourceEntityType */
export type EntityCodeLookupItem = {
  __typename?: 'EntityCodeLookupItem';
  /** Formatted next code — FE should send this as entityId on create */
  code?: Maybe<Scalars['String']['output']>;
  nextCode?: Maybe<Scalars['Int']['output']>;
  padding?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
};

/** An entity definition with its fields */
export type EntityDefinition = {
  __typename?: 'EntityDefinition';
  apiName: Scalars['String']['output'];
  audited: Scalars['Boolean']['output'];
  /** True for a custom entity, whose apiName ends in __c */
  customEntity: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** The entity's fields, sorted by display name; deleted fields are left out */
  fields: Array<EntityFieldDefinition>;
  kg: Scalars['Boolean']['output'];
  pluralDisplayName?: Maybe<Scalars['String']['output']>;
  restricted: Scalars['Boolean']['output'];
  store?: Maybe<Scalars['String']['output']>;
  systemEntity: Scalars['Boolean']['output'];
};

export type EntityExportStatus = {
  __typename?: 'EntityExportStatus';
  error?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<ExportedFile>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EntityExportTrigger = {
  __typename?: 'EntityExportTrigger';
  triggerId: Scalars['ID']['output'];
};

/** The definition of a field on its entity */
export type EntityFieldDefinition = {
  __typename?: 'EntityFieldDefinition';
  apiName: Scalars['String']['output'];
  audited: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fieldConstraints?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** TEXT, PICKLIST, MULTI_PICKLIST, INTEGER, DECIMAL, DATE, DATETIME, REFERENCE, ... */
  fieldType?: Maybe<Scalars['String']['output']>;
  /** SINGLE or LIST */
  multiplicity?: Maybe<Scalars['String']['output']>;
  predicate?: Maybe<Scalars['String']['output']>;
  /** Referenced entity type for a REFERENCE field */
  referenceEntity?: Maybe<Scalars['String']['output']>;
  systemField: Scalars['Boolean']['output'];
};

export type ExportJobHistory = BaseEntity & {
  __typename?: 'ExportJobHistory';
  completedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportJobId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reportDefinitionId?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ExportJobHistoryInput = {
  completedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  exportJobId?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  sourceEntityId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ExportJobHistoryList query */
export type ExportJobHistoryListResult = {
  __typename?: 'ExportJobHistoryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ExportJobHistory>>>;
  /** Total number of ExportJobHistory records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportedFile = {
  __typename?: 'ExportedFile';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['Long']['output'];
  fileId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ExtensibleAttribute = {
  __typename?: 'ExtensibleAttribute';
  builtIn: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  picklist?: Maybe<Scalars['String']['output']>;
  type: ExtensibleAttributeType;
};

export type ExtensibleAttributeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: ExtensibleAttributeType;
};

export enum ExtensibleAttributeType {
  Boolean = 'BOOLEAN',
  Decimal = 'DECIMAL',
  Integer = 'INTEGER',
  Picklist = 'PICKLIST',
  Text = 'TEXT'
}

export type ExtensibleAttributeValue = {
  __typename?: 'ExtensibleAttributeValue';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ExtensibleAttributeValueInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ExtensibleField = {
  __typename?: 'ExtensibleField';
  apiName: Scalars['String']['output'];
  attributes: Array<ExtensibleAttribute>;
  customized: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  module: Scalars['String']['output'];
  options: Array<ExtensibleFieldOption>;
};

export type ExtensibleFieldInput = {
  attributes: Array<ExtensibleAttributeInput>;
  options: Array<ExtensibleFieldOptionInput>;
};

export type ExtensibleFieldOption = {
  __typename?: 'ExtensibleFieldOption';
  attributes: Array<ExtensibleAttributeValue>;
  description?: Maybe<Scalars['String']['output']>;
  /** Listed here, but every other read of the picklist treats it as deleted */
  disabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExtensibleFieldOptionInput = {
  attributes: Array<ExtensibleAttributeValueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** A disabled option reads as deleted outside the editor. Omitted means enabled. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** The feedback coach's suggestions on a draft. Nothing is saved or sent */
export type FeedbackCoachAdvice = {
  __typename?: 'FeedbackCoachAdvice';
  issues: Array<FeedbackCoachIssue>;
  /** Catalog skills the draft speaks to; pass the ones kept unrated to giveFeedback */
  suggestedSkillIds: Array<Scalars['ID']['output']>;
  /** A rewrite to consider; [brackets] mark details only the giver knows. Null when there is none */
  suggestedText?: Maybe<Scalars['String']['output']>;
};

/** One thing in a draft to reconsider */
export type FeedbackCoachIssue = {
  __typename?: 'FeedbackCoachIssue';
  /** What to write instead */
  advice?: Maybe<Scalars['String']['output']>;
  /** The draft's words it is about */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** VAGUE, PERSONALITY (judges the person, not what they did) or GENDERED */
  kind: Scalars['String']['output'];
};

/** An ask for feedback about one person, sent to one recipient */
export type FeedbackRequest = BaseEntity & {
  __typename?: 'FeedbackRequest';
  answerId?: Maybe<PersonFeedback>;
  closedAt?: Maybe<Scalars['Long']['output']>;
  contextRef?: Maybe<BaseEntity>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  declineReason?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  prompt?: Maybe<Scalars['String']['output']>;
  recipientPersonId?: Maybe<Person>;
  requestedByPersonId?: Maybe<Person>;
  skillIds?: Maybe<Array<Maybe<BaseEntity>>>;
  status?: Maybe<Scalars['String']['output']>;
  subjectPersonId?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FeedbackRequestInput = {
  answerId?: InputMaybe<Scalars['ID']['input']>;
  closedAt?: InputMaybe<Scalars['Long']['input']>;
  contextRef?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  declineReason?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  recipientPersonId?: InputMaybe<Scalars['ID']['input']>;
  requestedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  skillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectPersonId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a FeedbackRequestList query */
export type FeedbackRequestListResult = {
  __typename?: 'FeedbackRequestListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<FeedbackRequest>>>;
  /** Total number of FeedbackRequest records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FieldChange = {
  __typename?: 'FieldChange';
  displayName?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  uploadDate?: Maybe<Scalars['Long']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileDownloadInfo = {
  __typename?: 'FileDownloadInfo';
  expiresAt?: Maybe<Scalars['Long']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  uploadDate?: InputMaybe<Scalars['Long']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A platform-defined functional permission assigned via FunctionalPermissionGrant */
export type FunctionalPermission = {
  __typename?: 'FunctionalPermission';
  description?: Maybe<Scalars['String']['output']>;
  /** Other functional keys directly implied when this one is held (FunctionalPermission.addImplied), e.g. MANAGE_ORG_CHART implies VIEW_ORG_CHART. Empty when this key implies no other key. */
  impliedKeys: Array<Scalars['String']['output']>;
  /** Stable key stored on FunctionalPermissionGrant.functionalPermission */
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** Enabled-feature key this permission belongs to (MODULE or MODULE/SUBMODULE). Null keys fall into an 'Other' group. listFunctionalPermissions omits keys whose module is not on the tenant's ENABLED_FEATURES config. */
  module?: Maybe<Scalars['String']['output']>;
  /** TypePermission grants this key implies. Empty for keys with no entity-type ACL. */
  typeScopes: Array<FunctionalPermissionTypeScope>;
};

/** Stable keys of platform-defined functional permissions (see the FunctionalPermission catalog) */
export enum FunctionalPermissionKey {
  /** Author Content */
  AuthorContent = 'AUTHOR_CONTENT',
  /** Create Custom Agent */
  CreateCustomAgent = 'CREATE_CUSTOM_AGENT',
  /** Create Custom Workflow */
  CreateCustomWorkflow = 'CREATE_CUSTOM_WORKFLOW',
  /** Delete Session */
  DeleteSession = 'DELETE_SESSION',
  /** Manage Academy */
  ManageAcademy = 'MANAGE_ACADEMY',
  /** Manage Action Plan */
  ManageActionPlan = 'MANAGE_ACTION_PLAN',
  /** Manage Announcement */
  ManageAnnouncement = 'MANAGE_ANNOUNCEMENT',
  /** Manage Assignments */
  ManageAssignments = 'MANAGE_ASSIGNMENTS',
  /** Manage Authentication */
  ManageAuth = 'MANAGE_AUTH',
  /** Manage Career Paths */
  ManageCareerFramework = 'MANAGE_CAREER_FRAMEWORK',
  /** Manage Collection */
  ManageCollection = 'MANAGE_COLLECTION',
  /** Manage Community */
  ManageCommunity = 'MANAGE_COMMUNITY',
  /** Manage Configuration */
  ManageConfig = 'MANAGE_CONFIG',
  /** Manage Department */
  ManageDepartment = 'MANAGE_DEPARTMENT',
  /** Manage Document Libraries */
  ManageDocumentLibraries = 'MANAGE_DOCUMENT_LIBRARIES',
  /** Manage Employee Relations */
  ManageEmployeeRelations = 'MANAGE_EMPLOYEE_RELATIONS',
  /** Manage Event */
  ManageEvent = 'MANAGE_EVENT',
  /** Manage Feedback */
  ManageFeedback = 'MANAGE_FEEDBACK',
  /** Manage Gamification */
  ManageGamification = 'MANAGE_GAMIFICATION',
  /** Manage Habit */
  ManageHabit = 'MANAGE_HABIT',
  /** Manage Homepage */
  ManageHomepage = 'MANAGE_HOMEPAGE',
  /** Manage Integrations */
  ManageIntegrations = 'MANAGE_INTEGRATIONS',
  /** Invite Users */
  ManageInviteUser = 'MANAGE_INVITE_USER',
  /** Manage Job Profile */
  ManageJobProfile = 'MANAGE_JOB_PROFILE',
  /** Manage Journey */
  ManageJourney = 'MANAGE_JOURNEY',
  /** Manage Legal Holds */
  ManageLegalHolds = 'MANAGE_LEGAL_HOLDS',
  /** Manage Lyearn Connect */
  ManageLyearnConnect = 'MANAGE_LYEARN_CONNECT',
  /** Masquerade as User */
  ManageMasquerade = 'MANAGE_MASQUERADE',
  /** Manage Meeting */
  ManageMeeting = 'MANAGE_MEETING',
  /** Merge Accounts */
  ManageMergeAccount = 'MANAGE_MERGE_ACCOUNT',
  /** Manage Notifications */
  ManageNotifications = 'MANAGE_NOTIFICATIONS',
  /** Manage OKR */
  ManageOkr = 'MANAGE_OKR',
  /** Manage Onboarding */
  ManageOnboarding = 'MANAGE_ONBOARDING',
  /** Manage 1:1 */
  ManageOneOnOne = 'MANAGE_ONE_ON_ONE',
  /** Manage Org Chart */
  ManageOrgChart = 'MANAGE_ORG_CHART',
  /** Manage People Compliance */
  ManagePeopleCompliance = 'MANAGE_PEOPLE_COMPLIANCE',
  /** Manage Permissions */
  ManagePermissions = 'MANAGE_PERMISSIONS',
  /** Manage Position */
  ManagePosition = 'MANAGE_POSITION',
  /** Manage Praise */
  ManagePraise = 'MANAGE_PRAISE',
  /** Manage Productivity Models */
  ManageProductivityModel = 'MANAGE_PRODUCTIVITY_MODEL',
  /** Manage Qualification Catalog */
  ManageQualificationCatalog = 'MANAGE_QUALIFICATION_CATALOG',
  /** Manage Report */
  ManageReport = 'MANAGE_REPORT',
  /** Manage Review */
  ManageReview = 'MANAGE_REVIEW',
  /** Manage Roles */
  ManageRoles = 'MANAGE_ROLES',
  /** Manage Routine */
  ManageRoutine = 'MANAGE_ROUTINE',
  /** Manage Salary */
  ManageSalary = 'MANAGE_SALARY',
  /** Manage Scorecards */
  ManageScorecards = 'MANAGE_SCORECARDS',
  /** Manage Session */
  ManageSession = 'MANAGE_SESSION',
  /** Manage Session Recordings */
  ManageSessionRecordings = 'MANAGE_SESSION_RECORDINGS',
  /** Manage Skill Catalog */
  ManageSkillCatalog = 'MANAGE_SKILL_CATALOG',
  /** Manage Smart Folders */
  ManageSmartFolders = 'MANAGE_SMART_FOLDERS',
  /** Manage Subaccounts */
  ManageSubaccounts = 'MANAGE_SUBACCOUNTS',
  /** Manage Subscription */
  ManageSubscription = 'MANAGE_SUBSCRIPTION',
  /** Manage Survey */
  ManageSurvey = 'MANAGE_SURVEY',
  /** Manage Tags */
  ManageTags = 'MANAGE_TAGS',
  /** Manage Task */
  ManageTask = 'MANAGE_TASK',
  /** Manage Tenant User Groups */
  ManageTenantUserGroups = 'MANAGE_TENANT_USER_GROUPS',
  /** Manage Users */
  ManageUsers = 'MANAGE_USERS',
  /** Manage User Groups */
  ManageUserGroups = 'MANAGE_USER_GROUPS',
  /** Manage User Performance */
  ManageUserPerformance = 'MANAGE_USER_PERFORMANCE',
  /** Manage Workspaces */
  ManageWorkspaces = 'MANAGE_WORKSPACES',
  /** Mark Session Attendance */
  MarkSessionAttendance = 'MARK_SESSION_ATTENDANCE',
  /** Publish Content */
  PublishContent = 'PUBLISH_CONTENT',
  /** Run Payroll */
  RunPayroll = 'RUN_PAYROLL',
  /** Use Agent Chat */
  UseAgentChat = 'USE_AGENT_CHAT',
  /** Use Agent Draft */
  UseAgentDraft = 'USE_AGENT_DRAFT',
  /** Use Custom Agent */
  UseCustomAgent = 'USE_CUSTOM_AGENT',
  /** Use Custom Workflow */
  UseCustomWorkflow = 'USE_CUSTOM_WORKFLOW',
  /** Use Documents */
  UseDocuments = 'USE_DOCUMENTS',
  /** Use OKR */
  UseOkr = 'USE_OKR',
  /** Use Report */
  UseReport = 'USE_REPORT',
  /** Use System Agent */
  UseSystemAgent = 'USE_SYSTEM_AGENT',
  /** View Action Plan */
  ViewActionPlan = 'VIEW_ACTION_PLAN',
  /** View All Assignments */
  ViewAllAssignment = 'VIEW_ALL_ASSIGNMENT',
  /** View Everyone's Career Progression */
  ViewAllCareer = 'VIEW_ALL_CAREER',
  /** View All Collections */
  ViewAllCollection = 'VIEW_ALL_COLLECTION',
  /** View All Content */
  ViewAllContent = 'VIEW_ALL_CONTENT',
  /** View Everyone's Feedback */
  ViewAllFeedback = 'VIEW_ALL_FEEDBACK',
  /** View Everyone's Learning Activity */
  ViewAllLearningActivity = 'VIEW_ALL_LEARNING_ACTIVITY',
  /** View Everyone's Productivity Scores */
  ViewAllProductivityScores = 'VIEW_ALL_PRODUCTIVITY_SCORES',
  /** View Everyone's Reviews */
  ViewAllReview = 'VIEW_ALL_REVIEW',
  /** View All Sessions */
  ViewAllSession = 'VIEW_ALL_SESSION',
  /** View Analytics V1 */
  ViewAnalyticsV1 = 'VIEW_ANALYTICS_V1',
  /** View Announcement */
  ViewAnnouncement = 'VIEW_ANNOUNCEMENT',
  /** View Assignment */
  ViewAssignment = 'VIEW_ASSIGNMENT',
  /** View Audit Log */
  ViewAuditLog = 'VIEW_AUDIT_LOG',
  /** View Bookmarks */
  ViewBookmarks = 'VIEW_BOOKMARKS',
  /** View Career Paths */
  ViewCareerFramework = 'VIEW_CAREER_FRAMEWORK',
  /** View Collection */
  ViewCollection = 'VIEW_COLLECTION',
  /** View Community */
  ViewCommunity = 'VIEW_COMMUNITY',
  /** View Company Slack */
  ViewCompanySlack = 'VIEW_COMPANY_SLACK',
  /** View Content */
  ViewContent = 'VIEW_CONTENT',
  /** View Event */
  ViewEvent = 'VIEW_EVENT',
  /** View Feedback */
  ViewFeedback = 'VIEW_FEEDBACK',
  /** View Gamification */
  ViewGamification = 'VIEW_GAMIFICATION',
  /** View Habit */
  ViewHabit = 'VIEW_HABIT',
  /** View Integrations */
  ViewIntegrations = 'VIEW_INTEGRATIONS',
  /** View Job Profile */
  ViewJobProfile = 'VIEW_JOB_PROFILE',
  /** View Journey */
  ViewJourney = 'VIEW_JOURNEY',
  /** View Meeting */
  ViewMeeting = 'VIEW_MEETING',
  /** View 1:1 */
  ViewOneOnOne = 'VIEW_ONE_ON_ONE',
  /** View Org Chart */
  ViewOrgChart = 'VIEW_ORG_CHART',
  /** View Praise */
  ViewPraise = 'VIEW_PRAISE',
  /** View Review */
  ViewReview = 'VIEW_REVIEW',
  /** View Salary */
  ViewSalary = 'VIEW_SALARY',
  /** View Sales Data */
  ViewSalesData = 'VIEW_SALES_DATA',
  /** View Session */
  ViewSession = 'VIEW_SESSION',
  /** View Skill */
  ViewSkill = 'VIEW_SKILL',
  /** View Survey */
  ViewSurvey = 'VIEW_SURVEY',
  /** View Task */
  ViewTask = 'VIEW_TASK',
  /** View Team Career Progression */
  ViewTeamCareer = 'VIEW_TEAM_CAREER',
  /** View Team Feedback */
  ViewTeamFeedback = 'VIEW_TEAM_FEEDBACK',
  /** View Team Learning Activity */
  ViewTeamLearningActivity = 'VIEW_TEAM_LEARNING_ACTIVITY',
  /** View Team Productivity Scores */
  ViewTeamProductivityScores = 'VIEW_TEAM_PRODUCTIVITY_SCORES',
  /** View Team Reviews */
  ViewTeamReview = 'VIEW_TEAM_REVIEW'
}

/** A TypePermission grant implied by a functional permission key */
export type FunctionalPermissionTypeScope = {
  __typename?: 'FunctionalPermissionTypeScope';
  actions?: Maybe<Array<Scalars['String']['output']>>;
  resourceType: Scalars['String']['output'];
};

export type Functional_Permission_Grant = BaseEntity & {
  __typename?: 'Functional_Permission_Grant';
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  functionalPermission?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a Functional_Permission_GrantList query */
export type Functional_Permission_GrantListResult = {
  __typename?: 'Functional_Permission_GrantListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Functional_Permission_Grant>>>;
  /** Total number of Functional_Permission_Grant records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Global_Permission = BaseEntity & {
  __typename?: 'Global_Permission';
  access?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Global goal registry entry */
export type Goal = BaseEntity & {
  __typename?: 'Goal';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type GoalInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a GoalList query */
export type GoalListResult = {
  __typename?: 'GoalListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Goal>>>;
  /** Total number of Goal records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Group_Membership = BaseEntity & {
  __typename?: 'Group_Membership';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dynamicGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  person?: Maybe<Person>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staticGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userGroup?: Maybe<UserGroup>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a Group_MembershipList query */
export type Group_MembershipListResult = {
  __typename?: 'Group_MembershipListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Group_Membership>>>;
  /** Total number of Group_Membership records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Link from an external-system identity to a canonical Person */
export type IdentityLink = BaseEntity & {
  __typename?: 'IdentityLink';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Long']['output']>;
  validTo?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IdentityLinkInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Long']['input']>;
  validTo?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a IdentityLinkList query */
export type IdentityLinkListResult = {
  __typename?: 'IdentityLinkListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<IdentityLink>>>;
  /** Total number of IdentityLink records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ImportJob = {
  __typename?: 'ImportJob';
  triggerId: Scalars['ID']['output'];
};

export type ImportValidationResult = {
  __typename?: 'ImportValidationResult';
  errors?: Maybe<Array<Maybe<CellError>>>;
  rowActions?: Maybe<Scalars['JSON']['output']>;
};

export type InitBrowserUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  purposeEntityId?: InputMaybe<Scalars['ID']['input']>;
  purposeType?: InputMaybe<Scalars['String']['input']>;
};

/** AI-generated insight for an entity */
export type Insight = BaseEntity & {
  __typename?: 'Insight';
  actionItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  agentCode?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Array<Maybe<InsightEvidence>>>;
  expiryTime?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  insightCategory?: Maybe<Scalars['String']['output']>;
  insightId?: Maybe<Scalars['String']['output']>;
  insightType?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  leadingIndicators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processName?: Maybe<Scalars['String']['output']>;
  productivityModel?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  subjectRefs?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InsightEvidence = {
  __typename?: 'InsightEvidence';
  interpretation?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  observedAt?: Maybe<Scalars['Long']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightEvidenceInput = {
  interpretation?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['Long']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Per-person suppression of an insight */
export type InsightSuppression = BaseEntity & {
  __typename?: 'InsightSuppression';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insightId?: Maybe<Insight>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  suppressed?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Integration = BaseEntity & {
  __typename?: 'Integration';
  connection?: Maybe<IntegrationConnection>;
  connector?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cursor?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  feed?: Maybe<Scalars['String']['output']>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastSyncAt?: Maybe<Scalars['Long']['output']>;
  lastSyncStatus?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nextSyncAt?: Maybe<Scalars['Long']['output']>;
  precedence?: Maybe<Scalars['Int']['output']>;
  syncFrequency?: Maybe<Scalars['Long']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConnection = BaseEntity & {
  __typename?: 'IntegrationConnection';
  connectionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  providerConfigKey?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type IntegrationConnectionSummary = {
  __typename?: 'IntegrationConnectionSummary';
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type IntegrationInput = {
  connection?: InputMaybe<Scalars['ID']['input']>;
  connector?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  feed?: InputMaybe<Scalars['String']['input']>;
  healthy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  lastSyncAt?: InputMaybe<Scalars['Long']['input']>;
  lastSyncStatus?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  nextSyncAt?: InputMaybe<Scalars['Long']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  syncFrequency?: InputMaybe<Scalars['Long']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Interaction entity derived from Activity */
export type Interaction = BaseEntity & {
  __typename?: 'Interaction';
  activityId?: Maybe<Activity>;
  actorPersonId?: Maybe<Person>;
  commsQuality?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  participantPersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  responseTimeSecs?: Maybe<Scalars['Long']['output']>;
  signalType?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Long']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InteractionInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  actorPersonId?: InputMaybe<Scalars['ID']['input']>;
  commsQuality?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  participantPersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responseTimeSecs?: InputMaybe<Scalars['Long']['input']>;
  signalType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Long']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a InteractionList query */
export type InteractionListResult = {
  __typename?: 'InteractionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Interaction>>>;
  /** Total number of Interaction records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Grouping of related job profiles within a job family group */
export type JobFamily = BaseEntity & {
  __typename?: 'JobFamily';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobFamilyGroup?: Maybe<JobFamilyGroup>;
  /** Number of job profiles belonging to this job family */
  jobProfileCount?: Maybe<Scalars['Int']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Top-level grouping of job families */
export type JobFamilyGroup = BaseEntity & {
  __typename?: 'JobFamilyGroup';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Number of job families belonging to this group */
  jobFamilyCount?: Maybe<Scalars['Int']['output']>;
  /** Number of job profiles belonging to this group */
  jobProfileCount?: Maybe<Scalars['Int']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type JobFamilyGroupInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a JobFamilyGroupList query */
export type JobFamilyGroupListResult = {
  __typename?: 'JobFamilyGroupListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobFamilyGroup>>>;
  /** Total number of JobFamilyGroup records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JobFamilyInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobFamilyGroup?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a JobFamilyList query */
export type JobFamilyListResult = {
  __typename?: 'JobFamilyListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobFamily>>>;
  /** Total number of JobFamily records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Generic role definition used for recruitment, compensation, and OKR generation */
export type JobProfile = BaseEntity & {
  __typename?: 'JobProfile';
  careerLevelId?: Maybe<CareerLevel>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobFamily?: Maybe<JobFamily>;
  jobGrade?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managementScope?: Maybe<Scalars['String']['output']>;
  minYearsExperience?: Maybe<Scalars['Int']['output']>;
  preferredQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  preferredSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  requiredQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  requiredSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  responsibilities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workingConditions?: Maybe<Scalars['JSON']['output']>;
};

export type JobProfileInput = {
  careerLevelId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobFamily?: InputMaybe<Scalars['ID']['input']>;
  jobGrade?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managementScope?: InputMaybe<Scalars['String']['input']>;
  minYearsExperience?: InputMaybe<Scalars['Int']['input']>;
  preferredQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  preferredSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  requiredQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  requiredSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  responsibilities?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  workingConditions?: InputMaybe<Scalars['JSON']['input']>;
};

/** Paginated result of a JobProfileList query */
export type JobProfileListResult = {
  __typename?: 'JobProfileListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobProfile>>>;
  /** Total number of JobProfile records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Scores one person as a job profile of a productivity model, by hand */
export type JobProfileOverride = BaseEntity & {
  __typename?: 'JobProfileOverride';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  productivityModel?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  regionId?: Maybe<Location>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** A measurable outcome that defines how progress against an Objective is evaluated — tracks baseline, target, and current value across check-ins */
export type KeyResult = BaseEntity & {
  __typename?: 'KeyResult';
  /** User assigned via ASSIGN_KEYRESULT, including grant template/actions and person details — null when no user assignee grant exists */
  assignee?: Maybe<Scalars['JSON']['output']>;
  baselineValue?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectiveId?: Maybe<Objective>;
  ownerPositionId?: Maybe<Position>;
  progress?: Maybe<Scalars['Float']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Generic instance of any ontology-pack knowledge node kind */
export type KnowledgeNode = BaseEntity & {
  __typename?: 'KnowledgeNode';
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nodeKind?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeNodeInput = {
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  canonicalName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nodeKind?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a KnowledgeNodeList query */
export type KnowledgeNodeListResult = {
  __typename?: 'KnowledgeNodeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<KnowledgeNode>>>;
  /** Total number of KnowledgeNode records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A person's note on one entry of their performance ledger */
export type LedgerAnnotation = BaseEntity & {
  __typename?: 'LedgerAnnotation';
  annotatedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  ref?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LedgerAnnotationInput = {
  annotatedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a LedgerAnnotationList query */
export type LedgerAnnotationListResult = {
  __typename?: 'LedgerAnnotationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<LedgerAnnotation>>>;
  /** Total number of LedgerAnnotation records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Preserves the documents under a library, folder or document for a legal matter */
export type LegalHold = BaseEntity & {
  __typename?: 'LegalHold';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  matter?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['Long']['output']>;
  releasedByPersonId?: Maybe<Person>;
  scopeId?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a LegalHoldList query */
export type LegalHoldListResult = {
  __typename?: 'LegalHoldListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<LegalHold>>>;
  /** Total number of LegalHold records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Physical workplace location that positions can be assigned to */
export type Location = BaseEntity & {
  __typename?: 'Location';
  address?: Maybe<Address>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationType?: Maybe<Scalars['String']['output']>;
  parentLocationId?: Maybe<Location>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  address?: InputMaybe<AddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a LocationList query */
export type LocationListResult = {
  __typename?: 'LocationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Location>>>;
  /** Total number of Location records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Global metric definition (stored in global_data) */
export type Metric = BaseEntity & {
  __typename?: 'Metric';
  aggregation?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dataSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultAnchorHi?: Maybe<Scalars['Float']['output']>;
  defaultAnchorLo?: Maybe<Scalars['Float']['output']>;
  defaultDirection?: Maybe<Scalars['String']['output']>;
  defaultIdealValue?: Maybe<Scalars['Float']['output']>;
  defaultMaxDeviation?: Maybe<Scalars['Float']['output']>;
  defaultNormType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  dependsOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricType?: Maybe<Scalars['String']['output']>;
  minimumData?: Maybe<Scalars['String']['output']>;
  minimumDataThreshold?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  windowType?: Maybe<Scalars['String']['output']>;
};

export type MetricInput = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dataSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultAnchorHi?: InputMaybe<Scalars['Float']['input']>;
  defaultAnchorLo?: InputMaybe<Scalars['Float']['input']>;
  defaultDirection?: InputMaybe<Scalars['String']['input']>;
  defaultIdealValue?: InputMaybe<Scalars['Float']['input']>;
  defaultMaxDeviation?: InputMaybe<Scalars['Float']['input']>;
  defaultNormType?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  dependsOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  metricType?: InputMaybe<Scalars['String']['input']>;
  minimumData?: InputMaybe<Scalars['String']['input']>;
  minimumDataThreshold?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  windowType?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a MetricList query */
export type MetricListResult = {
  __typename?: 'MetricListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Metric>>>;
  /** Total number of Metric records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Every metric computed for one subject in one window */
export type MetricScore = BaseEntity & {
  __typename?: 'MetricScore';
  SEP?: Maybe<Scalars['String']['output']>;
  computedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metrics?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  rollsUpTo?: Maybe<BaseEntity>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
};

/** Global mindset registry entry */
export type Mindset = BaseEntity & {
  __typename?: 'Mindset';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type MindsetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a MindsetList query */
export type MindsetListResult = {
  __typename?: 'MindsetListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Mindset>>>;
  /** Total number of Mindset records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Long']['output']>;
  baseAmount?: Maybe<Scalars['Long']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type MoneyInput = {
  amount?: InputMaybe<Scalars['Long']['input']>;
  baseAmount?: InputMaybe<Scalars['Long']['input']>;
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Take a next move proposed to you: it becomes your aspiration and readiness is judged toward it now */
  acceptAspirationProposal: AspirationProposal;
  /** Acknowledge the version in force of a document that applies to the caller */
  acknowledgeDocumentVersion: DocumentAcknowledgement;
  /** Say you have read your shared review — not that you agree with it. Needs VIEW_REVIEW */
  acknowledgeReview: PerformanceReview;
  /** Take into an open session the reviews of its scope that became ready since it opened. Needs MANAGE_REVIEW and VIEW_ALL_REVIEW */
  addCalibrationReviews: CalibrationSession;
  /** Create a check-in on a key result — denormalizes previousValue and triggers progress rollup */
  addCheckIn?: Maybe<Scalars['JSON']['output']>;
  /** Create a comment on any entity — optional attachments (ACL-enforced) */
  addComment?: Maybe<Scalars['JSON']['output']>;
  /** Create a department (ACL-enforced) */
  addDepartment: Department;
  /** Create an initiative (ACL-enforced) */
  addInitiative?: Maybe<Scalars['JSON']['output']>;
  /** Create a job family (ACL-enforced) */
  addJobFamily: JobFamily;
  /** Create a job family group (ACL-enforced) */
  addJobFamilyGroup: JobFamilyGroup;
  /** Create a job profile (ACL-enforced) */
  addJobProfile: JobProfile;
  /** Add a key result under an objective — no downstream invalidation */
  addKeyResult?: Maybe<Scalars['JSON']['output']>;
  /** Create a location. Requires MANAGE_ORG_CHART. */
  addLocation: Location;
  /** Add an objective to the OKR; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  addObjective?: Maybe<Scalars['JSON']['output']>;
  /** Add an org to a COMPANY objective's cascadeOrgIds and eagerly invalidate cascade downstream */
  addOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Appends change items to a draft. Each item needs op, targetId, and changes (keyed by the op's field, e.g. {"parentOrgId": "..."}); optional rationale, reason and note (a UI-defined reason code, e.g. RESIGNED, on FILL_POSITION/VACATE_POSITION, MOVE_POSITION/SET_REPORTS_TO, SET_POSITION_STATUS to CLOSED, or DEACTIVATE/REACTIVATE/EXIT/REJOIN_PERSON; note is allowed on all of those) and state (SUGGESTED default, or ACCEPTED). The service captures each item's expected base from live state, merges items hitting an entity+field already in the draft, and drops values that are already live — the counts report exactly what happened. Requires MANAGE_ORG_CHART. */
  addOrgChangeItems: AddOrgChangeItemsResult;
  /** Create a position through the given draft: nothing is created yet — a CREATE_POSITION item lands in the draft and the returned position is transient (final id, null orgPath until the draft publishes) */
  addPosition: Position;
  /** Attach a strategy document to an OKR — Phase 2 */
  addStrategyInput?: Maybe<Scalars['JSON']['output']>;
  /** Add a theme to the OKR and eagerly invalidate downstream */
  addTheme?: Maybe<Scalars['JSON']['output']>;
  /** Create a user task (ACL-enforced) */
  addUserTask?: Maybe<Scalars['JSON']['output']>;
  /** Move one rating of a review in an open session — target OVERALL or a rated section's key, to a point of the cycle's scale — saying why, about this person's evidence: they read it once the review is shared. A move of two scale points or more cites at least one ledger entry. Never edited; undo with a move back. The session's facilitator or the review's reviewer */
  adjustReviewRating: RatingAdjustment;
  /** Write your note on an entry of your own ledger, replacing any note you wrote on it before; whoever sees the entry sees the note. Blank text removes it and returns null. personId must be you. Needs VIEW_FEEDBACK */
  annotateLedgerEntry?: Maybe<LedgerAnnotation>;
  /** Approve a version in review, publishing it */
  approveDocumentVersion: DocumentVersion;
  /** Archive a framework with its tracks and levels; needs MANAGE_CAREER_FRAMEWORK */
  archiveCareerFramework: CareerFramework;
  /** Withdraw a document; its retention starts if its type counts from archiving */
  archiveDocument: Document;
  /** Archive an entity — for Objective, recursively archives child objectives and key results; for OKRCycle, recursively archives descendant cycles (e.g. an annual cycle's quarterly children) */
  archiveEntity?: Maybe<Scalars['Boolean']['output']>;
  /** Archive a workspace (by full id); workspaces are never deleted. The Main workspace cannot be archived. Requires MANAGE_WORKSPACES. */
  archiveWorkspace: Workspace;
  /** Judge the person's next move now and write the verdict: toward targetLevelId when given, else toward their aspiration, else the next rung on their track. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  assessCareerReadiness: CareerReadiness;
  assignGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Scores one person in a model as one of its job profiles, whether or not they hold it — or hold any job profile at all. HR is unchanged. A person is in one model, so this replaces any override they hold in any model. Errors when the model is not enabled, the job profile is not in its jobProfiles[], or the region is not a REGION location. Requires MANAGE_PRODUCTIVITY_MODEL. */
  assignJobProfileOverride: JobProfileOverride;
  assignRoles?: Maybe<Scalars['Boolean']['output']>;
  /** Abandon a draft or open session: its reviews are released to another session, its asks cancelled and its adjustments kept. Needs MANAGE_REVIEW and VIEW_ALL_REVIEW */
  cancelCalibrationSession: CalibrationSession;
  /** Cancel an open signature request; its signers are told by the provider */
  cancelDocumentSignatureRequest: SignatureRequest;
  /** Withdraw the invite of someone who has not accepted it, through the given draft: a VACATE_POSITION item per seat they hold plus CANCEL_INVITE. At publish the seats empty, then — after every other item — the Lyearn user is removed and the person deleted here. Cannot be undone, and left out of reverts. Refused for someone who already accepted; for someone this draft itself invites, remove that invite instead. Requires MANAGE_ORG_CHART. */
  cancelInvite: AddOrgChangeItemsResult;
  /** Abandon a cycle not yet over: its reviews and tasks are cancelled. Needs MANAGE_REVIEW */
  cancelReviewCycle: ReviewCycle;
  /** Raise or lower a document's classification */
  changeDocumentClassification: Document;
  /** Run the consistency check on the review you write, as saved: rating vs evidence, recency, ignored feedback, halo, uncited claims and language. Flags never block; they are stored on the review and never shown to the person. Needs VIEW_REVIEW */
  checkReview: PerformanceReview;
  clearFunctionalPermissions?: Maybe<Scalars['Boolean']['output']>;
  /** Close an ACTIVE candidate who will not join, as DECLINED or WITHDRAWN; the documents about them are archived. Requires MANAGE_ORG_CHART. */
  closeCandidate: Candidate;
  /** End an open or sharing cycle: reviews never submitted are kept as NOT_COMPLETED, and every open task of it is cancelled. Needs MANAGE_REVIEW */
  closeReviewCycle: ReviewCycle;
  commitImport: ImportJob;
  /** Validates the CSV again and, only if it has no errors, adds its rows to the draft as accepted items — INVITE_PERSON, SET_PERSON_*, DEACTIVATE_PERSON, REACTIVATE_PERSON. Nothing reaches Lyearn until the draft publishes. With errors, committed is false and nothing is added. Requires MANAGE_ORG_CHART. */
  commitPeopleImport: PeopleImportCommit;
  /** Complete the auth flow after the user returns: the backend fetches the created connection from the provider and activates it. */
  completeConnectionAuth?: Maybe<IntegrationConnectionSummary>;
  /** Save the organisation's own account with a signing provider; a secret left out keeps what is stored. Needs MANAGE_CONFIG */
  configureSignatureProvider: SignatureProviderSetup;
  /** Confirm that a browser upload completed. Transitions the pending file to AVAILABLE and records its size. */
  confirmBrowserUpload?: Maybe<StoredFile>;
  /** Bring a calibrated review's text in line with the ratings calibration moved, and confirm it; sharing waits for this. answers: as saveReview's, replacing yours; ratings do not change here. The reviewer, or VIEW_ALL_REVIEW. Needs VIEW_REVIEW */
  confirmCalibratedReview: PerformanceReview;
  /** Confirm human-reviewed extraction result — Phase 2 */
  confirmExtraction?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm company knowledge base is healthy — Phase 1; advances OKR from PENDING to KNOWLEDGE_CONFIRMED */
  confirmKnowledgeHealth?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm objective-to-org assignments and grant OKR_VIEWER to assigned orgs — Phase 7 */
  confirmOrgAssignments?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm the leader's answers to the strategy questions — Phase 2; packages the Q&A transcript into a synthetic STRATEGY_QA strategy input and runs it through the ordinary extraction pipeline, returning the created StrategyInput */
  confirmStrategyQuestions?: Maybe<Scalars['JSON']['output']>;
  /** Confirm the leader's answers to clarifying questions (may be empty) — Phase 4; advances to QUESTIONS_CONFIRMED */
  confirmThemeAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm human-edited theme list — Phase 3 */
  confirmThemes?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm human-reviewed top objectives — Phase 6; advances to TOP_CONFIRMED */
  confirmTopObjectives?: Maybe<Scalars['Boolean']['output']>;
  /** Add someone being hired, before they are a person: displayName and primaryEmail are required; primaryPhone and expectedJoiningDate (epoch millis) are optional. Documents such as an offer letter can then be issued about them. Requires MANAGE_ORG_CHART. */
  createCandidate: Candidate;
  /** Create a document; its first version is uploaded separately */
  createDocument: Document;
  /** Create a folder at a library's root or inside another folder */
  createDocumentFolder: DocumentFolder;
  /** Create a library — SHARED, or SUBJECT_FILES with the entity types its documents are about (Person, a case, …); the caller becomes its Manager */
  createDocumentLibrary: DocumentLibrary;
  /** Link a document to an entity it governs, describes or evidences; grants no access */
  createDocumentLink: DocumentLink;
  /** Create and schedule an async export job */
  createExportJob?: Maybe<Scalars['JSON']['output']>;
  /** Create a binding: one connector feed -> one target, through a connection. */
  createIntegration?: Maybe<Integration>;
  /** Create an OKR planning period for the tenant (cadence-aware; at most 3 upcoming root periods). Optional year/quarter target a fiscal period using Company.fiscalYearStartMonth; omit both to auto-advance. */
  createOKRCycle?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Create OKR shell(s) with cadence validation — auto-creates quarterly child shells for ORG OKRs on annual cycles with QUARTERLY_WITH_ANNUAL cadence; rejects direct quarterly ORG OKR creation under that cadence */
  createOKRShells?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Create an org through the given draft: nothing is created yet — a CREATE_ORG item lands in the draft and the returned org is transient (final id, null path/depth until the draft publishes). Root orgs omit parentOrgId. Requires MANAGE_ORG_CHART. */
  createOrg: Org;
  /** Branches a new, empty ADMIN change set from the current published truth. Multiple admin drafts may be open concurrently. Requires MANAGE_ORG_CHART. */
  createOrgChangeSet: OrgChangeSet;
  createRole?: Maybe<App_Role>;
  /** Create a smart folder in a library; the caller owns it */
  createSmartFolder: SmartFolder;
  createUserGroup?: Maybe<UserGroup>;
  /** Create an active workspace. code is its short, unique, permanent key (its entityId): 2-16 letters, digits or _, no spaces or hyphens; GLOBAL, ALL and system are reserved. The user service gets a sub-workspace with the code as its id. Requires MANAGE_WORKSPACES. */
  createWorkspace: Workspace;
  /** Turn off a person's access through the given draft (DEACTIVATE_PERSON). At publish Lyearn is set to archived, with personStatus (SUSPENDED or ON_LEAVE) in the Lyearn user's meta, and the person here to personStatus. Left out, it is a plain deactivate: ARCHIVED, nothing in meta. Their seat and employment are untouched. Refused for someone still invited or already deactivated. Requires MANAGE_ORG_CHART. */
  deactivatePerson: AddOrgChangeItemsResult;
  /** Keep your own aspiration; the proposer reads your reason */
  declineAspirationProposal: AspirationProposal;
  /** Decline a pending request addressed to you; reason is optional and the requester may read it. Needs VIEW_FEEDBACK */
  declineFeedbackRequest: FeedbackRequest;
  /** Soft-deletes the chat. Requires DELETE on the session (USE_AGENT_CHAT — owner or share); it disappears from myAgentChats. Refused while the agent is executing. */
  deleteAgentChat: Scalars['Boolean']['output'];
  /** Permanently delete an AnalyticsView by ID */
  deleteAnalyticsView?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a check-in and trigger progress rollup */
  deleteCheckIn?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a comment (ACL-enforced) */
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  /** Permanently delete a Dashboard by ID */
  deleteDashboard?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a department (ACL-enforced) */
  deleteDepartment?: Maybe<Scalars['Boolean']['output']>;
  /** Remove an empty authored folder — no sub-folder, document or document type still points at it. Refused under a legal hold. The folder is soft-deleted */
  deleteDocumentFolder: Scalars['Boolean']['output'];
  /** Soft-delete an initiative (ACL-enforced) */
  deleteInitiative?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a binding by id. */
  deleteIntegration?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job family (ACL-enforced) */
  deleteJobFamily?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job family group (ACL-enforced) */
  deleteJobFamilyGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job profile (ACL-enforced) */
  deleteJobProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a key result — no downstream invalidation */
  deleteKeyResult?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a location. Fails when positions still reference it. Requires MANAGE_ORG_CHART. */
  deleteLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete an objective and its descendants; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  deleteObjective?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an org through the given draft: an ARCHIVE_ORG item lands in the draft — delete is archive, the org stays live until publish, and publish conflicts while it has active child orgs or positions. Requires MANAGE_ORG_CHART. */
  deleteOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a position through the given draft: an ARCHIVE_POSITION item lands in the draft — delete is archive; the seat stays live until the draft publishes */
  deletePosition?: Maybe<Scalars['Boolean']['output']>;
  /** Remove one of this organisation's own qualifications; needs MANAGE_QUALIFICATION_CATALOG */
  deleteQualification: Scalars['Boolean']['output'];
  /** Delete a template; cycles saved from it keep their copy. Needs MANAGE_REVIEW */
  deleteReviewTemplate: Scalars['Boolean']['output'];
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  /** Removes one of the caller's own routines by routineId (document id or bare entity id). MANAGE_ROUTINE required. */
  deleteRoutine: Scalars['Boolean']['output'];
  /** Soft-delete a salary document (ACL-enforced) */
  deleteSalary?: Maybe<Scalars['Boolean']['output']>;
  /** Remove one of this organisation's own skills; needs MANAGE_SKILL_CATALOG */
  deleteSkill: Scalars['Boolean']['output'];
  /** Remove one of this organisation's own skill groups; needs MANAGE_SKILL_CATALOG */
  deleteSkillGroup: Scalars['Boolean']['output'];
  /** Delete a smart folder; its documents are untouched */
  deleteSmartFolder: Scalars['Boolean']['output'];
  /** Delete a file from cloud storage and soft-delete the StoredFile entity. */
  deleteStoredFile?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a strategy input and eagerly invalidate all downstream artifacts */
  deleteStrategyInput?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-deletes an authored agent. Sessions bound to its code stop resolving. USE_CUSTOM_AGENT required. */
  deleteTenantAgent: Scalars['Boolean']['output'];
  /** Soft-deletes the caller's authored workflow. It leaves their library at once, and its routines are removed with it. USE_CUSTOM_WORKFLOW required. */
  deleteTenantWorkflow: Scalars['Boolean']['output'];
  /** Delete a theme from the OKR and eagerly invalidate downstream */
  deleteTheme?: Maybe<Scalars['Boolean']['output']>;
  deleteUserGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a user task (ACL-enforced) */
  deleteUserTask?: Maybe<Scalars['Boolean']['output']>;
  /** The user's "drop it" on a result held for review (status REVIEW): nothing reaches Actions, an artifact the run created (a change set) is discarded. A chat goes back to OPEN with no result; a run record ends DISCARDED with its result kept as history. Same chatId rule as sendAgentChatResultToActions. */
  discardAgentChatResult: Agent_Chat_Session;
  /** Delete a draft that was never published, with its tracks and levels — how a career path an agent drafted is turned down from Actions. Refused unless the framework is DRAFT, and while an AI step is drafting it; a published one leaves use by archiveCareerFramework. Returns true. Needs MANAGE_CAREER_FRAMEWORK */
  discardCareerFrameworkDraft: Scalars['Boolean']['output'];
  /** Discards an admin draft without applying anything. Standing AGENT/SYNC lanes and the per-person draft are cleared and re-based instead of discarded, and stay drafts. Requires MANAGE_ORG_CHART. */
  discardOrgChangeSet?: Maybe<Scalars['Boolean']['output']>;
  /** Undo the profile scans for a person who says they found someone else: removes the rows still as a scan wrote them (discovered) and blanks the profile fields still holding what it filled (discoveredFields). Anything edited since stays. Refused while a scan is in flight. Afterwards the profile reads as a scan that found nothing: an unforced triggerPersonProfile waits for the cooldown or a profile edit, so rescan with force once the person gives a new LinkedIn or GitHub. Returns how many rows it removed. Same callers as triggerPersonProfile. */
  discardPersonProfile?: Maybe<Scalars['Int']['output']>;
  /** Dismiss a flag on the review you write, saying why; it stays dismissed while the check raises it. Needs VIEW_REVIEW */
  dismissReviewFlag: PerformanceReview;
  /** Draft one section of your own part — your self-review, or the review you write — from evidence the person can see. Every sentence cites; a question the evidence does not speak to gets no draft; nothing is rated. Copy what you keep into your answers and save: an answer kept word for word needs a rationale to submit. Empty when no model is configured; refused when the cycle turns drafting off. Needs VIEW_REVIEW */
  draftReviewSection: Array<PerformanceReviewDraft>;
  /** Edit a check-in — triggers progress rollup when newValue changes */
  editCheckIn?: Maybe<Scalars['JSON']['output']>;
  /** Edit a clarifying question's answer and eagerly invalidate downstream */
  editClarificationAnswer?: Maybe<Scalars['Boolean']['output']>;
  /** Edit a comment — body, mentions, attachments, status, or resolve state (ACL-enforced) */
  editComment?: Maybe<Scalars['JSON']['output']>;
  /** Edit a department (ACL-enforced) */
  editDepartment: Department;
  /** Edit an initiative (ACL-enforced) */
  editInitiative?: Maybe<Scalars['JSON']['output']>;
  /** Edit a job family (ACL-enforced) */
  editJobFamily: JobFamily;
  /** Edit a job family group (ACL-enforced) */
  editJobFamilyGroup: JobFamilyGroup;
  /** Edit a job profile (ACL-enforced) */
  editJobProfile: JobProfile;
  /** Edit a key result — no downstream invalidation */
  editKeyResult?: Maybe<Scalars['JSON']['output']>;
  /** Edit a location. Requires MANAGE_ORG_CHART. */
  editLocation: Location;
  /** Edit an objective; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  editObjective?: Maybe<Scalars['JSON']['output']>;
  /** Edit a position through the given draft: nothing is written — each field becomes a reviewable change item (editable: displayName, description, orgId, reportsToPositionId, personId, locationId, jobProfileId, status) and the returned position is the live one with the draft's changes overlaid */
  editPosition: Position;
  /** Edit a strategy input and eagerly invalidate all downstream artifacts */
  editStrategyInput?: Maybe<Scalars['JSON']['output']>;
  /** Edit a theme on the OKR and eagerly invalidate downstream */
  editTheme?: Maybe<Scalars['JSON']['output']>;
  /** Edit a user task (ACL-enforced) */
  editUserTask?: Maybe<Scalars['JSON']['output']>;
  /** Returns the standing open change set for a system lane (AGENT or SYNC), creating it when absent. Admin change sets are created with createOrgChangeSet. Requires MANAGE_ORG_CHART. */
  ensureOrgChangeSet: OrgChangeSet;
  /** The execute button. Flips the session to EXECUTING and runs the agent's work product in the background; returns immediately — poll agentChat for the result, or use POST /agent-chat/{chatId}/execute to stream it instead. The run ends REVIEW: the result is shown in the chat and held there until the user sends it to Actions, drops it, or executes again (which replaces it). The chat stays conversable throughout, EXECUTED included. */
  executeAgentChat: Agent_Chat_Session;
  /** End a person's employment, or put them on notice, through the given draft. personStatus TERMINATED (default): a VACATE_POSITION item per seat they hold plus EXIT_PERSON; at publish the seats empty, exitDate is set (default now, not in the future), access is turned off (archived in Lyearn, TERMINATED in its user meta) and their status here becomes TERMINATED. personStatus ON_NOTICE: one NOTICE_PERSON item; at publish their status here becomes ON_NOTICE with exitDate (optional, may be in the future) as the planned last day, ON_NOTICE goes in the Lyearn user meta, and their Lyearn status, access and seats are untouched — exit them as TERMINATED later to finish. reason is a UI-defined code — RESIGNED records a resignation, anything else a termination. Requires MANAGE_ORG_CHART. */
  exitPerson: AddOrgChangeItemsResult;
  /** Add skills to a shipped group (additions: {skillId: weight}) and leave shipped members out (exclusions), for this organisation only; replaces the earlier extension, both empty removes it; needs MANAGE_SKILL_CATALOG */
  extendSkillGroup: SkillGroup;
  /** Finalise an open session: its reviews are calibrated, and the reviewer of each whose rating moved is asked to confirm its text before it can be shared. Needs MANAGE_REVIEW and VIEW_ALL_REVIEW */
  finaliseCalibrationSession: CalibrationSession;
  /** The entry this name already is among its kind's in the catalog — a degree among degrees (EDUCATION), a certification or licence among both — by name or alias, or under another spelling; else a new one of this organisation's of that kind, with issuer for a certification or licence. Anyone may call it */
  findOrAddQualification: Qualification;
  /** The skill this name already is in the catalog — by name or alias, or under another spelling ("React.js" is React, "Figma (Software)" is Figma) — else a new one of this organisation's under the name. Anyone may call it; refused when the skill found has been turned off */
  findOrAddSkill: Skill;
  /** Issue a letter from its type's template into its subject's Employee File — a person's, or a candidate's before they join — exactly as previewed */
  generateDocument: DocumentVersion;
  /** Record feedback about a person. kind: PRAISE, CONSTRUCTIVE, RESPONSE (answers requestId) or REFLECTION (about yourself). visibility: SHARED (default) or MANAGER_ONLY. skillRatings: [{targetId, targetType: SKILL|SKILL_GROUP, band: NOT_OBSERVED|AWARENESS|WORKING|PROFICIENT|EXPERT}]. suggestedSkillIds: the coach's suggestions the giver kept but did not rate; they count for nothing. The relationship is read from the reporting line. Needs VIEW_FEEDBACK */
  giveFeedback: PersonFeedback;
  grantTypePermission?: Maybe<Scalars['Boolean']['output']>;
  /** Initiate a browser-direct upload. Returns a BrowserUploadSession with a presigned URL (uploadMode: DIRECT) or a SERVER_PROXY session for encrypted tenants. */
  initBrowserUpload?: Maybe<BrowserUploadSession>;
  /** Start an auth flow for a source type (e.g. WORKDAY). Returns a pending connection id and a URL to redirect the user to. The UI never sees the provider. */
  initiateConnectionAuth?: Maybe<ConnectionAuthStart>;
  /** Invite a person through the given draft: nothing is invited yet — an INVITE_PERSON item lands in the draft and the returned person is transient (status INVITED; its id is the draft's placeholder, e.g. acme::Person::e-1042-3f9a2c, and it has no entityId — the real ones exist only once the draft publishes, so updatePersonDetails takes it only to edit this draft's invite). The invite email and the real Person record are created only when the draft publishes; discarding the row sends nothing. Editable input fields: displayName, primaryEmail, personType (required); personCode, primaryPositionId (omit for "Decide later"), managerPersonId (only takes effect when primaryPositionId is omitted — seating the person derives their manager from that seat's reporting line instead; referencing another person invited in the same draft is refused, they have no real id until publish), primaryPhone (E.164 format, e.g. "+919876543210"), dateOfBirth (epoch millis), gender (a Gender picklist name), locationId, workMode (a WorkMode picklist name: OFFICE, HYBRID, REMOTE, or FIELD), permanentAddress (an Address object — street/city/state/postalCode/country — stored on Person); social links linkedinUrl, slackUrl, githubUrl, currentAddress (same Address shape, stored on PersonProfile instead, like the social links), and personalEmail (an email address, distinct from the primaryEmail login; also stored on PersonProfile) (all optional). Lyearn details: departmentId (a Department), orgRoleId (the designation, an OrgRole), profilePicture (an http(s) URL), tags ({tagId: [values]} — option ids for select tags, one text or number otherwise; date tags are not supported). Access, assigned right after the invite: roleIds (App_Role ids, needs MANAGE_ROLES), groupIds (UserGroup ids, needs MANAGE_USER_GROUPS); roleId and userGroupId (or groupId) are accepted for one of each. candidateId (a Candidate's id) hires that candidate: the documents filed about them move to the new person, and the candidate is closed as HIRED. A role, group, picture or candidate's documents that fail to apply leave the person invited, with a warning in the item's error. Requires MANAGE_ORG_CHART. */
  invitePerson: Person;
  /** Launch a draft: its window and steps are checked, its template's settings frozen, and its reviews written by a job, during which it is LAUNCHING. Needs MANAGE_REVIEW */
  launchReviewCycle: ReviewCycle;
  linkRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Clear the AI-draft mark from levels, or from every level when levelIds is empty. Needs MANAGE_CAREER_FRAMEWORK */
  markCareerLevelsReviewed: CareerFramework;
  /** Record that the caller confirmed the document is still accurate */
  markDocumentReviewed: Document;
  /** Move a document to another folder or library */
  moveDocument: Document;
  /** Move a record's folder under another top-level folder of its library (an employee's transfer) */
  moveSubjectDocumentFolder: DocumentFolder;
  /** Make a folder stop inheriting its library's access and hold its own grants */
  narrowDocumentFolder: DocumentFolder;
  /** Ask the colleagues you chose for feedback on a skill a readiness verdict of yours is short of, completing the verdict's 'ask colleagues' task. Yours only */
  nominatePeers: Array<FeedbackRequest>;
  /** Ask colleagues for feedback for a review — the person reviewed, or their reviewer, until peers are due. Each is a feedback request with the cycle as its context; never more than the cycle's maximum per review. Needs VIEW_REVIEW */
  nominateReviewPeers: Array<FeedbackRequest>;
  /** The facilitator's minutes, read by participants and HR, never by the people reviewed; blank clears them */
  noteCalibrationSession: CalibrationSession;
  /** Open a draft session: it takes the reviews of its scope that are submitted, signed off where asked, and in no other session — at most 150 — and asks their reviewers and the other participants to it. The cycle must require calibration. Needs MANAGE_REVIEW and VIEW_ALL_REVIEW */
  openCalibrationSession: CalibrationSession;
  /** Preserve a document, library or folder and everything under it for a legal matter */
  placeLegalHold: LegalHold;
  /** Suggest a next move to someone below you in the reporting line (VIEW_TEAM_CAREER) or anyone (VIEW_ALL_CAREER). Their aspiration changes only if they accept. note says why it fits and they read it; one pending proposal per person */
  proposeCareerAspiration: AspirationProposal;
  /** Build with AI: create a DRAFT framework from an instruction and an optional uploaded file, and queue a step that suggests the name, job profiles, track (CareerAITrack), requirement strictness and the instruction for later steps. Returns at once. Poll careerFrameworkAI until SUCCEEDED — step is PROPOSE — then read the framework and that state. Next, runCareerFrameworkAIStep(LEVELS); do not call start for this draft. Needs MANAGE_CAREER_FRAMEWORK */
  proposeCareerFrameworkAI: CareerFramework;
  /** Publish a whole ladder ({framework, tracks, levels}); on any error nothing is written and the report says why. Needs MANAGE_CAREER_FRAMEWORK */
  publishCareerLadder: CareerLadderReport;
  /** Publish a draft version of a published document */
  publishDocumentVersion: DocumentVersion;
  /** Fire async publish of the OKR tree after human review — grants deferred assignee/org-viewer permissions in the background; poll via pollPublish */
  publishOKR?: Maybe<Scalars['Boolean']['output']>;
  /** Publish one or more objectives and their descendant objectives (via parentObjectiveId) */
  publishObjective?: Maybe<Scalars['Boolean']['output']>;
  /** Publishes a draft: preflights every ACCEPTED item against live state (including cross-item cycle checks) and only when all pass applies them through the typed org services. On success the change set becomes PUBLISHED as the next org version. On conflict, the failing items are flagged and nothing applies — review or rebase, then retry. Requires MANAGE_ORG_CHART. */
  publishOrgChangeSet: OrgChangeSet;
  /** The one-call write path for lane writers (HRIS sync, reconciliation agent): resolves the standing AGENT or SYNC lane (creating it when absent) and appends the items to it — writers never create or manage a changeset. Same item shape and merge/drop semantics as addOrgChangeItems; push naively and repeatedly, the counts report what happened. Requires MANAGE_ORG_CHART. */
  pushOrgChangeItems: AddOrgChangeItemsResult;
  /** Thumbs on one transcript turn. Owner-only. true is up, false is down, omit or pass null to clear. Select feedback on messages to read it back. */
  rateAgentChatMessage: Agent_Chat_Message;
  /** Turn a deactivated person's access back on through the given draft (REACTIVATE_PERSON; status ACTIVE at publish). For someone who has left, use rejoinPerson. Requires MANAGE_ORG_CHART. */
  reactivatePerson: AddOrgChangeItemsResult;
  /** Hand an unsubmitted review to another reviewer; what was written stays, marked as its writer's. Needs VIEW_ALL_REVIEW */
  reassignReviewer: PerformanceReview;
  /** Rebases a draft onto the current published truth: every open item's expected base is re-captured and re-preflighted, superseded items are auto-dismissed, and resolved conflicts flip back to ACCEPTED. Use after another change set publishes. Requires MANAGE_ORG_CHART. */
  rebaseOrgChangeSet: OrgChangeSet;
  /** Recommend the person you review for a career level, or withdraw it (recommended false), until you submit. The latest readiness verdict toward the level is cited; recommending against unmet gates, or with no verdict, needs a rationale. The person never sees it; a promotion made later through an org change set cites this review. Needs VIEW_REVIEW */
  recommendPromotion: PerformanceReview;
  refreshUserGroup?: Maybe<UserGroupRefresh>;
  /** Turn down a draft, a version in review or a pending upload, with an optional note */
  rejectDocumentVersion: DocumentVersion;
  /** Bring back someone who has left, through the given draft (REJOIN_PERSON). At publish exitDate is cleared and access turned back on; their original hireDate is kept and the return is recorded as a rehire. Someone on notice has not left: for them this withdraws the notice instead (WITHDRAW_NOTICE) — status ACTIVE and the planned exitDate cleared at publish, no rehire. Seats are not restored — fill one with FILL_POSITION. Requires MANAGE_ORG_CHART. */
  rejoinPerson: AddOrgChangeItemsResult;
  /** Release a legal hold; the record stays */
  releaseLegalHold: LegalHold;
  /** Remove a document link */
  removeDocumentLink: Scalars['Boolean']['output'];
  /** Remove an org from a COMPANY objective's cascadeOrgIds and eagerly invalidate cascade downstream */
  removeOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Removes an unapplied item from a draft. Requires MANAGE_ORG_CHART. */
  removeOrgChangeItem: OrgChangeSet;
  /** Remove a qualification, under the same ownership rule as editing it. */
  removePersonQualification?: Maybe<Scalars['Boolean']['output']>;
  /** Remove one claim. source defaults to the caller's (SELF, MANAGER or HR); the person and a direct manager remove only their own source's, an admin any. False when there was no such claim. */
  removePersonSkill?: Maybe<Scalars['Boolean']['output']>;
  /** Remove the organisation's own account with a signing provider. Needs MANAGE_CONFIG */
  removeSignatureProviderSetup: SignatureProviderSetup;
  /** Sets the chat's displayName (middle-rail title). Requires UPDATE on the session (USE_AGENT_CHAT — owner or share). The first user message auto-titles the chat unless it has already been renamed. */
  renameAgentChat: Agent_Chat_Session;
  /** Rename an authored folder. A subject's folder and its kind sub-folders are named by the system */
  renameDocumentFolder: DocumentFolder;
  /** Renames an open admin draft — the title shown in the drafts list. The standing AGENT/SYNC lanes keep their names; published and discarded change sets are immutable. Requires MANAGE_ORG_CHART. */
  renameOrgChangeSet: OrgChangeSet;
  /** Re-sequence a target's bindings; index becomes precedence. */
  reorderIntegrations?: Maybe<Array<Integration>>;
  /** Move an org under a new parent through the given draft — a REPARENT_ORG item lands in the draft; at publish, path and depth are rewritten on the moved node and every ACTIVE descendant, and the moved org's head position is updated to report to the new parent's manager. Requires MANAGE_ORG_CHART functional permission. */
  reparentOrg: Org;
  /** Queue a readiness run over everyone on a ladder (every active ladder when frameworkId is null); returns the job trigger id. Needs VIEW_ALL_CAREER */
  requestCareerReadinessRun: Scalars['ID']['output'];
  /** Send a document's version in force out for signature through a provider, to signers in order */
  requestDocumentSignatures: SignatureRequest;
  /** Ask people for feedback about a person — yourself, someone in your reporting line, or anyone with VIEW_ALL_FEEDBACK. A recipient already asked about any of the same skills is not asked again; their pending request is returned instead. dueAt is epoch ms, two weeks out when null. Needs VIEW_FEEDBACK */
  requestFeedback: Array<FeedbackRequest>;
  /** Ask your direct manager to verify one of your unverified public work entries (ARTICLE, TALK, OPEN_SOURCE, PORTFOLIO, PRESS); HR verifies other types from its queue. False when they already have the ask open */
  requestQualificationVerification: Scalars['Boolean']['output'];
  /** Ask your direct manager to attest a skill you claimed — needs your own claim on it first. False when they already have the ask open */
  requestSkillAttestation: Scalars['Boolean']['output'];
  /** Resend the invite email to everyone who has not accepted it yet. Requires MANAGE_ORG_CHART. */
  resendAllPendingInvites: Scalars['Boolean']['output'];
  /** Resend the invite email to people who have not accepted it yet. With one person, fails if they already accepted; with several, those are skipped. Requires MANAGE_ORG_CHART. */
  resendInvites: Scalars['Boolean']['output'];
  /** Delete the tenant's copy and return the enum defaults */
  resetExtensibleField: ExtensibleField;
  /** Files a draft as ACCEPTED (acted on) or DISMISSED (not worth acting on), which takes it out of the Actions queue. Nothing is deleted and a draft cannot be reopened. An optional comment is kept on the draft as reviewComment: open the Workflow Builder with the draft id as subjectRef afterwards and it reads the run's output and the comment, and proposes the amendment. */
  resolveAgentDraft: Agent_Draft;
  /** Respond to your shared review, until the cycle closes; blank text clears it. Needs VIEW_REVIEW */
  respondToReview: PerformanceReview;
  /** Restore an archived framework as a draft: its status goes back to DRAFT, and its tracks and levels with it; publish it to bring it back into use. Refused unless the framework is archived; needs MANAGE_CAREER_FRAMEWORK */
  restoreCareerFramework: CareerFramework;
  /** Retract feedback you gave; it leaves every later read. Needs VIEW_FEEDBACK */
  retractFeedback: PersonFeedback;
  /** Runs a FAILED workflow run again on the same record: the run flips back to EXECUTING and runs in the background — poll agentChat for the result, or use POST /agent-chat/{chatId}/retry to stream it. Only a workflow run (not a conversation) and only while FAILED. Requires the workflow's permission. */
  retryWorkflowRun: Agent_Chat_Session;
  /** Builds a new ADMIN draft that returns the org to a previous version: the derived inverses of everything published after it, newest first. Items whose targets drifted since are flagged for review instead of pre-accepted. Publish the returned draft to complete the revert. Requires MANAGE_ORG_CHART. */
  revertOrgToVersion: OrgChangeSet;
  /** Builds a new ADMIN draft undoing a single published version (cherry-pick undo). Publish the returned draft to complete the revert. Requires MANAGE_ORG_CHART. */
  revertOrgVersion: OrgChangeSet;
  revokeShare?: Maybe<Scalars['Boolean']['output']>;
  revokeTypePermission?: Maybe<Scalars['Boolean']['output']>;
  /** Queue an AI step — PROPOSE, LEVELS, DEFINITIONS or MOVES — on the ladder as last saved. It fills only what is missing; regenerate redoes the whole step. Refused while a step runs. Needs MANAGE_CAREER_FRAMEWORK */
  runCareerFrameworkAIStep: CareerFramework;
  /** Run now: one headless run of a workflow as the caller, with values for its inputs (by name; omit to take defaults — a required input with no value is refused here, before anything runs). Returns the run's session already EXECUTING and runs it in the background — poll agentChat for the result, or use POST /agent-chat/workflows/{code}/run to stream it instead. The result lands in Actions like any agent's. Requires the workflow's permission. */
  runWorkflow: Agent_Chat_Session;
  saveActivity?: Maybe<Activity>;
  saveAgent_Action?: Maybe<Agent_Action>;
  saveAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  /** Create or update a tenant-scoped AnalyticsView */
  saveAnalyticsView?: Maybe<Scalars['JSON']['output']>;
  saveArtifact?: Maybe<Artifact>;
  /** Create a draft session for a cycle (id null) or replace a draft's setup. The scope lists match people in any of their values, and levelIds the level each review opened at; an empty list matches anyone. facilitatorPersonId null is the caller; participantPersonIds are asked besides the reviewers, who join as their reviews do. Needs MANAGE_REVIEW and VIEW_ALL_REVIEW */
  saveCalibrationSession: CalibrationSession;
  /** Save a whole ladder ({framework, tracks, levels}) that is not in use (never published, or restored from archive), as a DRAFT framework; only keys and track membership are checked. Refused while the framework is ACTIVE or ARCHIVE. Needs MANAGE_CAREER_FRAMEWORK */
  saveCareerLadderDraft: CareerLadderReport;
  /** Publishes the signed-in person's standing draft without publishing that document. Copies its items onto a new change set, publishes the copy, and clears the person's draft only when that publish succeeds. On success this returns the published change set — keep editing through getChangeSetForUser, whose id does not change. On conflict or a failed apply, nothing stays applied, the copy is removed, and this returns the person's draft with the failure on its items. Requires MANAGE_ORG_CHART. */
  saveChangeSetForUser: OrgChangeSet;
  saveChatBucket?: Maybe<ChatBucket>;
  saveCompany?: Maybe<Company>;
  saveCompanyKnowledge?: Maybe<CompanyKnowledge>;
  /** Create or update a tenant-scoped Dashboard */
  saveDashboard?: Maybe<Scalars['JSON']['output']>;
  /** Create or update a required-document rule; who owes it follows on the next daily pass */
  saveDocumentRequirement: DocumentRequirement;
  /** Create or update a document type in the catalog */
  saveDocumentType: DocumentType;
  saveEdge?: Maybe<Edge>;
  saveExportJobHistory?: Maybe<ExportJobHistory>;
  /** Replace one extensible field's options and custom attributes */
  saveExtensibleField: ExtensibleField;
  saveGoal?: Maybe<Goal>;
  saveIdentityLink?: Maybe<IdentityLink>;
  saveInteraction?: Maybe<Interaction>;
  saveKnowledgeNode?: Maybe<KnowledgeNode>;
  saveMetric?: Maybe<Metric>;
  saveMindset?: Maybe<Mindset>;
  saveNote?: Maybe<Note>;
  saveNotification?: Maybe<Notification>;
  saveNotification_Delivery?: Maybe<Notification_Delivery>;
  saveNotification_Outbox?: Maybe<Notification_Outbox>;
  saveNotification_Preference?: Maybe<Notification_Preference>;
  saveNotification_Template?: Maybe<Notification_Template>;
  /** Create or update an OKR */
  saveOkr?: Maybe<Okr>;
  saveOrgRole?: Maybe<OrgRole>;
  saveOutcome?: Maybe<Outcome>;
  savePerson?: Maybe<Person>;
  savePersonKnowledge?: Maybe<PersonKnowledge>;
  /** Create a qualification, or edit one when input.id is set. Keys: type, name, issuer, credentialId, validFrom, validTo (epoch ms), datePrecision (YEAR, MONTH or DAY), documentRef, attributes, url, skillIds, description, companyDomain, employmentType, location, current, role. type and name are required. Editing a date without datePrecision clears it. EMPLOYMENT also requires issuer. employmentType is FULL_TIME, PART_TIME, CONTRACTOR or INTERN, and a current position has no validTo. Public work uses ARTICLE, TALK, OPEN_SOURCE, PORTFOLIO or PRESS, with the title in name, the publisher in issuer and the person's part in role. The person may edit only rows they claimed themselves (source SELF). qualificationId may be sent back as read and is ignored: the save links the row to the catalog itself. */
  savePersonQualification?: Maybe<PersonQualification>;
  /** Claim a skill at a proficiency (AWARENESS, WORKING, PROFICIENT, EXPERT). Recorded as SELF when it is the caller's own record, MANAGER when the caller is the person's direct manager, HR when an admin's; replaces that source's earlier claim on the skill and leaves other sources' alone. evidenceRefs: full ids of what the claim rests on — feedback about the person, their credentials, a readiness verdict (max 20). */
  savePersonSkill?: Maybe<PersonSkill>;
  /** Save (or clear) the current user's layout/filter override for one dashboard. */
  saveProductivityDashboard?: Maybe<Scalars['JSON']['output']>;
  /** Saves the model editor's whole edited definition over the tenant's copy, validated as enablement validates it. Fails if the copy changed since its version was read, if the ontology changed, or if an override still scores people as a job profile it removes. The copy's agents are kept as they are; any agents sent are ignored. Requires MANAGE_PRODUCTIVITY_MODEL. */
  saveProductivityModelDefinition: ProductivityModelDefinition;
  /** Create or update one of this organisation's own qualifications (by id): displayName, kind, issuer, category, aliases, description, enabled; a shipped qualification is read-only; needs MANAGE_QUALIFICATION_CATALOG */
  saveQualification: Qualification;
  saveRawChat?: Maybe<RawChat>;
  saveResource?: Maybe<Resource>;
  /** Save the review you write. answers: [{sectionKey, questionKey, text, citations: [ledger entry ref], rationale}], one per question you answer; a save replaces your whole part. rationale says why drafted text stands unchanged. sectionRatings: {sectionKey: rating} for area and level sections; ratings are points of the cycle's scale. Needs VIEW_REVIEW */
  saveReview: PerformanceReview;
  /** Create a draft cycle (id null) or replace a draft's setup. Times are epoch ms. The audience lists match people in any of their values; an empty list matches anyone; hiredBefore leaves out later joiners. templateId null runs the standard settings. Needs MANAGE_REVIEW */
  saveReviewCycle: ReviewCycle;
  /** Create a template (id null) or replace one. settings: {scale: [{value, label, description}] of 3 to 7 rising points, selfReview: OFF|TEXT|TEXT_AND_RATING, peerInput: {enabled, min, max, prompt}, questions: [{key, text, appliesTo: SELF|MANAGER, section: AREA|LEVEL|OVERALL, required}], signOff: NONE|SKIP_LEVEL, calibration: NONE|REQUIRED, referenceDistribution: {scale value: share}, shares adding up to 1, shown in calibration and never enforced}; what is left out comes from standardReviewSettings. A cycle copies its template's settings, so an edit changes only cycles saved or launched after it. Needs MANAGE_REVIEW */
  saveReviewTemplate: ReviewTemplate;
  /** Creates or updates a routine: run workflowCode with these inputs on a cron, as the caller. The caller is the routine's owner — the run executes with their permissions, live, and its results are theirs in Actions — so they must hold the workflow's permission now, and the inputs must satisfy it (a required input with no value, or a name the workflow does not declare, is refused here). Upserts by routineId (document id or bare entity id) — default is one routine per workflow per owner; pass distinct ids for several scopes or cadences. Only the owner can change a routine: an id naming someone else's is refused. MANAGE_ROUTINE required. */
  saveRoutine: Routine;
  saveSalary?: Maybe<Salary>;
  /** Save your self-review. answers: [{sectionKey, questionKey, text, citations: [ledger entry ref], rationale}], one per question you answer; a save replaces your whole part. rationale says why drafted text stands unchanged. overallRating only where the cycle asks for a self-rating. Needs VIEW_REVIEW */
  saveSelfReview: PerformanceReview;
  /** Create or update one of this organisation's own skills (by id); a shipped skill is read-only; needs MANAGE_SKILL_CATALOG */
  saveSkill: Skill;
  /** Create or update one of this organisation's own skill groups (by id); skillWeights keys are skill ids; needs MANAGE_SKILL_CATALOG */
  saveSkillGroup: SkillGroup;
  saveTask?: Maybe<Task>;
  /** Creates or updates an authored agent from a spec (same shape as a *.agent.json file: code, displayName, description, chat instructions, tool and grounding names, requiredPermission, and either an attached workflow code or inline execution fields). The spec is validated against the building-blocks palette before saving — a bad reference is a synchronous error naming the problem. CREATE_CUSTOM_AGENT to create; USE_CUSTOM_AGENT to update an agent you authored. */
  saveTenantAgent: Tenant_Agent;
  saveTenantOntologyPack?: Maybe<TenantOntologyPack>;
  saveUser?: Maybe<User>;
  saveUserDashboardPreference?: Maybe<UserDashboardPreference>;
  saveUserMetricScore?: Maybe<UserMetricScore>;
  saveWorkActivity?: Maybe<WorkActivity>;
  /** One user message → one agent reply, returned with the updated session. Synchronous fallback of POST /agent-chat/{chatId}/messages. */
  sendAgentChatMessage: Agent_Chat_Session;
  /** The user's "send it" on a result held for review (status REVIEW): files it in Actions — the draft row or the provenance stamp on the artifact the run created — and the session ends EXECUTED. chatId is the session holding the result: the chat itself after its execute, or the run record of a run its agent started from the chat (parentChatId). The same thing the agent does when told "send it" in the chat. Refused for anything not held. When an earlier result from the same chat is still waiting in Actions and earlierDraft is not given, nothing is filed: the question is asked in the chat, with its two answers as chips, and the session stays REVIEW. */
  sendAgentChatResultToActions: Agent_Chat_Session;
  /** Make a level your aspiration, replacing any current one; sourceRef names the record it was stated in. The person themselves only — anyone else proposes one (proposeCareerAspiration) and the person accepts it. */
  setCareerAspiration: CareerAspiration;
  /** Set export job status by ID (DEACTIVATED/PENDING) */
  setExportJobStatus?: Maybe<Scalars['JSON']['output']>;
  /** Disable or enable one option; a disabled option reads as deleted outside the editor */
  setExtensibleFieldOptionDisabled: ExtensibleField;
  /** Replace all functional permission grants for an actor (u/, ug/, or r/). Requires MANAGE_PERMISSIONS. */
  setFunctionalPermissions?: Maybe<Array<Maybe<Functional_Permission_Grant>>>;
  setGlobalAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Records the admin's review decision on one item — ACCEPTED or DISMISSED. Applied items are immutable. Requires MANAGE_ORG_CHART. */
  setOrgChangeItemState: OrgChangeSet;
  shareRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Share a review with its person, once the cycle is sharing and the review is submitted and signed off where asked. The reviewer, or VIEW_ALL_REVIEW. Needs VIEW_REVIEW */
  shareReview: PerformanceReview;
  /** Share every review of a SHARING cycle that is submitted, and signed off where asked. Needs MANAGE_REVIEW */
  shareReviewCycle: ReviewCycle;
  /** Let a person (u/…) or group (ug/…) see a smart folder; shares the view, not the documents */
  shareSmartFolder: Record_Permission;
  /** Approve a submitted review you are asked to sign off, or send it back (approve false) with a note saying why. The note is never shown to the person reviewed. Needs VIEW_REVIEW */
  signOffReview: PerformanceReview;
  /** Opens a session with an agent and, for one that speaks first, runs its opening turn. Synchronous fallback of POST /agent-chat/start — prefer SSE for the live thinking state. The session carries the chips and title the turn wrote. */
  startAgentChat: Agent_Chat_Session;
  /** Build with AI: create a DRAFT framework from the Basics page — jobFamilyGroupIds, optional, are the groups the author narrowed to; jobProfiles, at least one, are the profiles it covers, and the only ones the AI places; strictness LIGHT, STANDARD (default) or STRICT; track LET_AI_DECIDE (default), IC_AND_MANAGEMENT or IC, from the CareerAITrack picklist; files are uploaded documents, each with an optional instruction — and queue the LEVELS step. Poll careerFrameworkAI, then read careerLadder. Needs MANAGE_CAREER_FRAMEWORK */
  startCareerFrameworkAI: CareerFramework;
  startExport: EntityExportTrigger;
  /** Submit a draft for approval; its approvers get a task */
  submitDocumentVersion: DocumentVersion;
  /** Submit the review you wrote: required questions answered and an overall rating. Asks for sign-off where the cycle wants it. Needs VIEW_REVIEW */
  submitReview: PerformanceReview;
  /** Submit your self-review; every required self question must be answered. Needs VIEW_REVIEW */
  submitSelfReview: PerformanceReview;
  /** Dismisses an insight for one person, so personInsights stops returning it for them. Per person: it changes nothing for anyone else looking at the same subject. Pass suppressed: false to restore one. Errors when the insight is not about that person. */
  suppressInsight: InsightSuppression;
  /** Switch a person (by full Person id) into one of their workspaces (by full id) and remember it for their next login. Self only. */
  switchWorkspace: Workspace;
  transferOwnership?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI cascade generation for the confirmed, org-assigned top objectives — Phase 8 */
  triggerCascade?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI extraction of company knowledge from the given sources (web search plus uploaded docs) — returns the task id immediately; poll with pollCompanyKnowledge(taskId). Extracted entries are persisted straight to CompanyKnowledge stamped with this task id, then reviewed and edited via CRUD (filter CompanyKnowledge.taskId to this run's entries). Returns null when a job is already running for the tenant and this call is a no-op. Needs MANAGE_CONFIG; at most 25 runs per day. */
  triggerCompanyKnowledge?: Maybe<Scalars['ID']['output']>;
  /** Fire async AI web-search discovery that prefills the blank fields of the tenant's Company — returns immediately; poll with pollCompanyProfile. Needs MANAGE_CONFIG; at most 25 runs per day. */
  triggerCompanyProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI web-search discovery of the public pages describing the tenant's company — returns immediately; poll with pollCompanySources. Re-triggering after a finished run replaces the previous list; a call while one is already running is a no-op. Needs MANAGE_CONFIG; at most 25 runs per day. */
  triggerCompanySources?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI extraction for a strategy input — Phase 2 */
  triggerExtraction?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI org assignment for confirmed top objectives — Phase 7 */
  triggerOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async public knowledge discovery for a person (fast tier) and start the background persist worker — returns immediately; poll with pollPersonKnowledge. No-op while a run is in flight, and when the person already has researched knowledge (the poll then reports COMPLETED) */
  triggerPersonKnowledge?: Maybe<Scalars['Boolean']['output']>;
  /** Queue a public-profile scan that fills the person's blank profile fields and prefills their positions, credentials, public work and skills. Returns immediately; poll with pollPersonProfile. No-op while a scan is in flight. Unless force is true, also a no-op (poll reports COMPLETED) once a scan has prefilled something; a scan that found nothing does not block the next. The person themselves or MANAGE_ORG_CHART. */
  triggerPersonProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI generation of bootstrapping strategy questions — Phase 2, an explicit alternative to attaching a strategy document */
  triggerStrategyQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI clarifying-question generation for confirmed themes — Phase 4 */
  triggerThemeQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI theme synthesis across confirmed inputs — Phase 3 */
  triggerThemeSynthesis?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI company-level top-objective generation — Phase 5 */
  triggerTopObjectiveGeneration?: Maybe<Scalars['Boolean']['output']>;
  /** Unarchive an entity — for Objective, recursively resets child objectives and key results to DRAFT; for OKRCycle, recursively resets descendant cycles to PLANNING */
  unarchiveEntity?: Maybe<Scalars['Boolean']['output']>;
  /** Make an archived workspace (by full id) active again. Requires MANAGE_WORKSPACES. */
  unarchiveWorkspace: Workspace;
  unassignGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Removes a person's override; they fall back to their own job profile's model, if any. False when they held none. Requires MANAGE_PRODUCTIVITY_MODEL. */
  unassignJobProfileOverride: Scalars['Boolean']['output'];
  unassignRoles?: Maybe<Scalars['Boolean']['output']>;
  unlinkRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Take back a smart folder share */
  unshareSmartFolder: Scalars['Boolean']['output'];
  updateActivityById?: Maybe<Activity>;
  updateAgent_ActionById?: Maybe<Agent_Action>;
  updateAnalyticsDashboardById?: Maybe<AnalyticsDashboard>;
  updateArtifactById?: Maybe<Artifact>;
  /** Change an ACTIVE candidate's displayName, primaryEmail, primaryPhone or expectedJoiningDate; a key left out is unchanged. Requires MANAGE_ORG_CHART. */
  updateCandidate: Candidate;
  /** Change the Basics of an AI-drafted framework; an argument left out stays as it was, and files, jobFamilyGroupIds and jobProfiles replace the whole list. Nothing already drafted changes. Needs MANAGE_CAREER_FRAMEWORK */
  updateCareerFrameworkAI: CareerFramework;
  updateChatBucketById?: Maybe<ChatBucket>;
  updateCompanyById?: Maybe<Company>;
  updateCompanyKnowledgeById?: Maybe<CompanyKnowledge>;
  /** Set whom a published document applies to: its appliesTo* criteria */
  updateDocumentAudience: Document;
  /** Update a library's name, description and classification cap */
  updateDocumentLibrary: DocumentLibrary;
  /** Change fields of a required-document rule. updates is the update DSL (set, unset, …), written with updateById, and the rule that results is checked the same way as saveDocumentRequirement. Who owes it follows on the next daily pass */
  updateDocumentRequirement: DocumentRequirement;
  /** Change fields of a document type. updates is the update DSL (set, unset, …), written with updateById, and the type that results is checked the same way as saveDocumentType */
  updateDocumentType: DocumentType;
  updateEdgeById?: Maybe<Edge>;
  updateExportJobHistoryById?: Maybe<ExportJobHistory>;
  updateGoalById?: Maybe<Goal>;
  updateIdentityLinkById?: Maybe<IdentityLink>;
  /** Replace a binding's feed-field -> target-field mapping. */
  updateIntegrationMapping?: Maybe<Integration>;
  updateInteractionById?: Maybe<Interaction>;
  updateKnowledgeNodeById?: Maybe<KnowledgeNode>;
  updateMetricById?: Maybe<Metric>;
  updateMindsetById?: Maybe<Mindset>;
  updateNoteById?: Maybe<Note>;
  updateNotificationById?: Maybe<Notification>;
  updateNotification_DeliveryById?: Maybe<Notification_Delivery>;
  updateNotification_OutboxById?: Maybe<Notification_Outbox>;
  updateNotification_PreferenceById?: Maybe<Notification_Preference>;
  updateNotification_TemplateById?: Maybe<Notification_Template>;
  /** Update an OKR cycle */
  updateOKRCycle?: Maybe<Scalars['JSON']['output']>;
  /** Update org fields through the given draft: nothing is written — each field becomes a reviewable change item (editable: displayName, description, parentOrgId, managerPositionId, status) and the returned org is the live one with the draft's changes overlaid. Requires MANAGE_ORG_CHART. */
  updateOrg: Org;
  updateOrgRoleById?: Maybe<OrgRole>;
  updateOutcomeById?: Maybe<Outcome>;
  updatePersonById?: Maybe<Person>;
  /** Change a person through the given draft, as an admin edits them: one item per key in input, applied at publish; null clears a field unless noted, and a value equal to today's adds nothing. displayName (SET_PERSON_NAME), profilePicture (SET_PERSON_PHOTO, an http(s) URL; cannot be cleared), departmentId (SET_PERSON_DEPARTMENT), orgRoleId (SET_PERSON_DESIGNATION), personType (SET_PERSON_TYPE, a PersonType name; cannot be cleared), primaryPhone (SET_PERSON_PHONE, E.164), dateOfBirth (SET_PERSON_DATE_OF_BIRTH, epoch millis), gender (SET_PERSON_GENDER, a Gender name), locationId (SET_PERSON_LOCATION), workMode (SET_PERSON_WORK_MODE, a WorkMode name: OFFICE, HYBRID, REMOTE, or FIELD), permanentAddress (SET_PERSON_PERMANENT_ADDRESS); on the person's profile: linkedinUrl (SET_PERSON_LINKEDIN), slackUrl (SET_PERSON_SLACK), githubUrl (SET_PERSON_GITHUB), currentAddress (SET_PERSON_CURRENT_ADDRESS). An address is {name, street, city, state, postalCode, country}, replaced whole. primaryPositionId moves the person: VACATE_POSITION on their seat, then FILL_POSITION on the new one, which must be open; null only vacates. managerPersonId (SET_PERSON_MANAGER) is for someone without a seat: ignored when primaryPositionId moves them to another seat, refused while they stay seated, and kept along with a vacate even when unchanged. Tags, roles and groups are not edited here; primaryEmail and personCode are set once, at invite, and refused here. personId may be the placeholder of someone this draft invites, not yet in the person list: the edit then rewrites their INVITE_PERSON payload (null drops a key), the seat and manager follow the invite's rules, and it also takes primaryEmail, roleId (needs MANAGE_ROLES) and userGroupId (needs MANAGE_USER_GROUPS). Requires MANAGE_ORG_CHART. */
  updatePersonDetails: AddOrgChangeItemsResult;
  updatePersonKnowledgeById?: Maybe<PersonKnowledge>;
  /** Set profile fields — headline, description, featuredSkillIds (max 10 Skill ids), linkedinUrl, slackUrl, githubUrl, skypeUrl, currentAddress ({name, street, city, state, postalCode, country}, replaced whole), personalEmail (an email address). A key with null clears it; an absent key is left alone. Also profilePicture (an http(s) URL; cannot be cleared), which is stored on the Person and set in Lyearn first, so read it back from the Person. The person themselves or MANAGE_ORG_CHART. */
  updatePersonProfile?: Maybe<PersonProfile>;
  updateRawChatById?: Maybe<RawChat>;
  updateResourceById?: Maybe<Resource>;
  updateRole?: Maybe<App_Role>;
  updateSalaryById?: Maybe<Salary>;
  /** Replace a smart folder's name, criteria, sort, position and library sharing */
  updateSmartFolder: SmartFolder;
  updateTaskById?: Maybe<Task>;
  updateTenantOntologyPackById?: Maybe<TenantOntologyPack>;
  updateUserById?: Maybe<User>;
  updateUserDashboardPreferenceById?: Maybe<UserDashboardPreference>;
  updateUserGroup?: Maybe<UserGroup>;
  updateUserMetricScoreById?: Maybe<UserMetricScore>;
  updateWorkActivityById?: Maybe<WorkActivity>;
  /** Rename or re-describe a workspace (by full id); an omitted argument is left as it is. A rename is made in the user service too. The Main workspace cannot be changed. Requires MANAGE_WORKSPACES. */
  updateWorkspace: Workspace;
  /** Make a copy of a library document's version in force a document type's template — the alternative to uploading one. Later versions of the document do not change it. Needs UPDATE on the type and read access to the document's content */
  useDocumentAsTemplate: DocumentType;
  /** Validate a whole ladder ({framework, tracks, levels}) as publish would, writing nothing; needs MANAGE_CAREER_FRAMEWORK */
  validateCareerLadder: CareerLadderReport;
  /** Checks a people import CSV without changing anything: every row back, with every problem grouped by kind. Actions: Invite, Update (blank cells leave a value as it is), Deactivate, Reactivate; Merge is refused. Departments, designations, tag options, roles and groups are matched by name and must exist. At most 5000 people. Requires MANAGE_ORG_CHART. */
  validatePeopleImport: PeopleImportValidation;
  /** Verify an employee document's pending version */
  verifyDocumentVersion: DocumentVersion;
  /** Verify a qualification: stamps verifiedAt and verifiedByPersonId. MANAGE_ORG_CHART verifies any type; the person's direct manager only public work (ARTICLE, TALK, OPEN_SOURCE, PORTFOLIO, PRESS); never the person themselves. A verified one is returned unchanged. */
  verifyPersonQualification?: Maybe<PersonQualification>;
  /** Let someone off acknowledging a document, with the reason */
  waiveDocumentAcknowledgement: DocumentAcknowledgement;
  /** Waive what a person owes, with the reason */
  waiveDocumentObligation: DocumentObligation;
  /** Make a narrowing folder inherit its container's access again */
  widenDocumentFolder: DocumentFolder;
  /** Take back a proposal you made that the person has not decided */
  withdrawAspirationProposal: AspirationProposal;
  /** Withdraw your current aspiration. The person themselves only. */
  withdrawCareerAspiration: CareerAspiration;
  /** Take a version back out of review */
  withdrawDocumentVersion: DocumentVersion;
};


export type MutationAcceptAspirationProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcknowledgeDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationAcknowledgeReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCalibrationReviewsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCheckInArgs = {
  input: Scalars['JSON']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCommentArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddDepartmentArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddInitiativeArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobFamilyArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobFamilyGroupArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobProfileArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddKeyResultArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
};


export type MutationAddLocationArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddObjectiveArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddOrgAssignmentArgs = {
  objectiveId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationAddOrgChangeItemsArgs = {
  changeSetId: Scalars['ID']['input'];
  items: Array<Scalars['JSON']['input']>;
};


export type MutationAddPositionArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationAddStrategyInputArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddThemeArgs = {
  okrId: Scalars['ID']['input'];
  theme: Scalars['JSON']['input'];
};


export type MutationAddUserTaskArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAdjustReviewRatingArgs = {
  citations?: InputMaybe<Array<Scalars['ID']['input']>>;
  rationale: Scalars['String']['input'];
  reviewId: Scalars['ID']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
  toRating: Scalars['Int']['input'];
};


export type MutationAnnotateLedgerEntryArgs = {
  personId: Scalars['ID']['input'];
  ref: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationArchiveCareerFrameworkArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type MutationArchiveDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationArchiveEntityArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationArchiveWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssessCareerReadinessArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAssignGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};


export type MutationAssignJobProfileOverrideArgs = {
  jobProfileEntityId: Scalars['ID']['input'];
  model: Scalars['String']['input'];
  personEntityId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  regionEntityId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAssignRolesArgs = {
  entityId: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCancelCalibrationSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelDocumentSignatureRequestArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};


export type MutationCancelInviteArgs = {
  changeSetId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeDocumentClassificationArgs = {
  classification: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
};


export type MutationCheckReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearFunctionalPermissionsArgs = {
  actor: Scalars['String']['input'];
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCloseCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationCloseReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCommitImportArgs = {
  sheets: Scalars['JSON']['input'];
};


export type MutationCommitPeopleImportArgs = {
  changeSetId: Scalars['ID']['input'];
  csv: Scalars['String']['input'];
};


export type MutationCompleteConnectionAuthArgs = {
  connectionId: Scalars['ID']['input'];
};


export type MutationConfigureSignatureProviderArgs = {
  provider: Scalars['String']['input'];
  values: Scalars['JSON']['input'];
};


export type MutationConfirmBrowserUploadArgs = {
  actualSize: Scalars['Long']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationConfirmCalibratedReviewArgs = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationConfirmExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationConfirmKnowledgeHealthArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationConfirmOrgAssignmentsArgs = {
  assignments: Scalars['JSON']['input'];
  okrId: Scalars['ID']['input'];
};


export type MutationConfirmStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
  questions: Scalars['JSON']['input'];
};


export type MutationConfirmThemeAnswersArgs = {
  okrId: Scalars['ID']['input'];
  questions: Scalars['JSON']['input'];
};


export type MutationConfirmThemesArgs = {
  okrId: Scalars['ID']['input'];
  themes: Scalars['JSON']['input'];
};


export type MutationConfirmTopObjectivesArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationCreateCandidateArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateDocumentArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateDocumentFolderArgs = {
  displayName: Scalars['String']['input'];
  libraryId: Scalars['ID']['input'];
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateDocumentLibraryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  libraryKind: Scalars['String']['input'];
  maxClassification?: InputMaybe<Scalars['String']['input']>;
  subjectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateDocumentLinkArgs = {
  documentId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
  targetId: Scalars['ID']['input'];
};


export type MutationCreateExportJobArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateOkrCycleArgs = {
  quarter?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOkrShellsArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationCreateOrgChangeSetArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input?: InputMaybe<App_RoleInput>;
};


export type MutationCreateSmartFolderArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateUserGroupArgs = {
  input?: InputMaybe<UserGroupInput>;
};


export type MutationCreateWorkspaceArgs = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
};


export type MutationDeactivatePersonArgs = {
  changeSetId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  personStatus?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineAspirationProposalArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeclineFeedbackRequestArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteAnalyticsViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCheckInArgs = {
  checkInId: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationDeleteDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentFolderArgs = {
  folderId: Scalars['ID']['input'];
};


export type MutationDeleteInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobFamilyArgs = {
  jobFamilyId: Scalars['ID']['input'];
};


export type MutationDeleteJobFamilyGroupArgs = {
  jobFamilyGroupId: Scalars['ID']['input'];
};


export type MutationDeleteJobProfileArgs = {
  jobProfileId: Scalars['ID']['input'];
};


export type MutationDeleteKeyResultArgs = {
  keyResultId: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationDeleteObjectiveArgs = {
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  objectiveId: Scalars['ID']['input'];
};


export type MutationDeleteOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationDeletePositionArgs = {
  changeSetId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};


export type MutationDeleteQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReviewTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type MutationDeleteRoutineArgs = {
  routineId: Scalars['String']['input'];
};


export type MutationDeleteSalaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSkillGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmartFolderArgs = {
  smartFolderId: Scalars['ID']['input'];
};


export type MutationDeleteStoredFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStrategyInputArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationDeleteTenantAgentArgs = {
  code: Scalars['String']['input'];
};


export type MutationDeleteTenantWorkflowArgs = {
  code: Scalars['String']['input'];
};


export type MutationDeleteThemeArgs = {
  okrId: Scalars['ID']['input'];
  themeId: Scalars['ID']['input'];
};


export type MutationDeleteUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteUserTaskArgs = {
  userTaskId: Scalars['ID']['input'];
};


export type MutationDiscardAgentChatResultArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDiscardCareerFrameworkDraftArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type MutationDiscardOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationDiscardPersonProfileArgs = {
  personId: Scalars['ID']['input'];
};


export type MutationDismissReviewFlagArgs = {
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  sectionKey: Scalars['String']['input'];
};


export type MutationDraftReviewSectionArgs = {
  id: Scalars['ID']['input'];
  sectionKey: Scalars['String']['input'];
};


export type MutationEditCheckInArgs = {
  checkInId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditClarificationAnswerArgs = {
  answer: Scalars['String']['input'];
  okrId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditJobFamilyArgs = {
  input: Scalars['JSON']['input'];
  jobFamilyId: Scalars['ID']['input'];
};


export type MutationEditJobFamilyGroupArgs = {
  input: Scalars['JSON']['input'];
  jobFamilyGroupId: Scalars['ID']['input'];
};


export type MutationEditJobProfileArgs = {
  input: Scalars['JSON']['input'];
  jobProfileId: Scalars['ID']['input'];
};


export type MutationEditKeyResultArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  keyResultId: Scalars['ID']['input'];
};


export type MutationEditLocationArgs = {
  input: Scalars['JSON']['input'];
  locationId: Scalars['ID']['input'];
};


export type MutationEditObjectiveArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  objectiveId: Scalars['ID']['input'];
};


export type MutationEditPositionArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
  positionId: Scalars['ID']['input'];
};


export type MutationEditStrategyInputArgs = {
  input: Scalars['JSON']['input'];
  strategyInputId: Scalars['ID']['input'];
};


export type MutationEditThemeArgs = {
  okrId: Scalars['ID']['input'];
  theme: Scalars['JSON']['input'];
};


export type MutationEditUserTaskArgs = {
  input: Scalars['JSON']['input'];
  userTaskId: Scalars['ID']['input'];
};


export type MutationEnsureOrgChangeSetArgs = {
  source: Scalars['String']['input'];
};


export type MutationExecuteAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationExitPersonArgs = {
  changeSetId: Scalars['ID']['input'];
  exitDate?: InputMaybe<Scalars['Long']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  personStatus?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExtendSkillGroupArgs = {
  additions?: InputMaybe<Scalars['JSON']['input']>;
  exclusions?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupId: Scalars['ID']['input'];
};


export type MutationFinaliseCalibrationSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFindOrAddQualificationArgs = {
  issuer?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationFindOrAddSkillArgs = {
  name: Scalars['String']['input'];
};


export type MutationGenerateDocumentArgs = {
  documentTypeId: Scalars['ID']['input'];
  inputs: Scalars['JSON']['input'];
  subjectId: Scalars['ID']['input'];
  templateFileId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationGiveFeedbackArgs = {
  kind: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['ID']['input']>;
  skillRatings?: InputMaybe<Scalars['JSON']['input']>;
  sourceRef?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
  suggestedSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text: Scalars['String']['input'];
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGrantTypePermissionArgs = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actor: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationInitBrowserUploadArgs = {
  input: InitBrowserUploadInput;
};


export type MutationInitiateConnectionAuthArgs = {
  sourceType: Scalars['String']['input'];
};


export type MutationInvitePersonArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationLaunchReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLinkRecordArgs = {
  childEntityType: Scalars['String']['input'];
  childId: Scalars['String']['input'];
  parentEntityType: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationMarkCareerLevelsReviewedArgs = {
  frameworkId: Scalars['ID']['input'];
  levelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationMarkDocumentReviewedArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationMoveDocumentArgs = {
  documentId: Scalars['ID']['input'];
  targetFolderId?: InputMaybe<Scalars['ID']['input']>;
  targetLibraryId: Scalars['ID']['input'];
};


export type MutationMoveSubjectDocumentFolderArgs = {
  subjectId: Scalars['ID']['input'];
  targetFolderId: Scalars['ID']['input'];
};


export type MutationNarrowDocumentFolderArgs = {
  folderId: Scalars['ID']['input'];
};


export type MutationNominatePeersArgs = {
  personIds: Array<Scalars['ID']['input']>;
  skillId?: InputMaybe<Scalars['ID']['input']>;
  verdictId: Scalars['ID']['input'];
};


export type MutationNominateReviewPeersArgs = {
  id: Scalars['ID']['input'];
  personIds: Array<Scalars['ID']['input']>;
};


export type MutationNoteCalibrationSessionArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOpenCalibrationSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPlaceLegalHoldArgs = {
  matter: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  scopeId: Scalars['ID']['input'];
};


export type MutationProposeCareerAspirationArgs = {
  contextRef?: InputMaybe<Scalars['ID']['input']>;
  note: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  targetLevelId: Scalars['ID']['input'];
};


export type MutationProposeCareerFrameworkAiArgs = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  instruction: Scalars['String']['input'];
};


export type MutationPublishCareerLadderArgs = {
  ladder: Scalars['JSON']['input'];
};


export type MutationPublishDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationPublishOkrArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationPublishObjectiveArgs = {
  objectiveIds: Array<Scalars['ID']['input']>;
};


export type MutationPublishOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationPushOrgChangeItemsArgs = {
  items: Array<Scalars['JSON']['input']>;
  source: Scalars['String']['input'];
};


export type MutationRateAgentChatMessageArgs = {
  feedback?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['ID']['input'];
};


export type MutationReactivatePersonArgs = {
  changeSetId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReassignReviewerArgs = {
  id: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};


export type MutationRebaseOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationRecommendPromotionArgs = {
  id: Scalars['ID']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
  recommended: Scalars['Boolean']['input'];
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRefreshUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationRejectDocumentVersionArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['ID']['input'];
};


export type MutationRejoinPersonArgs = {
  changeSetId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReleaseLegalHoldArgs = {
  holdId: Scalars['ID']['input'];
};


export type MutationRemoveDocumentLinkArgs = {
  linkId: Scalars['ID']['input'];
};


export type MutationRemoveOrgAssignmentArgs = {
  objectiveId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationRemoveOrgChangeItemArgs = {
  changeSetId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationRemovePersonQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePersonSkillArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  skillId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveSignatureProviderSetupArgs = {
  provider: Scalars['String']['input'];
};


export type MutationRenameAgentChatArgs = {
  chatId: Scalars['ID']['input'];
  displayName: Scalars['String']['input'];
};


export type MutationRenameDocumentFolderArgs = {
  displayName: Scalars['String']['input'];
  folderId: Scalars['ID']['input'];
};


export type MutationRenameOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationReorderIntegrationsArgs = {
  kind: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  orderedIds: Array<Scalars['ID']['input']>;
  target: Scalars['String']['input'];
};


export type MutationReparentOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  newParentOrgId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationRequestCareerReadinessRunArgs = {
  frameworkId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRequestDocumentSignaturesArgs = {
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  signers: Array<Scalars['JSON']['input']>;
  versionId: Scalars['ID']['input'];
};


export type MutationRequestFeedbackArgs = {
  contextRef?: InputMaybe<Scalars['ID']['input']>;
  dueAt?: InputMaybe<Scalars['Long']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  recipientIds: Array<Scalars['ID']['input']>;
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectId: Scalars['ID']['input'];
};


export type MutationRequestQualificationVerificationArgs = {
  qualificationId: Scalars['ID']['input'];
};


export type MutationRequestSkillAttestationArgs = {
  skillId: Scalars['ID']['input'];
};


export type MutationResendInvitesArgs = {
  personIds: Array<Scalars['String']['input']>;
};


export type MutationResetExtensibleFieldArgs = {
  apiName: Scalars['String']['input'];
};


export type MutationResolveAgentDraftArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draftId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationRespondToReviewArgs = {
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRestoreCareerFrameworkArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type MutationRetractFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryWorkflowRunArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationRevertOrgToVersionArgs = {
  version: Scalars['Int']['input'];
};


export type MutationRevertOrgVersionArgs = {
  version: Scalars['Int']['input'];
};


export type MutationRevokeShareArgs = {
  recordPermissionId: Scalars['String']['input'];
};


export type MutationRevokeTypePermissionArgs = {
  typePermissionId: Scalars['String']['input'];
};


export type MutationRunCareerFrameworkAiStepArgs = {
  frameworkId: Scalars['ID']['input'];
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  step: Scalars['String']['input'];
};


export type MutationRunWorkflowArgs = {
  inputs?: InputMaybe<Scalars['JSON']['input']>;
  workflowCode: Scalars['String']['input'];
};


export type MutationSaveActivityArgs = {
  input?: InputMaybe<ActivityInput>;
};


export type MutationSaveAgent_ActionArgs = {
  input?: InputMaybe<Agent_ActionInput>;
};


export type MutationSaveAnalyticsDashboardArgs = {
  input?: InputMaybe<AnalyticsDashboardInput>;
};


export type MutationSaveAnalyticsViewArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveArtifactArgs = {
  input?: InputMaybe<ArtifactInput>;
};


export type MutationSaveCalibrationSessionArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  employmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  facilitatorPersonId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  levelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  orgIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  participantPersonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  personTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSaveCareerLadderDraftArgs = {
  ladder: Scalars['JSON']['input'];
};


export type MutationSaveChatBucketArgs = {
  input?: InputMaybe<ChatBucketInput>;
};


export type MutationSaveCompanyArgs = {
  input?: InputMaybe<CompanyInput>;
};


export type MutationSaveCompanyKnowledgeArgs = {
  input?: InputMaybe<CompanyKnowledgeInput>;
};


export type MutationSaveDashboardArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveDocumentRequirementArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveDocumentTypeArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveEdgeArgs = {
  input?: InputMaybe<EdgeInput>;
};


export type MutationSaveExportJobHistoryArgs = {
  input?: InputMaybe<ExportJobHistoryInput>;
};


export type MutationSaveExtensibleFieldArgs = {
  apiName: Scalars['String']['input'];
  input: ExtensibleFieldInput;
};


export type MutationSaveGoalArgs = {
  input?: InputMaybe<GoalInput>;
};


export type MutationSaveIdentityLinkArgs = {
  input?: InputMaybe<IdentityLinkInput>;
};


export type MutationSaveInteractionArgs = {
  input?: InputMaybe<InteractionInput>;
};


export type MutationSaveKnowledgeNodeArgs = {
  input?: InputMaybe<KnowledgeNodeInput>;
};


export type MutationSaveMetricArgs = {
  input?: InputMaybe<MetricInput>;
};


export type MutationSaveMindsetArgs = {
  input?: InputMaybe<MindsetInput>;
};


export type MutationSaveNoteArgs = {
  input?: InputMaybe<NoteInput>;
};


export type MutationSaveNotificationArgs = {
  input?: InputMaybe<NotificationInput>;
};


export type MutationSaveNotification_DeliveryArgs = {
  input?: InputMaybe<Notification_DeliveryInput>;
};


export type MutationSaveNotification_OutboxArgs = {
  input?: InputMaybe<Notification_OutboxInput>;
};


export type MutationSaveNotification_PreferenceArgs = {
  input?: InputMaybe<Notification_PreferenceInput>;
};


export type MutationSaveNotification_TemplateArgs = {
  input?: InputMaybe<Notification_TemplateInput>;
};


export type MutationSaveOkrArgs = {
  input: OkrInput;
};


export type MutationSaveOrgRoleArgs = {
  input?: InputMaybe<OrgRoleInput>;
};


export type MutationSaveOutcomeArgs = {
  input?: InputMaybe<OutcomeInput>;
};


export type MutationSavePersonArgs = {
  input?: InputMaybe<PersonInput>;
};


export type MutationSavePersonKnowledgeArgs = {
  input?: InputMaybe<PersonKnowledgeInput>;
};


export type MutationSavePersonQualificationArgs = {
  input: Scalars['JSON']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSavePersonSkillArgs = {
  evidenceRefs?: InputMaybe<Array<Scalars['ID']['input']>>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  proficiency: Scalars['String']['input'];
  skillId: Scalars['ID']['input'];
};


export type MutationSaveProductivityDashboardArgs = {
  entityType: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  model: Scalars['String']['input'];
  overrides: Scalars['JSON']['input'];
};


export type MutationSaveProductivityModelDefinitionArgs = {
  definition: Scalars['JSON']['input'];
};


export type MutationSaveQualificationArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveRawChatArgs = {
  input?: InputMaybe<RawChatInput>;
};


export type MutationSaveResourceArgs = {
  input?: InputMaybe<ResourceInput>;
};


export type MutationSaveReviewArgs = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  overallRating?: InputMaybe<Scalars['Int']['input']>;
  sectionRatings?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSaveReviewCycleArgs = {
  calibrationDueAt?: InputMaybe<Scalars['Long']['input']>;
  employmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  hiredBefore?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managerDueAt?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  orgIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  peerDueAt?: InputMaybe<Scalars['Long']['input']>;
  personTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  selfDueAt?: InputMaybe<Scalars['Long']['input']>;
  shareAt?: InputMaybe<Scalars['Long']['input']>;
  signOffDueAt?: InputMaybe<Scalars['Long']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  windowEnd?: InputMaybe<Scalars['Long']['input']>;
  windowStart?: InputMaybe<Scalars['Long']['input']>;
};


export type MutationSaveReviewTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSaveRoutineArgs = {
  cron: Scalars['String']['input'];
  inputs?: InputMaybe<Scalars['JSON']['input']>;
  routineId?: InputMaybe<Scalars['String']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
  workflowCode: Scalars['String']['input'];
};


export type MutationSaveSalaryArgs = {
  input?: InputMaybe<SalaryInput>;
};


export type MutationSaveSelfReviewArgs = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  overallRating?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveSkillArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveSkillGroupArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveTaskArgs = {
  input?: InputMaybe<TaskInput>;
};


export type MutationSaveTenantAgentArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  spec: Scalars['JSON']['input'];
};


export type MutationSaveTenantOntologyPackArgs = {
  input?: InputMaybe<TenantOntologyPackInput>;
};


export type MutationSaveUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationSaveUserDashboardPreferenceArgs = {
  input?: InputMaybe<UserDashboardPreferenceInput>;
};


export type MutationSaveUserMetricScoreArgs = {
  input?: InputMaybe<UserMetricScoreInput>;
};


export type MutationSaveWorkActivityArgs = {
  input?: InputMaybe<WorkActivityInput>;
};


export type MutationSendAgentChatMessageArgs = {
  acceptProposal?: InputMaybe<Scalars['Boolean']['input']>;
  chatId: Scalars['ID']['input'];
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  model?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  webSearch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendAgentChatResultToActionsArgs = {
  chatId: Scalars['ID']['input'];
  earlierDraft?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetCareerAspirationArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  sourceRef?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId: Scalars['ID']['input'];
};


export type MutationSetExportJobStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationSetExtensibleFieldOptionDisabledArgs = {
  apiName: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  option: Scalars['String']['input'];
};


export type MutationSetFunctionalPermissionsArgs = {
  actor: Scalars['String']['input'];
  functionalPermissions: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetGlobalAccessArgs = {
  access: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationSetOrgChangeItemStateArgs = {
  changeSetId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationShareRecordArgs = {
  input?: InputMaybe<Record_PermissionInput>;
};


export type MutationShareReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShareReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShareSmartFolderArgs = {
  actor: Scalars['String']['input'];
  smartFolderId: Scalars['ID']['input'];
};


export type MutationSignOffReviewArgs = {
  approve: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartAgentChatArgs = {
  agentCode: Scalars['String']['input'];
  subjectRef?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartCareerFrameworkAiArgs = {
  files?: InputMaybe<Array<CareerAiFileInput>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobFamilyGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobProfiles: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  strictness?: InputMaybe<Scalars['String']['input']>;
  track?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartExportArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSubmitDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationSubmitReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitSelfReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSuppressInsightArgs = {
  insightId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSwitchWorkspaceArgs = {
  personId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationTransferOwnershipArgs = {
  entityType: Scalars['String']['input'];
  newOwnerId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


export type MutationTriggerCascadeArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerCompanyKnowledgeArgs = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  newsUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerCompanyProfileArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationTriggerCompanySourcesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationTriggerOrgAssignmentArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerPersonKnowledgeArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};


export type MutationTriggerPersonProfileArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
};


export type MutationTriggerStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerThemeQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerThemeSynthesisArgs = {
  okrId: Scalars['ID']['input'];
  timeHorizon?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerTopObjectiveGenerationArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationUnarchiveEntityArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnassignGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};


export type MutationUnassignJobProfileOverrideArgs = {
  personEntityId: Scalars['ID']['input'];
};


export type MutationUnassignRolesArgs = {
  entityId: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUnlinkRecordArgs = {
  membershipId: Scalars['String']['input'];
};


export type MutationUnshareSmartFolderArgs = {
  actor: Scalars['String']['input'];
  smartFolderId: Scalars['ID']['input'];
};


export type MutationUpdateActivityByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateAgent_ActionByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateAnalyticsDashboardByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateArtifactByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateCareerFrameworkAiArgs = {
  files?: InputMaybe<Array<CareerAiFileInput>>;
  frameworkId: Scalars['ID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobFamilyGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobProfiles?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  strictness?: InputMaybe<Scalars['String']['input']>;
  track?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateChatBucketByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateCompanyByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateCompanyKnowledgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateDocumentAudienceArgs = {
  documentId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateDocumentLibraryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  libraryId: Scalars['ID']['input'];
  maxClassification?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDocumentRequirementArgs = {
  requirementId: Scalars['ID']['input'];
  updates: Array<Scalars['JSON']['input']>;
};


export type MutationUpdateDocumentTypeArgs = {
  documentTypeId: Scalars['ID']['input'];
  updates: Array<Scalars['JSON']['input']>;
};


export type MutationUpdateEdgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateExportJobHistoryByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateGoalByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateIdentityLinkByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateIntegrationMappingArgs = {
  id: Scalars['ID']['input'];
  mapping: Scalars['JSON']['input'];
};


export type MutationUpdateInteractionByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateKnowledgeNodeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateMetricByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateMindsetByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNoteByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotificationByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_DeliveryByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_OutboxByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_PreferenceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_TemplateByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateOkrCycleArgs = {
  cycleId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateOrgRoleByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateOutcomeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdatePersonByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdatePersonDetailsArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
  personId: Scalars['ID']['input'];
};


export type MutationUpdatePersonKnowledgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdatePersonProfileArgs = {
  input: Scalars['JSON']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRawChatByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateResourceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateRoleArgs = {
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input?: InputMaybe<App_RoleInput>;
};


export type MutationUpdateSalaryByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateSmartFolderArgs = {
  input: Scalars['JSON']['input'];
  smartFolderId: Scalars['ID']['input'];
};


export type MutationUpdateTaskByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateTenantOntologyPackByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserDashboardPreferenceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserGroupArgs = {
  input?: InputMaybe<UserGroupInput>;
};


export type MutationUpdateUserMetricScoreByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateWorkActivityByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateWorkspaceArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUseDocumentAsTemplateArgs = {
  documentId: Scalars['ID']['input'];
  documentTypeId: Scalars['ID']['input'];
};


export type MutationValidateCareerLadderArgs = {
  ladder: Scalars['JSON']['input'];
};


export type MutationValidatePeopleImportArgs = {
  csv: Scalars['String']['input'];
};


export type MutationVerifyDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationVerifyPersonQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWaiveDocumentAcknowledgementArgs = {
  acknowledgementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWaiveDocumentObligationArgs = {
  obligationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWidenDocumentFolderArgs = {
  folderId: Scalars['ID']['input'];
};


export type MutationWithdrawAspirationProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWithdrawCareerAspirationArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationWithdrawDocumentVersionArgs = {
  versionId: Scalars['ID']['input'];
};

/** One functional permission key held by the current user */
export type MyFunctionalPermission = {
  __typename?: 'MyFunctionalPermission';
  /** true if this key was added by FunctionalPermission.addImplied rather than backed by a stored FunctionalPermissionGrant. */
  implied: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

/** Holders of one job profile in a model's job families whom the model does not score */
export type NotScoredGroup = {
  __typename?: 'NotScoredGroup';
  jobProfileId: Scalars['ID']['output'];
  people?: Maybe<Array<Maybe<Person>>>;
};

/** A standalone, longer-form rich-text annotation attached to any entity — generic, polymorphic; title is the inherited displayName */
export type Note = BaseEntity & {
  __typename?: 'Note';
  authorPersonId?: Maybe<Person>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mentionedPersonIds?: Maybe<Array<Maybe<Person>>>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetRef?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
  authorPersonId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  mentionedPersonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetRef?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a NoteList query */
export type NoteListResult = {
  __typename?: 'NoteListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Note>>>;
  /** Total number of Note records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A per-recipient notification-center inbox item with read/unread state. */
export type Notification = BaseEntity & {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deepLink?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  priority?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['Long']['output']>;
  recipientUserId?: Maybe<Scalars['String']['output']>;
  sourceOutboxId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type NotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['Long']['input']>;
  recipientUserId?: InputMaybe<Scalars['String']['input']>;
  sourceOutboxId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a NotificationList query */
export type NotificationListResult = {
  __typename?: 'NotificationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification>>>;
  /** Total number of Notification records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per (recipient × channel) delivery record tracking status and provider reference. */
export type Notification_Delivery = BaseEntity & {
  __typename?: 'Notification_Delivery';
  address?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nextRetryAt?: Maybe<Scalars['Long']['output']>;
  providerRef?: Maybe<Scalars['String']['output']>;
  recipientUserId?: Maybe<Scalars['String']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceOutboxId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Notification_DeliveryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nextRetryAt?: InputMaybe<Scalars['Long']['input']>;
  providerRef?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
  sourceOutboxId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a Notification_DeliveryList query */
export type Notification_DeliveryListResult = {
  __typename?: 'Notification_DeliveryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Delivery>>>;
  /** Total number of Notification_Delivery records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A queued semantic notification request, fanned out into per-recipient deliveries by core-notification-server. */
export type Notification_Outbox = BaseEntity & {
  __typename?: 'Notification_Outbox';
  actorUserId?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  data?: Maybe<Scalars['JSON']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  priority?: Maybe<Scalars['String']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  recipientOrgIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recipientUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Notification_OutboxInput = {
  actorUserId?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  processingError?: InputMaybe<Scalars['String']['input']>;
  recipientOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipientUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a Notification_OutboxList query */
export type Notification_OutboxListResult = {
  __typename?: 'Notification_OutboxListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Outbox>>>;
  /** Total number of Notification_Outbox records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A recipient's per-event channel opt-ins, digest mode, and quiet hours. */
export type Notification_Preference = BaseEntity & {
  __typename?: 'Notification_Preference';
  ALL_EVENTS?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  digestMode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabledChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  quietHoursEnd?: Maybe<Scalars['Long']['output']>;
  quietHoursStart?: Maybe<Scalars['Long']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Notification_PreferenceInput = {
  ALL_EVENTS?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  digestMode?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabledChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['Long']['input']>;
  quietHoursStart?: InputMaybe<Scalars['Long']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a Notification_PreferenceList query */
export type Notification_PreferenceListResult = {
  __typename?: 'Notification_PreferenceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Preference>>>;
  /** Total number of Notification_Preference records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Rendering template for an (eventKey, channel, locale) combination. */
export type Notification_Template = BaseEntity & {
  __typename?: 'Notification_Template';
  CONNECTION_REF?: Maybe<Scalars['String']['output']>;
  DEFAULT_LOCALE?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locale?: Maybe<Scalars['String']['output']>;
  subjectTemplate?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Notification_TemplateInput = {
  CONNECTION_REF?: InputMaybe<Scalars['String']['input']>;
  DEFAULT_LOCALE?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a Notification_TemplateList query */
export type Notification_TemplateListResult = {
  __typename?: 'Notification_TemplateListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Template>>>;
  /** Total number of Notification_Template records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Root of an OKR tree — holds type, ownership, generation wizard state, and the embedded generation context */
export type Okr = BaseEntity & {
  __typename?: 'OKR';
  clarifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  confidential?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<OkrCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  generationStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectiveIds?: Maybe<Array<Maybe<Objective>>>;
  orgId?: Maybe<Org>;
  ownerIds?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  parentOkrId?: Maybe<Okr>;
  status?: Maybe<Scalars['String']['output']>;
  strategyInputIds?: Maybe<Array<Maybe<StrategyInput>>>;
  strategyQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  themes?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** A planning and review period for OKRs — lean period definition; generation wizard state lives on each OKR */
export type OkrCycle = BaseEntity & {
  __typename?: 'OKRCycle';
  cadence?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentCycleId?: Maybe<OkrCycle>;
  startDate?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a OKRCycleList query */
export type OkrCycleListResult = {
  __typename?: 'OKRCycleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OkrCycle>>>;
  /** Total number of OKRCycle records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OkrInput = {
  clarifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  generationStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  objectiveIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  parentOkrId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategyInputIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  strategyQuestions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a OKRList query */
export type OkrListResult = {
  __typename?: 'OKRListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Okr>>>;
  /** Total number of OKR records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A qualitative goal within an OKR tree — holds the specific goal wording, level, and org/position assignment */
export type Objective = BaseEntity & {
  __typename?: 'Objective';
  /** User assigned via ASSIGN_OBJECTIVE, including grant template/actions and person details — null when no user assignee grant exists */
  assignee?: Maybe<Scalars['JSON']['output']>;
  cascadeOrgIds?: Maybe<Array<Maybe<Org>>>;
  /** Count of direct child key results (keyResultIds.size()) */
  childKeyResultsCount?: Maybe<Scalars['Int']['output']>;
  childObjectiveIds?: Maybe<Array<Maybe<Objective>>>;
  /** Count of direct child objectives (childObjectiveIds.size()) */
  childObjectivesCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<OkrCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyResultIds?: Maybe<Array<Maybe<KeyResult>>>;
  /** Key results visible to the current user grouped by status — includes key results on descendant objectives */
  keyResultsGroupedByStatus?: Maybe<Scalars['JSON']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  level?: Maybe<Scalars['String']['output']>;
  okrId?: Maybe<Okr>;
  orgId?: Maybe<Org>;
  parentObjectiveId?: Maybe<Objective>;
  positionId?: Maybe<Position>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a ObjectiveList query */
export type ObjectiveListResult = {
  __typename?: 'ObjectiveListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Count of scoped objectives the context user cannot read — all matching objectives minus those visible to the current user. Populated by rootLevelObjectives (POSITIONED) and objectiveListForPosition; 0 on other objective list queries. */
  hiddenObjectiveCount?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<Objective>>>;
  /** Total number of Objective records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Which objective visibility fetch to scope rootLevelObjectives to */
export enum ObjectiveScope {
  All = 'ALL',
  My = 'MY',
  Positioned = 'POSITIONED',
  Team = 'TEAM'
}

/** Aggregate counts for an OKR tree */
export type OkrStats = {
  __typename?: 'OkrStats';
  /** Total COMPANY-level objectives in this OKR */
  companyObjectiveCount?: Maybe<Scalars['Int']['output']>;
  /** Total key results under objectives belonging to this OKR */
  keyResultCount?: Maybe<Scalars['Int']['output']>;
  /** OKR id these counts belong to */
  okrId: Scalars['ID']['output'];
  /** Total ORG-level objectives in this OKR */
  orgObjectiveCount?: Maybe<Scalars['Int']['output']>;
  /** Distinct non-null position ids from Objective.positionId and KeyResult.ownerPositionId in this OKR */
  uniquePositionCount?: Maybe<Scalars['Int']['output']>;
};

/** Supervisory org unit in the organizational hierarchy */
export type Org = BaseEntity & {
  __typename?: 'Org';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  depth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  hierarchy?: Maybe<OrgHierarchy>;
  iconColour?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managerPositionId?: Maybe<Position>;
  /** Deepest depth value among this org's ACTIVE descendants, or null when it has none. Computed on demand — only when the field is actually queried — and batched across the page via a DataLoader, so listing N orgs costs one extra query rather than N. */
  maxChildDepth?: Maybe<Scalars['Int']['output']>;
  orgType?: Maybe<Scalars['String']['output']>;
  parentOrgId?: Maybe<Org>;
  path?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Reviewable batch of atomic org-structure changes; each published change set is one org version */
export type OrgChangeSet = BaseEntity & {
  __typename?: 'OrgChangeSet';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  baseVersion?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  orgVersion?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Long']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  publishingAt?: Maybe<Scalars['Long']['output']>;
  publishingBy?: Maybe<Scalars['String']['output']>;
  revertsToVersion?: Maybe<Scalars['Int']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
};

/** One page of org change sets plus the match count */
export type OrgChangeSetListResult = {
  __typename?: 'OrgChangeSetListResult';
  /** Whether another page exists after this one */
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<OrgChangeSet>>>;
  /** How many change sets match, ignoring limit and offset */
  totalCount: Scalars['Int']['output'];
};

/** Named hierarchy of orgs — the supervisory hierarchy plus tenant-defined ones */
export type OrgHierarchy = BaseEntity & {
  __typename?: 'OrgHierarchy';
  SUPERVISORY?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  orgTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OrgHierarchyInput = {
  SUPERVISORY?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  orgTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OrgInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  hierarchy?: InputMaybe<Scalars['ID']['input']>;
  iconColour?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managerPositionId?: InputMaybe<Scalars['ID']['input']>;
  orgType?: InputMaybe<Scalars['String']['input']>;
  parentOrgId?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a OrgList query */
export type OrgListResult = {
  __typename?: 'OrgListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Org>>>;
  /** Total number of Org records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Organizational role entity representing a position within a department */
export type OrgRole = BaseEntity & {
  __typename?: 'OrgRole';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  departmentId?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMGSAenabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  roleType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OrgRoleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMGSAenabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a OrgRoleList query */
export type OrgRoleListResult = {
  __typename?: 'OrgRoleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OrgRole>>>;
  /** Total number of OrgRole records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-item verdict of a simulation, in apply order */
export type OrgSimulatedItem = {
  __typename?: 'OrgSimulatedItem';
  /** Why the item cannot apply — null when it projects cleanly */
  conflict?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  /** OrgChangeOp name */
  op: Scalars['String']['output'];
  /** Full document id of the entity the op acts on */
  targetId: Scalars['ID']['output'];
};

/** What the org would look like if the selected items were published right now */
export type OrgSimulationResult = {
  __typename?: 'OrgSimulationResult';
  /** True when every selected item projects without conflict */
  clean: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<OrgSimulatedItem>>>;
  /** Target document id → the fields (and values) that would change; overlay this diff on the currently rendered tree */
  projected?: Maybe<Scalars['JSON']['output']>;
};

/** Outcome entity for tracking sales results and achievements */
export type Outcome = BaseEntity & {
  __typename?: 'Outcome';
  activityId?: Maybe<Activity>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OutcomeInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a OutcomeList query */
export type OutcomeListResult = {
  __typename?: 'OutcomeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Outcome>>>;
  /** Total number of Outcome records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ParsedSheet = {
  __typename?: 'ParsedSheet';
  headers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rows?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The entity type this sheet imports, e.g. "Org", "Position". */
  sheetName: Scalars['String']['output'];
};

export type ParsedWorkbook = {
  __typename?: 'ParsedWorkbook';
  fileId: Scalars['ID']['output'];
  sheets?: Maybe<Array<Maybe<ParsedSheet>>>;
};

export type PeopleImportCommit = {
  __typename?: 'PeopleImportCommit';
  added: Scalars['Int']['output'];
  /** The draft after the add; null when not committed */
  changeSet?: Maybe<OrgChangeSet>;
  /** False when the file still has errors; nothing was added */
  committed: Scalars['Boolean']['output'];
  dropped: Scalars['Int']['output'];
  merged: Scalars['Int']['output'];
  validation: PeopleImportValidation;
};

export type PeopleImportIssue = {
  __typename?: 'PeopleImportIssue';
  /** Header the problem is under; null when it is the whole row's */
  column?: Maybe<Scalars['String']['output']>;
  /** Row this one repeats, e.g. R7 */
  duplicateOf?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /** The cell is empty but must not be */
  missing: Scalars['Boolean']['output'];
  /** Spreadsheet row, e.g. R3 — R1 is the header */
  row?: Maybe<Scalars['String']['output']>;
  /** The cell as written */
  value?: Maybe<Scalars['String']['output']>;
};

export type PeopleImportIssueGroup = {
  __typename?: 'PeopleImportIssueGroup';
  /** e.g. MISSING_VALUE, DUPLICATE_EMAIL, NOT_FOUND, CONFLICT */
  code: Scalars['String']['output'];
  issues: Array<PeopleImportIssue>;
  /** ERROR blocks the import; WARNING does not */
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PeopleImportRow = {
  __typename?: 'PeopleImportRow';
  action?: Maybe<Scalars['String']['output']>;
  /** What the row changes — for an Update, only fields that differ from today */
  changes: Scalars['JSON']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  /** Codes of this row's problems, errors and warnings, in report order */
  issues: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The existing person an Update, Deactivate or Reactivate acts on */
  personId?: Maybe<Scalars['ID']['output']>;
  row: Scalars['String']['output'];
  /** Valid, but nothing to do */
  skipped: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PeopleImportTemplate = {
  __typename?: 'PeopleImportTemplate';
  /** Header and sample rows as CSV text, ready to download */
  csv: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
  sampleRows: Array<Array<Scalars['String']['output']>>;
};

export type PeopleImportValidation = {
  __typename?: 'PeopleImportValidation';
  /** Valid rows per action, e.g. {"Invite": 12, "Update": 3} */
  actionCounts: Scalars['JSON']['output'];
  errorCount: Scalars['Int']['output'];
  issueGroups: Array<PeopleImportIssueGroup>;
  rowCount: Scalars['Int']['output'];
  rows: Array<PeopleImportRow>;
  /** No errors — the file can be committed */
  valid: Scalars['Boolean']['output'];
  warningCount: Scalars['Int']['output'];
};

/** The caller's performance Home page. A panel the caller may not see, or whose feature is off, is null — the page takes the shape of their role */
export type PerformanceHome = {
  __typename?: 'PerformanceHome';
  hr?: Maybe<PerformanceHomeHr>;
  levelHeld?: Maybe<CareerLevel>;
  me: Person;
  /** Your open performance tasks, due soonest first */
  needsYou: PerformanceHomeTasks;
  /** Your aspiration, else the ordinary next rung. Null when career is off, or with no move and no proposal */
  nextMove?: Maybe<PerformanceHomeNextMove>;
  /** The newest feedback shared with you; null without VIEW_FEEDBACK */
  sharedFeedback?: Maybe<Array<PersonFeedback>>;
  skills: PerformanceHomeSkills;
  /** Your direct reports; null without VIEW_TEAM_CAREER or when nobody reports to you */
  team?: Maybe<Array<PerformanceHomeTeamRow>>;
};


/** The caller's performance Home page. A panel the caller may not see, or whose feature is off, is null — the page takes the shape of their role */
export type PerformanceHomeNeedsYouArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The caller's performance Home page. A panel the caller may not see, or whose feature is off, is null — the page takes the shape of their role */
export type PerformanceHomeSharedFeedbackArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** The caller's performance Home page. A panel the caller may not see, or whose feature is off, is null — the page takes the shape of their role */
export type PerformanceHomeTeamArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceHomeAsk = {
  __typename?: 'PerformanceHomeAsk';
  assignee?: Maybe<Person>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  kind: Scalars['String']['output'];
};

export type PerformanceHomeCredential = {
  __typename?: 'PerformanceHomeCredential';
  /** Someone has the ask to verify it */
  askOpen: Scalars['Boolean']['output'];
  /** A manager may verify it; HR verifies the rest */
  manager: Scalars['Boolean']['output'];
  qualification: PersonQualification;
};

export type PerformanceHomeGate = {
  __typename?: 'PerformanceHomeGate';
  /** The open asks working on it */
  asks: Array<PerformanceHomeAsk>;
  /** Its place in the verdict's criteria snapshot */
  index: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** NOT_MET or UNKNOWN */
  outcome?: Maybe<Scalars['String']['output']>;
};

/** HR's figures; each is null without its key */
export type PerformanceHomeHr = {
  __typename?: 'PerformanceHomeHr';
  /** Pending feedback requests the daily pass will expire within 7 days. VIEW_ALL_FEEDBACK */
  asksExpiringThisWeek?: Maybe<Scalars['Long']['output']>;
  /** Proposed next moves nobody has decided. VIEW_ALL_CAREER */
  pendingProposals?: Maybe<Scalars['Long']['output']>;
  /** Open aspirations whose latest verdict met every gate. VIEW_ALL_CAREER */
  readyForPromotion?: Maybe<Scalars['Long']['output']>;
  /** The oldest unverified credentials. MANAGE_ORG_CHART */
  verificationQueue?: Maybe<Array<PersonQualification>>;
  verificationQueueTotal?: Maybe<Scalars['Long']['output']>;
};

/** The move the caller aims for, and who is working on each gate still open */
export type PerformanceHomeNextMove = {
  __typename?: 'PerformanceHomeNextMove';
  /** Your own aspiration; null when the move is the ordinary next rung or there is only a proposal */
  aspiration?: Maybe<CareerAspiration>;
  from?: Maybe<CareerLevel>;
  /** Every gate not met, in the ladder's order */
  gates: Array<PerformanceHomeGate>;
  gatesMet: Scalars['Int']['output'];
  gatesTotal: Scalars['Int']['output'];
  pendingProposal?: Maybe<AspirationProposal>;
  to?: Maybe<CareerLevel>;
  /** Null until the first assessment */
  verdict?: Maybe<CareerReadiness>;
};

export type PerformanceHomeSkill = {
  __typename?: 'PerformanceHomeSkill';
  /** The newest claim from anyone else */
  attested?: Maybe<PersonSkill>;
  attestedAgeDays?: Maybe<Scalars['Int']['output']>;
  /** Your own claim */
  self?: Maybe<PersonSkill>;
  skill: Skill;
  /** NOT_STATED, AWAITING_ATTESTATION, SELF_ONLY or ATTESTED */
  state: Scalars['String']['output'];
};

export type PerformanceHomeSkills = {
  __typename?: 'PerformanceHomeSkills';
  skills: Array<PerformanceHomeSkill>;
  unverified: Array<PerformanceHomeCredential>;
};

export type PerformanceHomeTask = {
  __typename?: 'PerformanceHomeTask';
  /** FEEDBACK, DECLARE, ATTEST, RE_ATTEST, VERIFY, NOMINATE or DECIDE */
  kind: Scalars['String']['output'];
  /** Who it is about; null when its record is gone */
  subject?: Maybe<Person>;
  task: UserTask;
};

export type PerformanceHomeTasks = {
  __typename?: 'PerformanceHomeTasks';
  items: Array<PerformanceHomeTask>;
  /** How many are open in all */
  total: Scalars['Int']['output'];
};

export type PerformanceHomeTeamRow = {
  __typename?: 'PerformanceHomeTeamRow';
  gatesMet?: Maybe<Scalars['Int']['output']>;
  gatesTotal?: Maybe<Scalars['Int']['output']>;
  member: TeamMember;
  /** BLOCKED_ON_YOU, DECIDE, NO_NEXT_MOVE, READY, ASKS_OPEN or IN_PROGRESS — the first that holds */
  status: Scalars['String']['output'];
};

/** One piece of evidence about a person, and the record behind it */
export type PerformanceLedgerEntry = {
  __typename?: 'PerformanceLedgerEntry';
  /** The person's own note on it */
  annotation?: Maybe<Scalars['String']['output']>;
  /** A few typed values behind the summary: a band, a score, an attainment */
  facts?: Maybe<Scalars['JSON']['output']>;
  /** FEEDBACK, CLAIM, CREDENTIAL, GOAL, CHECK_IN, METRIC, MGSA, INSIGHT, VERDICT or MOVEMENT */
  kind: Scalars['String']['output'];
  /** Only the person's direct manager, skip-level and HR see it */
  managerOnly: Scalars['Boolean']['output'];
  occurredAt: Scalars['Long']['output'];
  /** Full id of the record; what a review cites and a note is written against */
  ref: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
};

/** One person's performance review in one cycle */
export type PerformanceReview = BaseEntity & {
  __typename?: 'PerformanceReview';
  SEP?: Maybe<Scalars['String']['output']>;
  acknowledgedAt?: Maybe<Scalars['Long']['output']>;
  calibration?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<ReviewCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  levelId?: Maybe<CareerLevel>;
  manager?: Maybe<Scalars['JSON']['output']>;
  promotion?: Maybe<Scalars['JSON']['output']>;
  respondedAt?: Maybe<Scalars['Long']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  reviewerPersonId?: Maybe<Person>;
  sections?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  self?: Maybe<Scalars['JSON']['output']>;
  sharedAt?: Maybe<Scalars['Long']['output']>;
  sharedByPersonId?: Maybe<Person>;
  signOffNote?: Maybe<Scalars['String']['output']>;
  signOffPersonId?: Maybe<Person>;
  signedOffAt?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectPersonId?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** What the drafter wrote for one question; every sentence cites evidence */
export type PerformanceReviewDraft = {
  __typename?: 'PerformanceReviewDraft';
  /** Full ids of the ledger entries it cites */
  citations: Array<Scalars['ID']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  questionKey: Scalars['String']['output'];
  sectionKey: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** An answer about a shared review, every sentence cited; with no model, no sentences and the evidence the review cites */
export type PerformanceReviewExplanation = {
  __typename?: 'PerformanceReviewExplanation';
  citations: Array<Scalars['ID']['output']>;
  sentences: Array<PerformanceReviewExplanationSentence>;
};

export type PerformanceReviewExplanationSentence = {
  __typename?: 'PerformanceReviewExplanationSentence';
  citations: Array<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
};

export type PerformanceReviewInput = {
  SEP?: InputMaybe<Scalars['String']['input']>;
  acknowledgedAt?: InputMaybe<Scalars['Long']['input']>;
  calibration?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  levelId?: InputMaybe<Scalars['ID']['input']>;
  manager?: InputMaybe<Scalars['JSON']['input']>;
  promotion?: InputMaybe<Scalars['JSON']['input']>;
  respondedAt?: InputMaybe<Scalars['Long']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  reviewerPersonId?: InputMaybe<Scalars['ID']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  self?: InputMaybe<Scalars['JSON']['input']>;
  sharedAt?: InputMaybe<Scalars['Long']['input']>;
  sharedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  signOffNote?: InputMaybe<Scalars['String']['input']>;
  signOffPersonId?: InputMaybe<Scalars['ID']['input']>;
  signedOffAt?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectPersonId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a PerformanceReviewList query */
export type PerformanceReviewListResult = {
  __typename?: 'PerformanceReviewListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PerformanceReview>>>;
  /** Total number of PerformanceReview records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Permission_Template = BaseEntity & {
  __typename?: 'Permission_Template';
  childrenRules?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  resourceType?: Maybe<Scalars['String']['output']>;
  selfRules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Person entity representing a measured subject */
export type Person = BaseEntity & {
  __typename?: 'Person';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dateOfBirth?: Maybe<Scalars['Long']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  departmentId?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dottedLineManagerId?: Maybe<Person>;
  emailAliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  exitDate?: Maybe<Scalars['Long']['output']>;
  federationId?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hierarchyPath?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationId?: Maybe<Location>;
  managerPersonId?: Maybe<Person>;
  orgPath?: Maybe<Scalars['String']['output']>;
  orgRoleId?: Maybe<OrgRole>;
  permanentAddress?: Maybe<Address>;
  personCode?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  primaryPositionId?: Maybe<Position>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  /** Stable unique identifier for the person: federationId when present, otherwise primaryEmail. */
  uniqueId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workMode?: Maybe<Scalars['String']['output']>;
};

/** One observation about a person from someone who worked with them: text and skill bands */
export type PersonFeedback = BaseEntity & {
  __typename?: 'PersonFeedback';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  givenAt?: Maybe<Scalars['Long']['output']>;
  giverPersonId?: Maybe<Person>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  relationship?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<FeedbackRequest>;
  retractedAt?: Maybe<Scalars['Long']['output']>;
  skillRatings?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  sourceRef?: Maybe<BaseEntity>;
  subjectPersonId?: Maybe<Person>;
  suggestedSkillIds?: Maybe<Array<Maybe<Skill>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type PersonFeedbackInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  givenAt?: InputMaybe<Scalars['Long']['input']>;
  giverPersonId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  retractedAt?: InputMaybe<Scalars['Long']['input']>;
  skillRatings?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceRef?: InputMaybe<Scalars['ID']['input']>;
  subjectPersonId?: InputMaybe<Scalars['ID']['input']>;
  suggestedSkillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a PersonFeedbackList query */
export type PersonFeedbackListResult = {
  __typename?: 'PersonFeedbackListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PersonFeedback>>>;
  /** Total number of PersonFeedback records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PersonInput = {
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Long']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  emailAliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  exitDate?: InputMaybe<Scalars['Long']['input']>;
  federationId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hierarchyPath?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  managerPersonId?: InputMaybe<Scalars['ID']['input']>;
  orgPath?: InputMaybe<Scalars['String']['input']>;
  orgRoleId?: InputMaybe<Scalars['ID']['input']>;
  permanentAddress?: InputMaybe<AddressInput>;
  personCode?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  primaryPositionId?: InputMaybe<Scalars['ID']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  workMode?: InputMaybe<Scalars['String']['input']>;
};

/** A knowledge entry about a person — feeds the Lyearn profile card and the MGSA cold start */
export type PersonKnowledge = BaseEntity & {
  __typename?: 'PersonKnowledge';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mgsaDimension?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PersonKnowledgeInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  mgsaDimension?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceDate?: InputMaybe<Scalars['Long']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a PersonKnowledgeList query */
export type PersonKnowledgeListResult = {
  __typename?: 'PersonKnowledgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PersonKnowledge>>>;
  /** Total number of PersonKnowledge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a PersonList query */
export type PersonListResult = {
  __typename?: 'PersonListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Person>>>;
  /** Total number of Person records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A person's curated profile: headline, featured skills, and their current career aspiration */
export type PersonProfile = BaseEntity & {
  __typename?: 'PersonProfile';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currentAddress?: Maybe<Address>;
  currentAspirationId?: Maybe<CareerAspiration>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  discoveredAt?: Maybe<Scalars['Long']['output']>;
  discoveredFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discoveredItems?: Maybe<Scalars['Int']['output']>;
  discoveredName?: Maybe<Scalars['String']['output']>;
  discoveredPhotoFileId?: Maybe<Scalars['String']['output']>;
  /** discoveredPhotoFileId as a link that works for a few minutes, to show and copy the photo; null when there is none */
  discoveredPhotoUrl?: Maybe<Scalars['String']['output']>;
  discoverySources?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  featuredSkillIds?: Maybe<Array<Maybe<Skill>>>;
  githubUrl?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  skypeUrl?: Maybe<Scalars['String']['output']>;
  slackUrl?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PersonProfileInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  currentAddress?: InputMaybe<AddressInput>;
  currentAspirationId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discoveredAt?: InputMaybe<Scalars['Long']['input']>;
  discoveredFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discoveredItems?: InputMaybe<Scalars['Int']['input']>;
  discoveredName?: InputMaybe<Scalars['String']['input']>;
  discoveredPhotoFileId?: InputMaybe<Scalars['String']['input']>;
  discoverySources?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  featuredSkillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  githubUrl?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  skypeUrl?: InputMaybe<Scalars['String']['input']>;
  slackUrl?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** A credential a person holds, with its validity window and provenance */
export type PersonQualification = BaseEntity & {
  __typename?: 'PersonQualification';
  attributes?: Maybe<Scalars['JSON']['output']>;
  companyDomain?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  credentialId?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  datePrecision?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  discovered?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentRef?: Maybe<StoredFile>;
  employmentType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  location?: Maybe<Scalars['String']['output']>;
  /** The organisation's logo the profile scan saved with the row, as a link that works for a few minutes; null when there is none */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  qualificationId?: Maybe<Qualification>;
  role?: Maybe<Scalars['String']['output']>;
  skillIds?: Maybe<Array<Maybe<Skill>>>;
  source?: Maybe<Scalars['String']['output']>;
  sourceUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Long']['output']>;
  validTo?: Maybe<Scalars['Long']['output']>;
  verifiedAt?: Maybe<Scalars['Long']['output']>;
  verifiedByPersonId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
};

/** A person's proficiency in a registry skill, as claimed by one source */
export type PersonSkill = BaseEntity & {
  __typename?: 'PersonSkill';
  SEP?: Maybe<Scalars['String']['output']>;
  assessedAt?: Maybe<Scalars['Long']['output']>;
  assessedByPersonId?: Maybe<Person>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  discovered?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidenceRefs?: Maybe<Array<Maybe<BaseEntity>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  proficiency?: Maybe<Scalars['String']['output']>;
  skillId?: Maybe<Skill>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PersonTagDefinition = {
  __typename?: 'PersonTagDefinition';
  id: Scalars['ID']['output'];
  /** SELECT, TEXT, NUMBER or USER */
  kind: Scalars['String']['output'];
  multiple: Scalars['Boolean']['output'];
  /** Also the import column: Tag.<name> */
  name: Scalars['String']['output'];
  options: Array<PersonTagOption>;
};

export type PersonTagOption = {
  __typename?: 'PersonTagOption';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

/** Instance of a JobProfile placed within the org hierarchy */
export type Position = BaseEntity & {
  __typename?: 'Position';
  availableFrom?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  critical?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationId?: Maybe<Location>;
  orgId?: Maybe<Org>;
  orgPath?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  positionStatus?: Maybe<Scalars['String']['output']>;
  reportsToPositionId?: Maybe<Position>;
  requisitionId?: Maybe<Requisition>;
  responsibilities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PositionInput = {
  availableFrom?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  orgPath?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  positionStatus?: InputMaybe<Scalars['String']['input']>;
  reportsToPositionId?: InputMaybe<Scalars['ID']['input']>;
  requisitionId?: InputMaybe<Scalars['ID']['input']>;
  responsibilities?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a PositionList query */
export type PositionListResult = {
  __typename?: 'PositionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Position>>>;
  /** Total number of Position records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Declarative definition of a productivity model (job profiles + ontology) */
export type ProductivityModelDefinition = BaseEntity & {
  __typename?: 'ProductivityModelDefinition';
  agents?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  analyses?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  jobFamilies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jobProfiles?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metrics?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  mgsa?: Maybe<Scalars['JSON']['output']>;
  modelVersion?: Maybe<Scalars['Int']['output']>;
  ontology?: Maybe<Scalars['JSON']['output']>;
  populations?: Maybe<Scalars['JSON']['output']>;
  processes?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Qualification catalog entry */
export type Qualification = BaseEntity & {
  __typename?: 'Qualification';
  aliasKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nameKey?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type QualificationInput = {
  aliasKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nameKey?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** One page of a qualification catalog search, best match first */
export type QualificationSearchResult = {
  __typename?: 'QualificationSearchResult';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Qualification>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  Activity?: Maybe<Activity>;
  ActivityList?: Maybe<Array<Maybe<Activity>>>;
  ActivityPaginatedList?: Maybe<ActivityListResult>;
  Agent_Action?: Maybe<Agent_Action>;
  Agent_ActionList?: Maybe<Array<Maybe<Agent_Action>>>;
  Agent_ActionPaginatedList?: Maybe<Agent_ActionListResult>;
  AnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  AnalyticsDashboardList?: Maybe<Array<Maybe<AnalyticsDashboard>>>;
  AnalyticsDashboardPaginatedList?: Maybe<AnalyticsDashboardListResult>;
  Artifact?: Maybe<Artifact>;
  ArtifactList?: Maybe<Array<Maybe<Artifact>>>;
  ArtifactPaginatedList?: Maybe<ArtifactListResult>;
  /** A candidate by id. Requires MANAGE_ORG_CHART. */
  Candidate?: Maybe<Candidate>;
  /** Candidates; filter on e.status. Requires MANAGE_ORG_CHART. */
  CandidateList?: Maybe<CandidateListResult>;
  /** A career framework; needs VIEW_CAREER_FRAMEWORK */
  CareerFramework?: Maybe<CareerFramework>;
  /** Career frameworks; filter on e.status. Needs VIEW_CAREER_FRAMEWORK, which sees only ACTIVE. MANAGE_CAREER_FRAMEWORK sees every status */
  CareerFrameworkList?: Maybe<CareerFrameworkListResult>;
  /** A career level; needs VIEW_CAREER_FRAMEWORK */
  CareerLevel?: Maybe<CareerLevel>;
  /** A readiness verdict. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  CareerReadiness?: Maybe<CareerReadiness>;
  ChatBucket?: Maybe<ChatBucket>;
  ChatBucketList?: Maybe<Array<Maybe<ChatBucket>>>;
  ChatBucketPaginatedList?: Maybe<ChatBucketListResult>;
  /** List comments visible to the current user (ACL-enforced) */
  CommentList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  Company?: Maybe<Company>;
  CompanyKnowledge?: Maybe<CompanyKnowledge>;
  CompanyKnowledgeList?: Maybe<Array<Maybe<CompanyKnowledge>>>;
  CompanyKnowledgePaginatedList?: Maybe<CompanyKnowledgeListResult>;
  CompanyList?: Maybe<Array<Maybe<Company>>>;
  CompanyPaginatedList?: Maybe<CompanyListResult>;
  /** List departments visible to the current user (ACL-enforced) */
  DepartmentList?: Maybe<Array<Maybe<Department>>>;
  /** A document the caller can read */
  Document?: Maybe<Document>;
  /** Acknowledgements the caller can see; filter on e.documentId / e.personId / e.status */
  DocumentAcknowledgementList?: Maybe<DocumentAcknowledgementListResult>;
  /** A folder the caller can read */
  DocumentFolder?: Maybe<DocumentFolder>;
  /** Folders the caller can see; filter on e.libraryId / e.parentFolderId */
  DocumentFolderList?: Maybe<DocumentFolderListResult>;
  /** A library the caller can read */
  DocumentLibrary?: Maybe<DocumentLibrary>;
  /** Libraries the caller can see */
  DocumentLibraryList?: Maybe<DocumentLibraryListResult>;
  /** A document link the caller can read */
  DocumentLink?: Maybe<DocumentLink>;
  /** Links the caller can see; filter on e.documentId / e.targetId */
  DocumentLinkList?: Maybe<DocumentLinkListResult>;
  /** Documents the caller can see; filter on e.libraryId / e.folderId */
  DocumentList?: Maybe<DocumentListResult>;
  /** Obligations the caller can see; filter on e.personId / e.status */
  DocumentObligationList?: Maybe<DocumentObligationListResult>;
  /** A required-document rule */
  DocumentRequirement?: Maybe<DocumentRequirement>;
  /** The catalog of required documents */
  DocumentRequirementList?: Maybe<DocumentRequirementListResult>;
  /** A document type */
  DocumentType?: Maybe<DocumentType>;
  /** The document type catalog */
  DocumentTypeList?: Maybe<DocumentTypeListResult>;
  /** A document version the caller can read */
  DocumentVersion?: Maybe<DocumentVersion>;
  /** Versions the caller can see; filter on e.documentId */
  DocumentVersionList?: Maybe<DocumentVersionListResult>;
  Edge?: Maybe<Edge>;
  EdgeList?: Maybe<Array<Maybe<Edge>>>;
  EdgePaginatedList?: Maybe<EdgeListResult>;
  /** Peek (and seed if missing) the next entity code for a sourceEntityType */
  EntityCodeLookupItem: EntityCodeLookupItem;
  /** The tenant's entity definitions sorted by apiName, optionally only the given ones */
  EntityDefinitionList: Array<EntityDefinition>;
  ExportJobHistory?: Maybe<ExportJobHistory>;
  ExportJobHistoryList?: Maybe<Array<Maybe<ExportJobHistory>>>;
  ExportJobHistoryPaginatedList?: Maybe<ExportJobHistoryListResult>;
  Goal?: Maybe<Goal>;
  GoalList?: Maybe<Array<Maybe<Goal>>>;
  GoalPaginatedList?: Maybe<GoalListResult>;
  IdentityLink?: Maybe<IdentityLink>;
  IdentityLinkList?: Maybe<Array<Maybe<IdentityLink>>>;
  IdentityLinkPaginatedList?: Maybe<IdentityLinkListResult>;
  Interaction?: Maybe<Interaction>;
  InteractionList?: Maybe<Array<Maybe<Interaction>>>;
  InteractionPaginatedList?: Maybe<InteractionListResult>;
  /** List job family groups visible to the current user (ACL-enforced) */
  JobFamilyGroupList?: Maybe<JobFamilyGroupListResult>;
  /** List job families visible to the current user (ACL-enforced) */
  JobFamilyList?: Maybe<JobFamilyListResult>;
  /** List job profiles visible to the current user (ACL-enforced) */
  JobProfileList?: Maybe<JobProfileListResult>;
  /** List key results visible to the current user (ACL-enforced) */
  KeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  KnowledgeNode?: Maybe<KnowledgeNode>;
  KnowledgeNodeList?: Maybe<Array<Maybe<KnowledgeNode>>>;
  KnowledgeNodePaginatedList?: Maybe<KnowledgeNodeListResult>;
  /** A legal hold; needs MANAGE_LEGAL_HOLDS */
  LegalHold?: Maybe<LegalHold>;
  /** Legal holds; filter on e.scopeId. Needs MANAGE_LEGAL_HOLDS */
  LegalHoldList?: Maybe<LegalHoldListResult>;
  Metric?: Maybe<Metric>;
  MetricList?: Maybe<Array<Maybe<Metric>>>;
  MetricPaginatedList?: Maybe<MetricListResult>;
  Mindset?: Maybe<Mindset>;
  MindsetList?: Maybe<Array<Maybe<Mindset>>>;
  MindsetPaginatedList?: Maybe<MindsetListResult>;
  Note?: Maybe<Note>;
  NoteList?: Maybe<Array<Maybe<Note>>>;
  NotePaginatedList?: Maybe<NoteListResult>;
  Notification?: Maybe<Notification>;
  NotificationList?: Maybe<Array<Maybe<Notification>>>;
  NotificationPaginatedList?: Maybe<NotificationListResult>;
  Notification_Delivery?: Maybe<Notification_Delivery>;
  Notification_DeliveryList?: Maybe<Array<Maybe<Notification_Delivery>>>;
  Notification_DeliveryPaginatedList?: Maybe<Notification_DeliveryListResult>;
  Notification_Outbox?: Maybe<Notification_Outbox>;
  Notification_OutboxList?: Maybe<Array<Maybe<Notification_Outbox>>>;
  Notification_OutboxPaginatedList?: Maybe<Notification_OutboxListResult>;
  Notification_Preference?: Maybe<Notification_Preference>;
  Notification_PreferenceList?: Maybe<Array<Maybe<Notification_Preference>>>;
  Notification_PreferencePaginatedList?: Maybe<Notification_PreferenceListResult>;
  Notification_Template?: Maybe<Notification_Template>;
  Notification_TemplateList?: Maybe<Array<Maybe<Notification_Template>>>;
  Notification_TemplatePaginatedList?: Maybe<Notification_TemplateListResult>;
  /** List OKR cycles visible to the current user (ACL-enforced) — paginated result with items, totalCount, and hasNextPage */
  OKRCycleList?: Maybe<OkrCycleListResult>;
  /** List Objective records for the current tenant — paginated result with items, totalCount, and hasNextPage */
  ObjectiveList?: Maybe<ObjectiveListResult>;
  /** List orgs matching the given filter criteria (parentOrgId, pathPrefix, status, depth, etc.) */
  OrgList?: Maybe<OrgListResult>;
  OrgRole?: Maybe<OrgRole>;
  OrgRoleList?: Maybe<Array<Maybe<OrgRole>>>;
  OrgRolePaginatedList?: Maybe<OrgRoleListResult>;
  Outcome?: Maybe<Outcome>;
  OutcomeList?: Maybe<Array<Maybe<Outcome>>>;
  OutcomePaginatedList?: Maybe<OutcomeListResult>;
  Person?: Maybe<Person>;
  PersonKnowledge?: Maybe<PersonKnowledge>;
  PersonKnowledgeList?: Maybe<Array<Maybe<PersonKnowledge>>>;
  PersonKnowledgePaginatedList?: Maybe<PersonKnowledgeListResult>;
  PersonList?: Maybe<Array<Maybe<Person>>>;
  PersonPaginatedList?: Maybe<PersonListResult>;
  /** List positions visible to the current user (ACL-enforced) */
  PositionList?: Maybe<PositionListResult>;
  /** A qualification from the shipped catalog or this organisation's own */
  Qualification?: Maybe<Qualification>;
  RawChat?: Maybe<RawChat>;
  RawChatList?: Maybe<Array<Maybe<RawChat>>>;
  RawChatPaginatedList?: Maybe<RawChatListResult>;
  Resource?: Maybe<Resource>;
  ResourceList?: Maybe<Array<Maybe<Resource>>>;
  ResourcePaginatedList?: Maybe<ResourceListResult>;
  Salary?: Maybe<Salary>;
  SalaryList?: Maybe<Array<Maybe<Salary>>>;
  SalaryPaginatedList?: Maybe<SalaryListResult>;
  /** A signature request whose document the caller can read */
  SignatureRequest?: Maybe<SignatureRequest>;
  /** Signature requests the caller can see; filter on e.documentId / e.status */
  SignatureRequestList?: Maybe<SignatureRequestListResult>;
  /** A skill from the shipped catalog or this organisation's own */
  Skill?: Maybe<Skill>;
  /** A skill group as this organisation sees it: a shipped group with its additions and exclusions applied, or one of its own */
  SkillGroup?: Maybe<SkillGroup>;
  /** A smart folder the caller can see */
  SmartFolder?: Maybe<SmartFolder>;
  /** Smart folders the caller can see; filter on e.libraryId, order by position */
  SmartFolderList?: Maybe<SmartFolderListResult>;
  Task?: Maybe<Task>;
  TaskList?: Maybe<Array<Maybe<Task>>>;
  TaskPaginatedList?: Maybe<TaskListResult>;
  TenantOntologyPack?: Maybe<TenantOntologyPack>;
  TenantOntologyPackList?: Maybe<Array<Maybe<TenantOntologyPack>>>;
  TenantOntologyPackPaginatedList?: Maybe<TenantOntologyPackListResult>;
  User?: Maybe<User>;
  UserDashboardPreference?: Maybe<UserDashboardPreference>;
  UserDashboardPreferenceList?: Maybe<Array<Maybe<UserDashboardPreference>>>;
  UserDashboardPreferencePaginatedList?: Maybe<UserDashboardPreferenceListResult>;
  UserList?: Maybe<Array<Maybe<User>>>;
  UserMetricScore?: Maybe<UserMetricScore>;
  UserMetricScoreList?: Maybe<Array<Maybe<UserMetricScore>>>;
  UserMetricScorePaginatedList?: Maybe<UserMetricScoreListResult>;
  UserPaginatedList?: Maybe<UserListResult>;
  /** List user tasks visible to the current user (ACL-enforced) */
  UserTaskList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  WorkActivity?: Maybe<WorkActivity>;
  WorkActivityList?: Maybe<Array<Maybe<WorkActivity>>>;
  WorkActivityPaginatedList?: Maybe<WorkActivityListResult>;
  WorkforceEvent?: Maybe<WorkforceEvent>;
  WorkforceEventList?: Maybe<Array<Maybe<WorkforceEvent>>>;
  WorkforceEventPaginatedList?: Maybe<WorkforceEventListResult>;
  /** The Actions queue, newest first: open org change sets, career paths an agent drafted, and open agent drafts (briefings) merged into one list, in the standard page envelope { items, totalCount, hasNextPage }. Drafts require USE_AGENT_DRAFT (own createdBy only); change sets still require MANAGE_ORG_CHART; career paths require MANAGE_CAREER_FRAMEWORK. Each card names the agent and the chat behind it when an agent produced it, and carries the artifact itself under changeSet, careerPath or draft — select all three and render the one that arrives. */
  agentActions?: Maybe<AgentActionListResult>;
  /** The agent-builder's palette: the tools, grounding providers and prompt fragments an authored agent may reference (each with a description to pick it by), plus the permissions a spec may require. CREATE_CUSTOM_AGENT required. */
  agentBuildingBlocks: Scalars['JSON']['output'];
  /** One chat session by id — transcript, status, readiness, and the result envelope once executed. The history view's fetch, and the poll target while an execution runs. */
  agentChat: Agent_Chat_Session;
  /** The agents a chat can be opened with — the picker's list. Each carries its execute-button label and the kind of artifact it produces. The list lives in memory, so the knobs are named rather than Predicate JSON: search matches code, displayName and description case-insensitively. Offset applies before limit. */
  agentChatCatalog?: Maybe<Array<Maybe<AgentChatAgent>>>;
  /** The models the composer's picker may offer, best general choice first, with one marked current. The same list for every agent and every chat, so fetch it once per session rather than per chat. Empty when this workspace is on a provider whose models are not offered — hide the picker rather than showing one that cannot be acted on. */
  agentChatModels?: Maybe<Array<Maybe<AgentChatModel>>>;
  /** One agent draft by id — the review screen's fetch. Requires USE_AGENT_DRAFT (own createdBy only), and a producing agent this user may use. Errors indistinguishably when the id is unknown or not visible. */
  agentDraft: Agent_Draft;
  /** Group and aggregate records for any entity type */
  aggregate?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Union of myKeyResultList and visibleToOrgKeyResultList — all key results the current user can see, deduplicated */
  allKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** Load a saved AnalyticsView by ID */
  analyticsView?: Maybe<Scalars['JSON']['output']>;
  /** List AnalyticsViews owned by or shared with the current user */
  analyticsViewListAll?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List AnalyticsViews owned by the current user */
  analyticsViewListOwned?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List AnalyticsViews shared with the current user but owned by someone else */
  analyticsViewListShared?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List saved AnalyticsViews for a report definition */
  analyticsViews?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Next moves proposed to the person, newest first. personId null for the caller */
  aspirationProposals: Array<AspirationProposal>;
  auditLogForEntity?: Maybe<Array<Maybe<Audit_Log>>>;
  /** Every rating adjustment made in a cycle's sessions, oldest first, with who decided, why and the evidence cited: the audit trail. Needs VIEW_ALL_REVIEW */
  calibrationAdjustments: Array<RatingAdjustment>;
  /** A few sentences on a person's shared evidence for the room, each citing it: {sentences: [{text, citations}], citations}. No rating, comparison or recommendation; empty with no model configured. For whoever may read the session */
  calibrationBrief?: Maybe<Scalars['JSON']['output']>;
  /** What a session looks at, every line a published rule; it proposes no rating. {distribution: {session, cycle, reference}, reviewers: [{reviewerPersonId, name, reviews, mean, spread, sessionMean}] for 3+ reviews, outliers: [{reviewId, name, kind RATING_VS_EVIDENCE|DRAFT_KEPT, message, dismissed, reason}], alike: same scored-as job profile and level, MGSA within 5, goals within 10, coverage 0.6+, ratings 2+ points apart, reciprocal: [{reviewId, name, endorsers, reciprocal}] within 90 days, rings: [[name]], cards: [{reviewId, name, level, ratings and originals, mgsa, coverage, goalProgress, flags, citations}], drift: ratings before and after by group, VIEW_ALL_REVIEW only}. For whoever may read the session */
  calibrationPacket?: Maybe<Scalars['JSON']['output']>;
  /** One calibration session, for whoever runs sessions, facilitates it or takes part in it */
  calibrationSession: CalibrationSession;
  /** The reviews in a calibration session, as submitted, for those who may read the session */
  calibrationSessionReviews: Array<PerformanceReview>;
  /** A cycle's calibration sessions, newest first: all of them for VIEW_ALL_REVIEW; otherwise those the caller facilitates or takes part in */
  calibrationSessions: Array<CalibrationSession>;
  /** The review's text and each move's reason, checked for reading as a different case once the person's name and gender are swapped: [{source REVIEW or an adjustment id, original, swapped}] for those that do. It judges wording, never the person; nothing is stored. For the session's facilitator, or VIEW_ALL_REVIEW */
  calibrationWordingCheck?: Maybe<Scalars['JSON']['output']>;
  /** The person's current aspiration; with none set, their next rung as an unsaved aspiration with null effectiveFrom; null when there is neither. personId null for the caller. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  careerAspiration?: Maybe<CareerAspiration>;
  /** Every aspiration the person has had, newest first. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  careerAspirationHistory: Array<CareerAspiration>;
  /** How much of a ladder this organisation can evaluate; needs MANAGE_CAREER_FRAMEWORK */
  careerCoverage: CareerCoverage;
  /** Where an AI-drafted framework's current step stands — poll this while a step runs; null for a framework not drafted with AI. Needs VIEW_CAREER_FRAMEWORK */
  careerFrameworkAI?: Maybe<CareerAiState>;
  /** For each framework id, its track count, level count and unique job-profile count, in the order given. Ids may be bare or full. Every id in the request is loaded in one batch. Needs VIEW_CAREER_FRAMEWORK */
  careerFrameworkCounts: Array<CareerFrameworkCounts>;
  /** How far the person is from a level: its entry criteria judged now, never stored. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  careerGap: CareerGap;
  /** A framework, whatever its status, with its tracks and levels, levels in rank order; needs VIEW_CAREER_FRAMEWORK */
  careerLadder?: Maybe<CareerLadder>;
  /** The person's verdicts, newest first; only those toward targetLevelId when given. The person themselves, VIEW_TEAM_CAREER for their reporting line, VIEW_ALL_CAREER for anyone */
  careerReadinessHistory?: Maybe<CareerReadinessListResult>;
  /** The runs an agent started from one conversation, oldest first — the run cards that belong in that transcript. Match them to the turns by runId on the message: a chat can have started several runs, and a card shows the result of exactly the run its turn names. The id to pass to sendAgentChatResultToActions or discardAgentChatResult is the run's own id, never the chat's. Read this on load; the live workflowRun event carries the same ids for runs started while connected. */
  chatWorkflowRuns?: Maybe<Array<Maybe<Agent_Chat_Session>>>;
  /** What to reconsider in a reason before moving a rating with it, since a recorded move is never edited: vague, personality, gendered, or naming someone else in the session. Never blocking. The session's facilitator or the review's reviewer */
  checkAdjustmentRationale: Array<Scalars['String']['output']>;
  /** List check-ins visible to the current user (ACL-enforced) */
  checkInList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The feedback coach's read of a draft about a colleague: what is vague, judges the person rather than the work, or is gendered; a rewrite; and the skills it speaks to. It suggests and saves nothing. Empty advice when no AI model is configured. Needs VIEW_FEEDBACK */
  coachFeedback: FeedbackCoachAdvice;
  /** The cockpit summary widgets + a paged, per-row-resolved rows for a collection dashboard. */
  collectionView?: Maybe<Scalars['JSON']['output']>;
  /** The available declarative connectors and the feeds they provide. */
  connectors?: Maybe<Array<Connector>>;
  /** Highest published org version number; 0 when nothing has been published. The version shown on top of the Org Structure page. */
  currentOrgVersion: Scalars['Int']['output'];
  /** Load a saved Dashboard by ID */
  dashboard?: Maybe<Scalars['JSON']['output']>;
  /** The profile CTA row — one entry per productivity model enabled for the tenant that declares a collection dashboard with an `entry` block. */
  dashboardEntries?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The pure DashboardSpec layout (cacheable) for one (model, kind, entityType), with any saved per-user preference shallow-merged in. Includes free-form uiConfig JSON when the spec declares it. */
  dashboardLayout?: Maybe<Scalars['JSON']['output']>;
  /** List dashboards for the current tenant, optionally filtered by type and paginated */
  dashboards?: Maybe<DashboardListResult>;
  /** Discarded admin drafts, newest activity first unless order is set — the Discarded tab. One list instead of fetching each discarded set by id. Same page and filter arguments as openOrgChangeSets. Standing AGENT/SYNC lanes are never discarded, so they do not appear here. */
  discardedOrgChangeSets: OrgChangeSetListResult;
  /** How the current round of acknowledgement of a document stands; needs UPDATE on it */
  documentAcknowledgementSummary: DocumentAcknowledgementSummary;
  /** People a document applies to who cannot read it — check before publishing; needs UPDATE on it */
  documentAudienceWithoutAccess: Array<Scalars['ID']['output']>;
  /** The documents a person owes and where each stands, as far as the caller can see */
  documentChecklist: Array<DocumentObligation>;
  /** Per requirement, how the people in an org and below it stand, counting the obligations the caller can see */
  documentComplianceSummary: Array<DocumentRequirementCompliance>;
  /** Libraries a document type about these subject types may be filed in: subject files libraries declaring all of them, or shared libraries when none is given */
  documentLibrariesFor: Array<DocumentLibrary>;
  /** The inputs a document type's template reads, in order — what generating a letter of the type asks for. Each is a field definition: apiName (the key in generateDocument's inputs), displayName, description, fieldType and, for a choice, picklistSpec.picklistOptions */
  documentTemplateInputs: Array<Scalars['JSON']['output']>;
  /** The tenant's own copies of the productivity model definitions it has enabled — the source of display metadata (displayName, description, unit, category) for the bare metric names and MGSA formula codes that scores are keyed by. */
  enabledProductivityModelDefinitions?: Maybe<Array<Maybe<ProductivityModelDefinition>>>;
  /** Productivity model names enabled for the current tenant (from tenant-scoped assignments).  */
  enabledProductivityModelNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Execute a report query and return paginated rows */
  executeReport?: Maybe<Scalars['JSON']['output']>;
  /** Ask about your shared review; the answer comes from its text and the evidence you can open, every sentence cited. Needs VIEW_REVIEW */
  explainReview: PerformanceReviewExplanation;
  /** Poll an export job for status and download URL */
  exportJob?: Maybe<Scalars['JSON']['output']>;
  /** List export jobs for the current tenant, optionally scoped to a report definition or a specific report/dashboard */
  exportJobs?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  exportStatus?: Maybe<EntityExportStatus>;
  /** Fields a tenant can extend. Configurable picklists are the first set. */
  extensibleFields: Array<ExtensibleField>;
  /** Feedback the caller gave, newest first. Needs VIEW_FEEDBACK */
  feedbackGiven?: Maybe<PersonFeedbackListResult>;
  /** Feedback requests, newest first. role: RECEIVED (addressed to the caller), SENT (the caller asked), ABOUT (about personId, for anyone who may read feedback about them). status filters to one of PENDING, ANSWERED, DECLINED, EXPIRED, CANCELLED. Needs VIEW_FEEDBACK */
  feedbackRequests?: Maybe<FeedbackRequestListResult>;
  /** Get download routing for a StoredFile. Returns a presigned URL for non-encrypted files (mode: DIRECT_URL) or SERVER_PROXY for encrypted files that must be streamed through the server. */
  fileDownloadInfo?: Maybe<FileDownloadInfo>;
  /** The signed-in person's standing draft. Its entityId is that person's entityId. Creates an empty draft when none exists. The document stays a draft. Edits go into this draft; saveChangeSetForUser publishes a copy and clears it. Requires MANAGE_ORG_CHART. */
  getChangeSetForUser: OrgChangeSet;
  importJobStatus?: Maybe<Scalars['JSON']['output']>;
  /** List initiatives visible to the current user (ACL-enforced) */
  initiativeList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Connected connections for a source type — the reuse picker's options. */
  integrationConnections?: Maybe<Array<IntegrationConnectionSummary>>;
  /** Bindings under a catalog target, in precedence order. */
  integrationsForTarget?: Maybe<Array<Integration>>;
  /** The people scored in one model by hand rather than through their own job profile: who, scored as which of the model's job profiles, in which region, and why. Removed overrides are not listed. Requires MANAGE_PRODUCTIVITY_MODEL. */
  jobProfileOverrides?: Maybe<Array<Maybe<JobProfileOverride>>>;
  /** Everyone the model scores as one of its job profiles: by their own job profile, or by an override (which carries its reason), with the region they are placed in, where it came from (LOCATION, OVERRIDE, NONE) and barRegionId — the region whose targets apply, null for the job profile's own. Computed from HR data and overrides. Errors when the job profile is not in the model. Requires MANAGE_PRODUCTIVITY_MODEL. */
  jobProfilePeople?: Maybe<Array<Maybe<ScoredPerson>>>;
  /** For each objective id, returns key results visible to the current user grouped by KeyResult status — includes key results on descendant objectives */
  keyResultsGroupedByObjectiveStatus?: Maybe<Scalars['JSON']['output']>;
  /** List functional permission grants. Requires MANAGE_PERMISSIONS. */
  listFunctionalPermissionGrants?: Maybe<Functional_Permission_GrantListResult>;
  /** Platform functional-permission catalog. Requires MANAGE_PERMISSIONS. */
  listFunctionalPermissions?: Maybe<Array<Maybe<FunctionalPermission>>>;
  listGlobalPermissions?: Maybe<Array<Maybe<Global_Permission>>>;
  /** Groups for a person (Resolve_Membership KV) or groups holding an app role. Requires MANAGE_PERMISSIONS. */
  listGroupMembership?: Maybe<Group_MembershipListResult>;
  /** List locations matching the given filter criteria */
  listLocation?: Maybe<LocationListResult>;
  listMyShares?: Maybe<Array<Maybe<Record_Permission>>>;
  listMyTypePermissions?: Maybe<Array<Maybe<Type_Permission>>>;
  listPermissionTemplates?: Maybe<Array<Maybe<Permission_Template>>>;
  /** Roles on a person (Resolve_Membership KV) or a user group (Group_Membership KV). Requires MANAGE_PERMISSIONS. */
  listRoleMembership?: Maybe<Group_MembershipListResult>;
  /** Roles for the permission page and the invite role picker, as { items, totalCount, hasNextPage }. filter is a predicate — a name search is { type: "BASIC_SEARCH", field: "displayName", value: "..." }. Requires MANAGE_ROLES. */
  listRoles?: Maybe<App_RoleListResult>;
  listShares?: Maybe<Array<Maybe<Record_Permission>>>;
  listTypePermissions?: Maybe<Array<Maybe<Type_Permission>>>;
  /** List user groups. Requires MANAGE_USER_GROUPS. */
  listUserGroups?: Maybe<UserGroupListResult>;
  /** Users in a user group, or users who hold an app role (Resolve_Membership). Requires MANAGE_PERMISSIONS. */
  listUserMembership?: Maybe<Resolve_MembershipListResult>;
  /** Every workspace in the tenant, with member and group counts. Requires MANAGE_WORKSPACES. */
  listWorkspaces?: Maybe<WorkspaceListResult>;
  /** Resolve available values for a UI lookup key */
  lookupValues?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Visible agent chat sessions for the caller — chats you own or that were shared with you (USE_AGENT_CHAT GATE; no tenant-wide list). Without agentCode it is the history page across all agents; with it, previous chats for one agent. filter/order/limit/offset match OrgList — Predicate JSON, e.g. order: "createdAt DESC". Default order is newest first. */
  myAgentChats?: Maybe<Array<Maybe<Agent_Chat_Session>>>;
  /** The current user's functional permissions, each flagged with whether it came from a stored grant or was added by FunctionalPermission.addImplied (e.g. MANAGE_ORG_CHART implies VIEW_ORG_CHART). Same effective key set as myFunctionalPermissions. */
  myFunctionalPermissionDetails: Array<MyFunctionalPermission>;
  myFunctionalPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Key results the current user owns, created, is assigned to via position, or holds through a parent objective */
  myKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** Objectives assigned to the current user's primary position, plus the parent objectives of key results assigned to that position (deduplicated) — paginated result with items, totalCount, and hasNextPage */
  myObjectiveList?: Maybe<ObjectiveListResult>;
  myPerson?: Maybe<Person>;
  /** The caller's own salary document ({tenant}::Salary::{userId}). */
  mySalary?: Maybe<Salary>;
  /** Everyone below the caller in the reporting line, by name: level held, aspiration and where it came from, latest verdict, any proposal waiting on them. Needs VIEW_TEAM_CAREER */
  myTeam: Array<TeamMember>;
  /** People in the model's job families it does not score, grouped by the job profile they hold — usually a job profile nobody added to the model. People overridden into another model are not listed. Requires MANAGE_PRODUCTIVITY_MODEL. */
  notScored?: Maybe<Array<Maybe<NotScoredGroup>>>;
  /** The object-360 widget-data tree for one entity — every section/widget binding resolved. */
  objectDashboard?: Maybe<Scalars['JSON']['output']>;
  /** All objectives the current user has read access to (ACL-enforced: owned, shared via readPrincipals, or blanket type permission) — paginated result with items, totalCount, and hasNextPage */
  objectiveListAll?: Maybe<ObjectiveListResult>;
  /** Objectives assigned to the given position, plus the parent objectives of key results assigned to that position (deduplicated) — restricted to what the current user has read access to. Empty when the current user has no READ standing on Objective, or when no person currently holds positionId — paginated result with items, totalCount, hasNextPage, and hiddenObjectiveCount (position-scoped objectives the context user cannot read) */
  objectiveListForPosition?: Maybe<ObjectiveListResult>;
  /** List OKR records for the current tenant — paginated result with items, totalCount, and hasNextPage */
  okrList?: Maybe<OkrListResult>;
  /** Aggregate counts per OKR: key results, company objectives, org objectives, and unique position ids */
  okrStats: Array<OkrStats>;
  /** Open draft change sets across lanes — the standing AGENT and SYNC lanes plus any admin drafts — as { items, totalCount, hasNextPage }. Newest activity first unless order is set. filter is ANDed with status DRAFT and cannot widen it; a name search is a BASIC_SEARCH predicate in that filter. Omit limit to return every match; limit 0 returns no rows and still reports totalCount. */
  openOrgChangeSets: OrgChangeSetListResult;
  /** One page of the documents a smart folder shows the caller, in its own order */
  openSmartFolder?: Maybe<DocumentListResult>;
  /** Operational entity types that can be populated from an external source. */
  operationalTargets?: Maybe<Array<SyncTarget>>;
  /** One change set by id, whatever its status — the review screen's fetch for a single draft (items travel inline) or a published version's detail. Errors when the id is unknown. */
  orgChangeSet: OrgChangeSet;
  /** The published change set that produced a given org version, or null. */
  orgChangeSetByVersion?: Maybe<OrgChangeSet>;
  /** The org as of a past version, as a field overlay on today's state: target document id → the fields whose value was different at that version, with their value back then. Same shape as a simulation's projected diff — overlay it on the currently rendered tree. Entities created after the version overlay as status ARCHIVE (hidden). Computed by replaying published change sets; nothing is stored per version. Empty when the version is current. */
  orgStateAtVersion: Scalars['JSON']['output'];
  /** Published change sets, newest orgVersion first unless order is set — the Published tab. Same page and filter arguments as openOrgChangeSets; status stays PUBLISHED. */
  orgVersionHistory: OrgChangeSetListResult;
  parseImport?: Maybe<Array<Maybe<ParsedWorkbook>>>;
  /** People the person might ask for feedback: those sharing their manager and those they exchanged feedback with this year — less their manager, skip-level and anyone who declined. personId null for the caller */
  peerSuggestions: Array<Person>;
  /** The people import CSV to fill in: Email ID, Action, Name, Employee ID, Department, Designation, Profile Picture URL, Manager Email ID, Roles, User Groups, and one Tag.<name> column per tag this workspace can import. Requires MANAGE_ORG_CHART. */
  peopleImportTemplate: PeopleImportTemplate;
  /** The caller's performance Home page: what needs them, their next move, what was shared with them, their skills, their team and HR's figures, as far as their role reaches */
  performanceHome: PerformanceHome;
  /** A person's evidence over a window, newest first: feedback, skill claims, credentials, goals and check-ins, metrics and MGSA scores, insights, readiness verdicts and movements, less any kind the tenant switched off. from and to are epoch ms; to defaults to now and from to a year before it, and a window is at most three years. The person and VIEW_TEAM_FEEDBACK holders see shared entries; their direct manager, skip-level and VIEW_ALL_FEEDBACK see manager-only feedback too. personId null for the caller. Needs VIEW_FEEDBACK */
  performanceLedger: Array<PerformanceLedgerEntry>;
  /** One review, as the caller may read it: the person reads their self-review always and the reviewer's part once shared; the reviewer reads all of it; the sign-off person and VIEW_TEAM_REVIEW holders above the person, once submitted; VIEW_ALL_REVIEW, always. Needs VIEW_REVIEW */
  performanceReview: PerformanceReview;
  /** Reviews, newest first. role: MINE (about the caller), WRITING (the caller reviews), SIGNING_OFF (the caller signs off), CYCLE (every review of cycleId; needs VIEW_ALL_REVIEW). cycleId narrows the others. Needs VIEW_REVIEW */
  performanceReviews?: Maybe<PerformanceReviewListResult>;
  /** Insights about a person's records rather than about them, newest first — one page of them. Filter by sourceEntityType to page through one of the groups personConcernsGrouped showed the top of. */
  personConcerns?: Maybe<Array<Maybe<Insight>>>;
  /** The newest few insights about each kind of thing a person is named on but which is not them — the insights written about their records, without opening each record. Ranked per sourceEntityType, so no one kind takes every slot; group these by sourceEntityType and label each group with that entity's display name rather than a hardcoded word. */
  personConcernsGrouped?: Maybe<Array<Maybe<Insight>>>;
  /** Feedback about a person, newest first. Their direct manager, skip-level and VIEW_ALL_FEEDBACK read every entry; the person and VIEW_TEAM_FEEDBACK holders above them read shared entries only. personId null for the caller. Needs VIEW_FEEDBACK */
  personFeedback?: Maybe<PersonFeedbackListResult>;
  /** Insights written about a person, newest first, with the ones they have dismissed left out — one page of them. Filter by insightType to read the rest of a group personInsightsGrouped showed the top of. */
  personInsights?: Maybe<Array<Maybe<Insight>>>;
  /** The newest few insights of every insightType written about a person, newest first, with the ones they have dismissed left out. Ranked per type, so a type written on every run cannot crowd the others out: display these grouped by insightType, then read one group in full with personInsights. */
  personInsightsGrouped?: Maybe<Array<Maybe<Insight>>>;
  /** A person's metric documents, newest first — every metric's trend, one entry per window. A window in which a metric was not computed simply has no key for it: absence is not zero. */
  personMetricHistory?: Maybe<Array<Maybe<MetricScore>>>;
  /** A person's most recent metric scores. One document holds every metric their model computed for that window, keyed by bare model-local name — so this is one read, not one per metric. Titles, units and categories for those names come from productivityModelDefinition(name: <the model field on this result>). */
  personMetrics?: Maybe<MetricScore>;
  /** A person's scored windows, newest first — the MGSA trend. Richer than the snapshot: these carry windowStart/windowEnd, per-dimension coverage and the component scores behind each formula. */
  personMgsaHistory?: Maybe<Array<Maybe<UserMgsaScores>>>;
  /** A person's latest MGSA snapshot — the page header. Null when they have never been scored. Carries no window and no coverage: to tell a low score from a dimension that went NA for want of components, read personMgsaHistory. */
  personMgsaScore?: Maybe<UserLatestMgsaScore>;
  /** The person's profile; empty (never null) when they have not written one. personId defaults to the caller. */
  personProfile?: Maybe<PersonProfile>;
  /** The person's qualifications, newest validFrom first. Filter by type: EMPLOYMENT is a position, ARTICLE TALK OPEN_SOURCE PORTFOLIO PRESS are public work, and the rest are credentials. */
  personQualifications?: Maybe<Array<Maybe<PersonQualification>>>;
  /** How many positions, credentials and pieces of work cite each skill: {skillId: {experiences, qualifications, contributions, total}}. EMPLOYMENT rows count as experiences, public-work types as contributions, every other type as qualifications. Uncited skills are absent. */
  personSkillEvidence?: Maybe<Scalars['JSON']['output']>;
  /** Every skill claim about the person, one per skill and source (SELF, HR, ...). */
  personSkills?: Maybe<Array<Maybe<PersonSkill>>>;
  /** The tags a person can be given — in invitePerson, updatePersonDetails and the import — with their options. A tags input is {id: [values]}; a SELECT value is an option id, a USER value a person's entity id. Requires MANAGE_ORG_CHART. */
  personTagDefinitions: Array<PersonTagDefinition>;
  /** Poll async cascade generation job status from Redis — returns a single JSON status object */
  pollCascade?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company knowledge trigger job status from Redis for the given task id — returns a JSON status object for the FE loading UI, or null when no job exists for that task id. At COMPLETED the entries are persisted; read them via CRUD filtered by the same taskId. */
  pollCompanyKnowledge?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company profile trigger job status from Redis — returns a single JSON status object, or null when no job exists for the tenant */
  pollCompanyProfile?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company source discovery job from Redis — returns a single JSON status object, or null when no job exists for the tenant. At status COMPLETED the object carries sources: [{ type, url, title }], best first, at most 8 entries. type is one of WEBSITE, LINKEDIN, CRUNCHBASE, WIKIPEDIA, NEWS, REGISTRY, OTHER — switch on it to pick the source icon; OTHER covers credible pages outside those families. Every url is an absolute, de-duplicated http(s) URL. */
  pollCompanySources?: Maybe<Scalars['JSON']['output']>;
  /** Poll async extraction result for a strategy input — null while in progress */
  pollExtraction?: Maybe<Scalars['JSON']['output']>;
  /** Poll async org assignment for an OKR — null while in progress */
  pollOrgAssignment?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll the async person knowledge trigger job status from Redis — returns a single JSON status object, or null when no job exists for the person */
  pollPersonKnowledge?: Maybe<Scalars['JSON']['output']>;
  /** The person's latest profile scan from Redis: {status, progress, error, startedAt, updatedAt}; null when none was queued in the last day */
  pollPersonProfile?: Maybe<Scalars['JSON']['output']>;
  /** Poll async publish job status from Redis — returns a single JSON status object */
  pollPublish?: Maybe<Scalars['JSON']['output']>;
  /** Poll async bootstrapping strategy questions for an OKR (Phase 2, no-document substitute) — null while in progress; empty list means no questions. Each question carries suggestedAnswers: 0-4 plain-text one-tap answer choices to render next to the free-text box */
  pollStrategyQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async clarifying questions for an OKR — null while in progress; empty list means no questions. Each question carries suggestedAnswers: 0-4 plain-text one-tap answer choices to render next to the free-text box */
  pollThemeQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async theme synthesis for an OKR — null while in progress */
  pollThemeSynthesis?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async top-objective generation for an OKR — null while in progress */
  pollTopObjectiveGeneration?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Who would gain and who would lose read access if the document moved; checked like the move itself */
  previewDocumentMove: DocumentMoveAccessDiff;
  /** One enabled productivity model definition by name, e.g. the value of UserLatestMgsaScore.model. Null when the tenant has not enabled that model. */
  productivityModelDefinition?: Maybe<ProductivityModelDefinition>;
  /** The universal MGSA-centric profile: overall + per-pillar MGSA, insight feed, direct-reports table. */
  productivityProfile?: Maybe<Scalars['JSON']['output']>;
  /** Every fact and signal of the tenant's enabled productivity models. */
  productivityTargets?: Maybe<Array<SyncTarget>>;
  /** Credentials people claimed or imported that nobody has verified, newest first — public work is left to managers. Needs MANAGE_ORG_CHART */
  qualificationVerificationQueue: Array<PersonQualification>;
  /** How calibration moved a review's ratings, oldest first: from, to, why and the evidence cited. The person reads their own once the review is shared, without who decided. Needs VIEW_REVIEW */
  ratingAdjustments: Array<RatingAdjustment>;
  /** Review outcomes by one attribute — LOCATION, ORG, LEVEL, EMPLOYMENT_TYPE, PERSON_TYPE, TENURE_BAND, or, with fairnessReporting on and its legal basis recorded, GENDER or AGE_BAND: per group, reviewed, ratings, favourableRate (top two points), promotionRate and impactRatio against the highest group; and before calibration: ratingsBefore, favourableRateBefore, calibrationDrift (after less before) and meanAdjustment. Groups under 5 are suppressed and never the reference. Needs VIEW_ALL_REVIEW */
  ratingOutcomeExport?: Maybe<Scalars['JSON']['output']>;
  /** Load an enriched ReportDefinitionDetail by ID */
  reportDefinition?: Maybe<Scalars['JSON']['output']>;
  /** List report definitions for the report selector, optionally sorted and paginated */
  reportDefinitions?: Maybe<ReportDefinitionListResult>;
  /** Resolve one named dataSources entry from the dashboard spec. Looks up datasourceName on the (model, kind, entityType) DashboardSpec. Optional fields replaces the Binding with a { fields: [...] } projection. Field/list Bindings return { items, totalCount, hasNextPage, page, pageSize }; aggregates and other kinds return { data, page, pageSize }. */
  resolveDataSource?: Maybe<Scalars['JSON']['output']>;
  /** Ad-hoc resolve of a dataSources map (same shape as *.dashboard.json). Collection aggregates use model/entityType/scope/filters; per-subject sources (fields/metrics/…) batch across the optional subjectIds list. Returns { data: { sourceName: resolvedValue }, subjectIds, page, pageSize, totalCount, hasNextPage }. */
  resolveDataSources?: Maybe<Scalars['JSON']['output']>;
  /** One review cycle. Needs MANAGE_REVIEW or VIEW_ALL_REVIEW */
  reviewCycle: ReviewCycle;
  /** How a cycle is going: {steps: {reviews, selfSubmitted, submitted, signedOff, awaitingCalibration, inCalibration, calibrated, confirmed, shared, acknowledged, notCompleted, cancelled}, reviewers: [{reviewerPersonId, name, open, overdue}], ratingsByOrg and ratingsByLevel: [{key, label, reviewed, ratings, adjustedUp, adjustedDown, suppressed}], aiAcceptance: [{reviewerPersonId, name, drafted, acceptedUnchanged, rate, suppressed}]}. Groups under 5 are suppressed. Needs MANAGE_REVIEW */
  reviewCycleReport?: Maybe<Scalars['JSON']['output']>;
  /** Review cycles, newest first; status filters to DRAFT, LAUNCHING, OPEN, SHARING, CLOSED or CANCELLED. Needs MANAGE_REVIEW or VIEW_ALL_REVIEW */
  reviewCycles?: Maybe<ReviewCycleListResult>;
  /** The person's ledger over the cycle's window, newest first: everything for the reviewer, sign-off, the line above and VIEW_ALL_REVIEW; shared entries only for the person. Needs VIEW_REVIEW */
  reviewEvidence: Array<PerformanceLedgerEntry>;
  /** One review template. Needs MANAGE_REVIEW */
  reviewTemplate: ReviewTemplate;
  /** The tenant's review templates, by name. Needs MANAGE_REVIEW */
  reviewTemplates: Array<ReviewTemplate>;
  /** Root-level objectives within the chosen scope — objectives whose parent is null or not itself in the scoped result set — paginated result with items, totalCount, hasNextPage, and hiddenObjectiveCount; filter and order apply to the underlying fetch, limit/offset are applied after root filtering; scope defaults to ALL; positionId is required when scope is POSITIONED */
  rootLevelObjectives?: Maybe<ObjectiveListResult>;
  /** The caller's own routines — the Routines tab. A routine is a workflow (workflowCode, inputs) run on a cron as its owner. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the job's fields (cronExpression, tz, …), order e.g. "displayName ASC". Default order is newest first. MANAGE_ROUTINE required. */
  routines?: Maybe<RoutineListResult>;
  /** Education, certifications and licences in the shipped catalog and this organisation's own, best match first; text matches the start of a name or alias; kind is EDUCATION, CERTIFICATION or LICENSE; ids narrows to those full qualification ids */
  searchQualifications: QualificationSearchResult;
  /** Skill groups in the shipped catalog and this organisation's own, best match first */
  searchSkillGroups: SkillGroupSearchResult;
  /** Skills in the shipped catalog and this organisation's own, best match first; text matches the start of a name; groupId narrows to that group; ids narrows to those full skill ids */
  searchSkills: SkillSearchResult;
  /** Every signing provider and the organisation's setup of it; needs MANAGE_CONFIG */
  signatureProviderSetups: Array<SignatureProviderSetup>;
  /** The signing providers this organisation has set up — what a signature request can go through */
  signatureProviders: Array<SignatureProvider>;
  /** Preview what the org would look like if the selected items were published right now, without changing anything. Returns per-item verdicts (including cross-item cycles only visible in combination) and the projected field diff the UI overlays on the tree it already rendered. Omit itemIds to simulate every ACCEPTED item. */
  simulateOrgChangeSet: OrgSimulationResult;
  /** Everything said about a person's skill: claims by source, feedback rating it, credentials citing it. The person, their direct manager, or MANAGE_ORG_CHART; personId null for the caller */
  skillAttestationView: SkillAttestationView;
  /** How many documents a smart folder shows the caller */
  smartFolderCount: Scalars['Int']['output'];
  /** Whom a smart folder is shared with by name; for its owner and the library's Managers */
  smartFolderShares: Array<Record_Permission>;
  /** The settings a cycle runs with when it names no template, and a new template starts from */
  standardReviewSettings?: Maybe<Scalars['JSON']['output']>;
  /** Fetch a StoredFile by its ID */
  storedFile?: Maybe<StoredFile>;
  /** List StoredFiles for the current tenant, optionally filtered by purpose */
  storedFiles?: Maybe<Array<Maybe<StoredFile>>>;
  /** A record's folders — a person's, a case's — one per subject files library it has documents in, of those the caller can see */
  subjectDocumentFolders: Array<DocumentFolder>;
  /** This workspace's authored agents, enabled or not — the management list behind the agent-builder UI. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the document's fields (enabled, code, …), order e.g. "displayName ASC". Default order is newest first. USE_CUSTOM_AGENT required (own agents only). */
  tenantAgents?: Maybe<Tenant_AgentListResult>;
  /** The caller's authored workflows — the management list behind the Workflow Builder; each is also a TENANT card of workflowLibrary. A row carries the file (content) and the category/description copied from the frontmatter. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the document's fields (category, code, …), order e.g. "displayName ASC". Default order is newest first. USE_CUSTOM_WORKFLOW required (own only). */
  tenantWorkflows?: Maybe<Tenant_WorkflowListResult>;
  /** A person's (by full Person id) workspaces and the one they land in at login. Self only. */
  userWorkspaces: UserWorkspaces;
  validateImport?: Maybe<ImportValidationResult>;
  /** Objectives visible to the current user via permission grants (OKR-level cascade, parent-objective cascade, or direct grants on the Objective) — paginated result with items, totalCount, and hasNextPage */
  visibleOrgObjectiveList?: Maybe<ObjectiveListResult>;
  /** Key results visible to the current user via permission grants (OKR/objective-level cascade or direct grants on the KeyResult) */
  visibleToOrgKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** The workflows the caller may run — the Workflows tab. Each card carries its category (group by it), the kind of artifact one run produces, its typed inputs (render the Run-now form from them; required ones without a default must be supplied) and the suggested cron. Platform workflows and the caller's own authored ones (source TENANT), already filtered to the caller's permissions; category narrows to one group. */
  workflowLibrary?: Maybe<Array<Maybe<AgentWorkflow>>>;
  /** Runs of one workflow visible to the caller, newest first — the history under a card in the Workflows tab. Each run is an Agent_Chat_Session marked with workflowCode/workflowInputs: status, error and result read like any execute; poll it while EXECUTING. dryRun=true marks an author's test of their own document from the Workflow Builder — badge it; it filed no Actions row. */
  workflowRuns?: Maybe<Array<Maybe<Agent_Chat_Session>>>;
};


export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgent_ActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgent_ActionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgent_ActionPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsDashboardListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsDashboardPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCandidateListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareerFrameworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareerFrameworkListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareerLevelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareerReadinessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatBucketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatBucketListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatBucketPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommentListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyKnowledgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyKnowledgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDepartmentListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentAcknowledgementListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentFolderListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentLibraryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentLinkListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentObligationListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentRequirementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentRequirementListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentTypeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentVersionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEdgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEdgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEdgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityCodeLookupItemArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  sourceEntityType: Scalars['String']['input'];
};


export type QueryEntityDefinitionListArgs = {
  apiNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryExportJobHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportJobHistoryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportJobHistoryPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentityLinkListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityLinkPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInteractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInteractionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInteractionPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobFamilyGroupListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobFamilyListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobProfileListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKnowledgeNodeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeNodePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLegalHoldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLegalHoldListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetricArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetricListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetricPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMindsetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMindsetListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMindsetPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_DeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_DeliveryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_DeliveryPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_OutboxArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_OutboxListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_OutboxPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_PreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_PreferenceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_PreferencePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_TemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_TemplateListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_TemplatePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOkrCycleListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrgRoleListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgRolePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutcomeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutcomeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutcomePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonKnowledgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonKnowledgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPositionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRawChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRawChatListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRawChatPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourcePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalaryArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySalaryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalaryPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySignatureRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySignatureRequestListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmartFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmartFolderListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantOntologyPackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantOntologyPackListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantOntologyPackPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDashboardPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDashboardPreferenceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserDashboardPreferencePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserMetricScoreArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserMetricScoreListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserMetricScorePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTaskListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkActivityListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkActivityPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkforceEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkforceEventListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkforceEventPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentActionsArgs = {
  category?: InputMaybe<AgentActionCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryAgentChatCatalogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type QueryAggregateArgs = {
  aggregations?: InputMaybe<Array<AggregationInput>>;
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  having?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsViewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsViewsArgs = {
  reportDefinitionId: Scalars['ID']['input'];
};


export type QueryAspirationProposalsArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAuditLogForEntityArgs = {
  entityType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['String']['input'];
};


export type QueryCalibrationAdjustmentsArgs = {
  cycleId: Scalars['ID']['input'];
};


export type QueryCalibrationBriefArgs = {
  reviewId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type QueryCalibrationPacketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalibrationSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalibrationSessionReviewsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalibrationSessionsArgs = {
  cycleId: Scalars['ID']['input'];
};


export type QueryCalibrationWordingCheckArgs = {
  reviewId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};


export type QueryCareerAspirationArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCareerAspirationHistoryArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCareerCoverageArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type QueryCareerFrameworkAiArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type QueryCareerFrameworkCountsArgs = {
  frameworkIds: Array<Scalars['ID']['input']>;
};


export type QueryCareerGapArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId: Scalars['ID']['input'];
};


export type QueryCareerLadderArgs = {
  frameworkId: Scalars['ID']['input'];
};


export type QueryCareerReadinessHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  targetLevelId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatWorkflowRunsArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryCheckAdjustmentRationaleArgs = {
  rationale: Scalars['String']['input'];
  reviewId: Scalars['ID']['input'];
};


export type QueryCheckInListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCoachFeedbackArgs = {
  skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type QueryCollectionViewArgs = {
  entityType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDashboardEntriesArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDashboardLayoutArgs = {
  entityType: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


export type QueryDashboardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DashboardType>;
};


export type QueryDiscardedOrgChangeSetsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentAcknowledgementSummaryArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryDocumentAudienceWithoutAccessArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryDocumentChecklistArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryDocumentComplianceSummaryArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryDocumentLibrariesForArgs = {
  subjectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDocumentTemplateInputsArgs = {
  documentTypeId: Scalars['ID']['input'];
};


export type QueryExecuteReportArgs = {
  input: Scalars['JSON']['input'];
};


export type QueryExplainReviewArgs = {
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
};


export type QueryExportJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportStatusArgs = {
  triggerId: Scalars['ID']['input'];
};


export type QueryFeedbackGivenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedbackRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  role: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileDownloadInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportJobStatusArgs = {
  triggerId: Scalars['ID']['input'];
};


export type QueryInitiativeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntegrationConnectionsArgs = {
  sourceType: Scalars['String']['input'];
};


export type QueryIntegrationsForTargetArgs = {
  kind: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};


export type QueryJobProfileOverridesArgs = {
  model: Scalars['String']['input'];
};


export type QueryJobProfilePeopleArgs = {
  jobProfileEntityId: Scalars['ID']['input'];
  mappedBy?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
};


export type QueryKeyResultsGroupedByObjectiveStatusArgs = {
  objectiveIds: Array<Scalars['ID']['input']>;
};


export type QueryListFunctionalPermissionGrantsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListGroupMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLocationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMySharesArgs = {
  recordIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMyTypePermissionsArgs = {
  resourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryListPermissionTemplatesArgs = {
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRoleMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRolesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSharesArgs = {
  entityType: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


export type QueryListTypePermissionsArgs = {
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserGroupsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkspacesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLookupValuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  lookup: Scalars['JSON']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skipBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAgentChatsArgs = {
  agentCode?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyTeamArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotScoredArgs = {
  model: Scalars['String']['input'];
};


export type QueryObjectDashboardArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  model: Scalars['String']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryObjectiveListAllArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObjectiveListForPositionArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  positionId: Scalars['ID']['input'];
};


export type QueryOkrListArgs = {
  excludeArchivedCycles?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOkrStatsArgs = {
  okrIds: Array<Scalars['ID']['input']>;
};


export type QueryOpenOrgChangeSetsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpenSmartFolderArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  smartFolderId: Scalars['ID']['input'];
};


export type QueryOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type QueryOrgChangeSetByVersionArgs = {
  version: Scalars['Int']['input'];
};


export type QueryOrgStateAtVersionArgs = {
  version: Scalars['Int']['input'];
};


export type QueryOrgVersionHistoryArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParseImportArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


export type QueryPeerSuggestionsArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPerformanceLedgerArgs = {
  from?: InputMaybe<Scalars['Long']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPerformanceReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPerformanceReviewsArgs = {
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role: Scalars['String']['input'];
};


export type QueryPersonConcernsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryPersonConcernsGroupedArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryPersonFeedbackArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonInsightsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryPersonInsightsGroupedArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryPersonMetricHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPersonMetricsArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPersonMgsaHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPersonMgsaScoreArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPersonProfileArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonQualificationsArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonSkillEvidenceArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPersonSkillsArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPollCascadeArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollCompanyKnowledgeArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryPollExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type QueryPollOrgAssignmentArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollPersonKnowledgeArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPollPersonProfileArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPollPublishArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollThemeQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollThemeSynthesisArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollTopObjectiveGenerationArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPreviewDocumentMoveArgs = {
  documentId: Scalars['ID']['input'];
  targetFolderId?: InputMaybe<Scalars['ID']['input']>;
  targetLibraryId: Scalars['ID']['input'];
};


export type QueryProductivityModelDefinitionArgs = {
  name: Scalars['String']['input'];
};


export type QueryProductivityProfileArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQualificationVerificationQueueArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRatingAdjustmentsArgs = {
  reviewId: Scalars['ID']['input'];
};


export type QueryRatingOutcomeExportArgs = {
  attribute: Scalars['String']['input'];
  cycleId: Scalars['ID']['input'];
};


export type QueryReportDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportDefinitionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveDataSourceArgs = {
  controls?: InputMaybe<Scalars['JSON']['input']>;
  datasourceName: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResolveDataSourcesArgs = {
  controls?: InputMaybe<Scalars['JSON']['input']>;
  dataSources: Scalars['JSON']['input'];
  entityType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewCycleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewCycleReportArgs = {
  cycleId: Scalars['ID']['input'];
};


export type QueryReviewCyclesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReviewEvidenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRootLevelObjectivesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<ObjectiveScope>;
};


export type QueryRoutinesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchQualificationsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSkillGroupsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSkillsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySimulateOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySkillAttestationViewArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  skillId: Scalars['ID']['input'];
};


export type QuerySmartFolderCountArgs = {
  smartFolderId: Scalars['ID']['input'];
};


export type QuerySmartFolderSharesArgs = {
  smartFolderId: Scalars['ID']['input'];
};


export type QueryStoredFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoredFilesArgs = {
  purposeEntityId?: InputMaybe<Scalars['ID']['input']>;
  purposeType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubjectDocumentFoldersArgs = {
  subjectId: Scalars['ID']['input'];
};


export type QueryTenantAgentsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantWorkflowsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserWorkspacesArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryValidateImportArgs = {
  sheets: Scalars['JSON']['input'];
};


export type QueryVisibleOrgObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisibleToOrgKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkflowLibraryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkflowRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workflowCode: Scalars['String']['input'];
};

/** A rating change made in calibration, with who decided it, why, and the evidence cited */
export type RatingAdjustment = BaseEntity & {
  __typename?: 'RatingAdjustment';
  OVERALL?: Maybe<Scalars['String']['output']>;
  citations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  decidedByPersonId?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fromRating?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  rationale?: Maybe<Scalars['String']['output']>;
  reviewId?: Maybe<PerformanceReview>;
  sessionId?: Maybe<CalibrationSession>;
  subjectPersonId?: Maybe<Person>;
  target?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  toRating?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type RatingAdjustmentInput = {
  OVERALL?: InputMaybe<Scalars['String']['input']>;
  citations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  decidedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromRating?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  reviewId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  subjectPersonId?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  toRating?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a RatingAdjustmentList query */
export type RatingAdjustmentListResult = {
  __typename?: 'RatingAdjustmentListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<RatingAdjustment>>>;
  /** Total number of RatingAdjustment records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Raw chat message archived from messaging platform */
export type RawChat = BaseEntity & {
  __typename?: 'RawChat';
  actorIdentity?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventSubType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  messageId?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type RawChatInput = {
  actorIdentity?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventSubType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a RawChatList query */
export type RawChatListResult = {
  __typename?: 'RawChatListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<RawChat>>>;
  /** Total number of RawChat records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Record_Permission = BaseEntity & {
  __typename?: 'Record_Permission';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  recordId?: Maybe<BaseEntity>;
  resourceType?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Permission_Template>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Record_PermissionInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDefinition = BaseEntity & {
  __typename?: 'ReportDefinition';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultFilter?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  name?: Maybe<Scalars['String']['output']>;
  participatingEntities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  primaryEntity?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a reportDefinitions query */
export type ReportDefinitionListResult = {
  __typename?: 'ReportDefinitionListResult';
  /** Whether more report definitions exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Report definitions on this page (id, name, description) */
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Total report definitions */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One hiring event opened against a JobProfile; headcount is derived from the Positions attached to it */
export type Requisition = BaseEntity & {
  __typename?: 'Requisition';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  hiringManagerPositionId?: Maybe<Position>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  targetStartDate?: Maybe<Scalars['Long']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workMode?: Maybe<Scalars['String']['output']>;
};

export type RequisitionInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  hiringManagerPositionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetStartDate?: InputMaybe<Scalars['Long']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  workMode?: InputMaybe<Scalars['String']['input']>;
};

export type Resolve_Membership = BaseEntity & {
  __typename?: 'Resolve_Membership';
  appRole?: Maybe<App_Role>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a Resolve_MembershipList query */
export type Resolve_MembershipListResult = {
  __typename?: 'Resolve_MembershipListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Resolve_Membership>>>;
  /** Total number of Resolve_Membership records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** LMS Resource entity representing a hierarchical reusable asset */
export type Resource = BaseEntity & {
  __typename?: 'Resource';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentContentId?: Maybe<Resource>;
  parentSurveyId?: Maybe<Resource>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ResourceInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  parentContentId?: InputMaybe<Scalars['ID']['input']>;
  parentSurveyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ResourceList query */
export type ResourceListResult = {
  __typename?: 'ResourceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Resource>>>;
  /** Total number of Resource records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One round of performance reviews: its audience, window, timeline and settings */
export type ReviewCycle = BaseEntity & {
  __typename?: 'ReviewCycle';
  calibrationDueAt?: Maybe<Scalars['Long']['output']>;
  closedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employmentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  hiredBefore?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  jobProfileIds?: Maybe<Array<Maybe<JobProfile>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  launchedAt?: Maybe<Scalars['Long']['output']>;
  launchedByPersonId?: Maybe<Person>;
  locationIds?: Maybe<Array<Maybe<Location>>>;
  managerDueAt?: Maybe<Scalars['Long']['output']>;
  orgIds?: Maybe<Array<Maybe<Org>>>;
  peerDueAt?: Maybe<Scalars['Long']['output']>;
  personTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  selfDueAt?: Maybe<Scalars['Long']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  shareAt?: Maybe<Scalars['Long']['output']>;
  signOffDueAt?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<ReviewTemplate>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
  windowStart?: Maybe<Scalars['Long']['output']>;
};

export type ReviewCycleInput = {
  calibrationDueAt?: InputMaybe<Scalars['Long']['input']>;
  closedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employmentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  hiredBefore?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  launchedAt?: InputMaybe<Scalars['Long']['input']>;
  launchedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  managerDueAt?: InputMaybe<Scalars['Long']['input']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  peerDueAt?: InputMaybe<Scalars['Long']['input']>;
  personTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selfDueAt?: InputMaybe<Scalars['Long']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  shareAt?: InputMaybe<Scalars['Long']['input']>;
  signOffDueAt?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  windowEnd?: InputMaybe<Scalars['Long']['input']>;
  windowStart?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ReviewCycleList query */
export type ReviewCycleListResult = {
  __typename?: 'ReviewCycleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ReviewCycle>>>;
  /** Total number of ReviewCycle records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** How a tenant runs performance reviews: scale, questions, self-review, peers and sign-off */
export type ReviewTemplate = BaseEntity & {
  __typename?: 'ReviewTemplate';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  settings?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ReviewTemplateInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a ReviewTemplateList query */
export type ReviewTemplateListResult = {
  __typename?: 'ReviewTemplateListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ReviewTemplate>>>;
  /** Total number of ReviewTemplate records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One routine — a workflow with saved inputs, run on a cron as its owner */
export type Routine = {
  __typename?: 'Routine';
  createdAt?: Maybe<Scalars['Long']['output']>;
  /** The person who first created this routine */
  createdBy?: Maybe<Person>;
  cron?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** The inputs the routine runs with, by name — what the Run-now form would have sent */
  inputs?: Maybe<Scalars['JSON']['output']>;
  /** The run record of the routine's latest firing — EXECUTED with its result, or FAILED with its reason — or null if it has not fired yet or the caller cannot see the owner's runs */
  lastRun?: Maybe<Agent_Chat_Session>;
  /** When the routine last fired, or null if it never has */
  lastRunAt?: Maybe<Scalars['Long']['output']>;
  /** When the routine fires next, or null if the scheduler has not yet planned it or it is DEAD */
  nextRunAt?: Maybe<Scalars['Long']['output']>;
  /** The person the routine runs as — the one who created it */
  owner?: Maybe<Person>;
  routineId: Scalars['ID']['output'];
  /** The scheduler's view of the routine: READY (waiting for its next tick), RUNNING, FAILED (the last firing's plumbing failed; it retries), DEAD (retries exhausted; save it again to revive it), or null before the scheduler has first seen it */
  status?: Maybe<Scalars['String']['output']>;
  tz?: Maybe<Scalars['String']['output']>;
  /** The workflow's card, or null if the code no longer resolves or the caller may not run it */
  workflow?: Maybe<AgentWorkflow>;
  /** The workflow this routine runs */
  workflowCode: Scalars['String']['output'];
};

/** Paginated result of a routines query */
export type RoutineListResult = {
  __typename?: 'RoutineListResult';
  /** Whether more routines exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Routine>>>;
  /** Total number of routines matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A person's compensation amount and currency */
export type Salary = BaseEntity & {
  __typename?: 'Salary';
  amount?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SalaryInput = {
  amount?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a SalaryList query */
export type SalaryListResult = {
  __typename?: 'SalaryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Salary>>>;
  /** Total number of Salary records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One person a productivity model scores as one of its job profiles */
export type ScoredPerson = {
  __typename?: 'ScoredPerson';
  /** The region whose targets apply; null for the job profile's own targets */
  barRegionId?: Maybe<Scalars['ID']['output']>;
  /** The job profile they are scored as; for an override, not the one held in HR */
  jobProfileId: Scalars['ID']['output'];
  /** The override that put them here; null when it is their own job profile */
  override?: Maybe<JobProfileOverride>;
  person: Person;
  /** The REGION they are placed in; null when the job profile has no regions */
  regionId?: Maybe<Scalars['ID']['output']>;
  /** LOCATION, OVERRIDE or NONE */
  regionSource: Scalars['String']['output'];
};

/** A signing provider: its name is what a signature request names */
export type SignatureProvider = {
  __typename?: 'SignatureProvider';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** A signing provider, what setting it up takes, and how far the organisation has */
export type SignatureProviderSetup = {
  __typename?: 'SignatureProviderSetup';
  /** Whether requests can go through it now */
  configured: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  fields: Array<SignatureSetupField>;
  name: Scalars['String']['output'];
  ownAccount: Scalars['Boolean']['output'];
  /** Which secrets are stored, by field name */
  secretsSet: Array<Scalars['String']['output']>;
  /** The organisation's own non-secret settings */
  values: Scalars['JSON']['output'];
  /** For callbacks set account-wide: the URL to register with the provider */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

/** A document version sent out for signature, and how it is going */
export type SignatureRequest = BaseEntity & {
  __typename?: 'SignatureRequest';
  certificateStoredFileId?: Maybe<StoredFile>;
  closedAt?: Maybe<Scalars['Long']['output']>;
  closedReason?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Document>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  envelopeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  message?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Long']['output']>;
  sentByPersonId?: Maybe<Person>;
  signedVersionId?: Maybe<DocumentVersion>;
  signers?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<DocumentVersion>;
};

/** Paginated result of a SignatureRequestList query */
export type SignatureRequestListResult = {
  __typename?: 'SignatureRequestListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SignatureRequest>>>;
  /** Total number of SignatureRequest records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A setting a signing provider's setup takes; a secret is never shown back */
export type SignatureSetupField = {
  __typename?: 'SignatureSetupField';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  secret: Scalars['Boolean']['output'];
};

/** Skill catalog entry */
export type Skill = BaseEntity & {
  __typename?: 'Skill';
  aliasKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  levelDefinitions?: Maybe<Scalars['JSON']['output']>;
  nameKey?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Everything said about one person's skill — what a manager weighs before attesting it */
export type SkillAttestationView = {
  __typename?: 'SkillAttestationView';
  /** {band: givers} — each giver's latest rating once, NOT_OBSERVED left out */
  bandSpread?: Maybe<Scalars['JSON']['output']>;
  /** Every live claim on the skill, one per source */
  claims: Array<PersonSkill>;
  /** Credentials and work that cite the skill */
  credentials: Array<PersonQualification>;
  /** Feedback from the last year rating the skill, newest first, as much as the reader may see */
  feedback: Array<PersonFeedback>;
  person: Person;
  skill: Skill;
};

/** Skill group catalog entry */
export type SkillGroup = BaseEntity & {
  __typename?: 'SkillGroup';
  DEFAULT_REQUIRED_COVERAGE?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  excludedSkillIds?: Maybe<Array<Maybe<Skill>>>;
  extendsGroupId?: Maybe<SkillGroup>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nameKey?: Maybe<Scalars['String']['output']>;
  requiredCoverage?: Maybe<Scalars['Float']['output']>;
  skillWeights?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SkillGroupInput = {
  DEFAULT_REQUIRED_COVERAGE?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  excludedSkillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  extendsGroupId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nameKey?: InputMaybe<Scalars['String']['input']>;
  requiredCoverage?: InputMaybe<Scalars['Float']['input']>;
  skillWeights?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** One page of a catalog search, best match first */
export type SkillGroupSearchResult = {
  __typename?: 'SkillGroupSearchResult';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SkillGroup>>>;
  /** Each item's match score, higher is better; parallel to items */
  scores?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SkillInput = {
  aliasKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  levelDefinitions?: InputMaybe<Scalars['JSON']['input']>;
  nameKey?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** One page of a catalog search, best match first */
export type SkillSearchResult = {
  __typename?: 'SkillSearchResult';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Skill>>>;
  /** Each item's match score, higher is better; parallel to items */
  scores?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A saved view of one document library; holds and grants nothing */
export type SmartFolder = BaseEntity & {
  __typename?: 'SmartFolder';
  classifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentTypeIds?: Maybe<Array<Maybe<DocumentType>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  expiringWithinDays?: Maybe<Scalars['Int']['output']>;
  folderIds?: Maybe<Array<Maybe<DocumentFolder>>>;
  id: Scalars['ID']['output'];
  kinds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  libraryId?: Maybe<DocumentLibrary>;
  position?: Maybe<Scalars['Int']['output']>;
  reviewDueWithinDays?: Maybe<Scalars['Int']['output']>;
  sharedWithLibrary?: Maybe<Scalars['Boolean']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedWithinDays?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  versionStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  viewer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Paginated result of a SmartFolderList query */
export type SmartFolderListResult = {
  __typename?: 'SmartFolderListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SmartFolder>>>;
  /** Total number of SmartFolder records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StoredFile = {
  __typename?: 'StoredFile';
  bucket?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectKey?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  purposeEntityId?: Maybe<Scalars['ID']['output']>;
  purposeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['Long']['output']>;
};

/** A strategy input attached to an OKR — document, pasted text, or previous-cycle OKR reference that feeds the AI generation pipeline */
export type StrategyInput = BaseEntity & {
  __typename?: 'StrategyInput';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  extractionResult?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  okrId?: Maybe<Okr>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SyncTarget = {
  __typename?: 'SyncTarget';
  displayName: Scalars['String']['output'];
  inputSchema?: Maybe<Array<TargetField>>;
  kind: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
};

export type TargetField = {
  __typename?: 'TargetField';
  description?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/** Task entity for tracking work items and action items */
export type Task = BaseEntity & {
  __typename?: 'Task';
  SUBJECT_PREDICATE?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Activity>;
  assigneePersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  relatedId?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<Scalars['String']['output']>;
  sourceTool?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  taskType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type TaskInput = {
  SUBJECT_PREDICATE?: InputMaybe<Scalars['String']['input']>;
  activityId?: InputMaybe<Scalars['ID']['input']>;
  assigneePersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  relatedId?: InputMaybe<Scalars['String']['input']>;
  relatedType?: InputMaybe<Scalars['String']['input']>;
  sourceTool?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a TaskList query */
export type TaskListResult = {
  __typename?: 'TaskListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Task>>>;
  /** Total number of Task records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One person below the caller in the reporting line */
export type TeamMember = {
  __typename?: 'TeamMember';
  aspiration?: Maybe<CareerAspiration>;
  /** The proposal their aspiration came from; null when they stated it themselves */
  aspirationSource?: Maybe<AspirationProposal>;
  latestVerdict?: Maybe<CareerReadiness>;
  levelHeld?: Maybe<CareerLevel>;
  openTasks: Scalars['Int']['output'];
  pendingProposal?: Maybe<AspirationProposal>;
  person: Person;
};

/** A tenant's enabled ontology pack (with optional inline YAML override) */
export type TenantOntologyPack = BaseEntity & {
  __typename?: 'TenantOntologyPack';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultPack?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  packName?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  yaml?: Maybe<Scalars['String']['output']>;
};

export type TenantOntologyPackInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  defaultPack?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  packName?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  yaml?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a TenantOntologyPackList query */
export type TenantOntologyPackListResult = {
  __typename?: 'TenantOntologyPackListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<TenantOntologyPack>>>;
  /** Total number of TenantOntologyPack records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One tenant-authored conversational agent — the JSON spec, stored and editable */
export type Tenant_Agent = BaseEntity & {
  __typename?: 'Tenant_Agent';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  spec?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a Tenant_AgentList query */
export type Tenant_AgentListResult = {
  __typename?: 'Tenant_AgentListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Tenant_Agent>>>;
  /** Total number of Tenant_Agent records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One tenant-authored workflow — the markdown file, stored, private to its author */
export type Tenant_Workflow = BaseEntity & {
  __typename?: 'Tenant_Workflow';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a Tenant_WorkflowList query */
export type Tenant_WorkflowListResult = {
  __typename?: 'Tenant_WorkflowListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Tenant_Workflow>>>;
  /** Total number of Tenant_Workflow records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Type_Permission = BaseEntity & {
  __typename?: 'Type_Permission';
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  resourceType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Type_PermissionInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  actor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type User = BaseEntity & {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Per-user dashboard layout/filter override */
export type UserDashboardPreference = BaseEntity & {
  __typename?: 'UserDashboardPreference';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  overrides?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
};

export type UserDashboardPreferenceInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a UserDashboardPreferenceList query */
export type UserDashboardPreferenceListResult = {
  __typename?: 'UserDashboardPreferenceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserDashboardPreference>>>;
  /** Total number of UserDashboardPreference records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserGroup = BaseEntity & {
  __typename?: 'UserGroup';
  WORKEFFY_ID_PREFIX?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  criteria?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  membershipType?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type UserGroupInput = {
  WORKEFFY_ID_PREFIX?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  membershipType?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  systemDefined?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a UserGroupList query */
export type UserGroupListResult = {
  __typename?: 'UserGroupListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserGroup>>>;
  /** Total number of UserGroup records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** What refreshing a user group changed: the users who joined and the users who left */
export type UserGroupRefresh = {
  __typename?: 'UserGroupRefresh';
  /** User ids added to the group */
  added: Array<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  /** User ids removed from the group */
  removed: Array<Scalars['String']['output']>;
};

export type UserInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a UserList query */
export type UserListResult = {
  __typename?: 'UserListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<User>>>;
  /** Total number of User records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-user metric value computed for a time window */
export type UserMetricScore = BaseEntity & {
  __typename?: 'UserMetricScore';
  computedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobRunId?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricId?: Maybe<Metric>;
  target?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  value?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
  windowStart?: Maybe<Scalars['Long']['output']>;
};

export type UserMetricScoreInput = {
  computedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobRunId?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  metricId?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  windowEnd?: InputMaybe<Scalars['Long']['input']>;
  windowStart?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a UserMetricScoreList query */
export type UserMetricScoreListResult = {
  __typename?: 'UserMetricScoreListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserMetricScore>>>;
  /** Total number of UserMetricScore records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A user's MGSA scores for one window */
export type UserMgsaScores = BaseEntity & {
  __typename?: 'UserMgsaScores';
  GOAL?: Maybe<Scalars['String']['output']>;
  MINDSET?: Maybe<Scalars['String']['output']>;
  OVERALL?: Maybe<Scalars['String']['output']>;
  SCORE_KEYS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SCORE_RECORD_TYPE?: Maybe<Scalars['String']['output']>;
  SEP?: Maybe<Scalars['String']['output']>;
  SKILL?: Maybe<Scalars['String']['output']>;
  WORK_ACTIVITY?: Maybe<Scalars['String']['output']>;
  componentScores?: Maybe<Scalars['JSON']['output']>;
  computedAt?: Maybe<Scalars['Long']['output']>;
  coverage?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  goalAvgScore?: Maybe<Scalars['Float']['output']>;
  goalScores?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  jobRunId?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mindsetAvgScore?: Maybe<Scalars['Float']['output']>;
  mindsetScores?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  normalizedMetrics?: Maybe<Scalars['JSON']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  regionId?: Maybe<Location>;
  skillAvgScore?: Maybe<Scalars['Float']['output']>;
  skillScores?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
  windowStart?: Maybe<Scalars['Long']['output']>;
  workActivityAvgScore?: Maybe<Scalars['Float']['output']>;
  workActivityScores?: Maybe<Scalars['JSON']['output']>;
};

/** A lightweight actionable item attached to any entity — used alongside OKR initiatives for day-to-day execution tracking */
export type UserTask = BaseEntity & {
  __typename?: 'UserTask';
  assigneePersonId?: Maybe<Person>;
  completedAt?: Maybe<Scalars['Long']['output']>;
  completedByPersonId?: Maybe<Person>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  priority?: Maybe<Scalars['String']['output']>;
  sourceRef?: Maybe<BaseEntity>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** The workspace switcher's read: a person's workspaces and where they land at login */
export type UserWorkspaces = {
  __typename?: 'UserWorkspaces';
  /** entityId of the workspace they last switched to while still among workspaces, else of the first; null when they have none */
  lastWorkspaceId?: Maybe<Scalars['ID']['output']>;
  /** Active workspaces the person is a member of — the Main workspace when they have no explicit membership */
  workspaces: Array<Workspace>;
};

/** Global work activity registry entry */
export type WorkActivity = BaseEntity & {
  __typename?: 'WorkActivity';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type WorkActivityInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a WorkActivityList query */
export type WorkActivityListResult = {
  __typename?: 'WorkActivityListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<WorkActivity>>>;
  /** Total number of WorkActivity records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One dimension of a person's employment state, from an effective date until superseded */
export type WorkforceEvent = BaseEntity & {
  __typename?: 'WorkforceEvent';
  SEP?: Maybe<Scalars['String']['output']>;
  approvedByPersonId?: Maybe<Person>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  dimension?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['Long']['output']>;
  effectiveTo?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  gradeRankDelta?: Maybe<Scalars['Int']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedByPersonId?: Maybe<Person>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  readinessRef?: Maybe<CareerReadiness>;
  reason?: Maybe<Scalars['String']['output']>;
  reviewRef?: Maybe<PerformanceReview>;
  source?: Maybe<Scalars['String']['output']>;
  sourceChangeSetId?: Maybe<OrgChangeSet>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valueCode?: Maybe<Scalars['String']['output']>;
  valueRef?: Maybe<BaseEntity>;
  verifiedAt?: Maybe<Scalars['Long']['output']>;
  verifiedByPersonId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
};

export type WorkforceEventInput = {
  SEP?: InputMaybe<Scalars['String']['input']>;
  approvedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimension?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['Long']['input']>;
  effectiveTo?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  gradeRankDelta?: InputMaybe<Scalars['Int']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initiatedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  readinessRef?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewRef?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceChangeSetId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  valueCode?: InputMaybe<Scalars['String']['input']>;
  valueRef?: InputMaybe<Scalars['ID']['input']>;
  verifiedAt?: InputMaybe<Scalars['Long']['input']>;
  verifiedByPersonId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a WorkforceEventList query */
export type WorkforceEventListResult = {
  __typename?: 'WorkforceEventListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<WorkforceEvent>>>;
  /** Total number of WorkforceEvent records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Workspace = BaseEntity & {
  __typename?: 'Workspace';
  MAIN_DISPLAY_NAME?: Maybe<Scalars['String']['output']>;
  MAIN_ENTITY_ID?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** User groups that live in this workspace. */
  groupCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  /** People who are members of this workspace. */
  memberCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of a WorkspaceList query */
export type WorkspaceListResult = {
  __typename?: 'WorkspaceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Workspace>>>;
  /** Total number of Workspace records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-user latest MGSA score snapshot */
export type UserLatestMgsaScore = BaseEntity & {
  __typename?: 'userLatestMgsaScore';
  componentScores?: Maybe<Scalars['JSON']['output']>;
  computedAt?: Maybe<Scalars['Long']['output']>;
  coverage?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  goalAvgScore?: Maybe<Scalars['Float']['output']>;
  goalScores?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricScores?: Maybe<Scalars['JSON']['output']>;
  mindsetAvgScore?: Maybe<Scalars['Float']['output']>;
  mindsetScores?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  regionId?: Maybe<Location>;
  skillAvgScore?: Maybe<Scalars['Float']['output']>;
  skillScores?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['String']['output']>;
  workActivityAvgScore?: Maybe<Scalars['Float']['output']>;
  workActivityScores?: Maybe<Scalars['JSON']['output']>;
};
